var xr = Object.defineProperty;
var Sr = (e, t, r) => t in e ? xr(e, t, { enumerable: !0, configurable: !0, writable: !0, value: r }) : e[t] = r;
var Q = (e, t, r) => Sr(e, typeof t != "symbol" ? t + "" : t, r);
import { jsx as n, jsxs as m, Fragment as we } from "react/jsx-runtime";
import vr, { createContext as te, useContext as ne, forwardRef as Ce, useState as E, useEffect as S, useCallback as z, useRef as D, useMemo as j, Fragment as Lt, cloneElement as mn } from "react";
import { useTheme as X, SvgIcon as Tr, CircularProgress as Mt, Stack as b, Button as le, Box as N, DialogContent as at, DialogTitle as He, IconButton as ie, debounce as Or, TextField as $e, Typography as A, ListItem as st, ListItemButton as lt, Chip as Ir, List as Ze, SwipeableDrawer as fn, Divider as ge, Menu as Rr, MenuItem as Ne, Link as Ye, Snackbar as br, Alert as nt, Avatar as rn, Grid as It, FormHelperText as Nr, FormControl as yr, InputLabel as gn, Select as Ar, InputAdornment as wr, Collapse as Pr, Tabs as Lr, Tab as Mr, ListItemIcon as Ur, ListItemText as Dr, Tooltip as Ut, Skeleton as Rt, Modal as Fr } from "@mui/material";
import _r from "pino";
import Cn, { AxiosError as kr } from "axios";
import zr from "ua-parser-js";
import { UnfoldMore as Vr, Close as En, Menu as Br, QuestionMark as Gr, Person as xn, ArrowDropDown as Wr, AccessTime as Hr, RoomPreferences as $r, DisplaySettings as Zr } from "@mui/icons-material";
import { initReactI18next as Yr, useTranslation as Sn, Trans as qr } from "react-i18next";
import jr from "i18next";
import ve, { useSWRConfig as Xr, SWRConfig as Kr } from "swr";
import { useTheme as Te, styled as Qr } from "@mui/material/styles";
import vn from "@mui/material/useMediaQuery";
import ct from "@mui/icons-material/Close";
import Tn from "@mui/material/Dialog";
import Dt from "@mui/material/Fade";
import dt from "@mui/material/Slide";
import Ft from "swr/immutable";
import Jr from "swr/infinite";
import ei from "swr/mutation";
import ut, { debounce as ti } from "lodash";
import ni from "@mui/icons-material/ArrowForward";
import { useOktaAuth as qe } from "@okta/okta-react";
import { addEmail as ri, updateProfile as ii, verifyEmailChallenge as oi, sendEmailChallenge as ai, saveTransactionMeta as si } from "@okta/okta-auth-js";
import be from "@mui/material/Skeleton";
import ze from "@mui/material/Button";
import li from "@mui/icons-material/AccountCircleOutlined";
import ci from "@mui/icons-material/PrivacyTipOutlined";
import di from "@mui/icons-material/Tune";
import ui from "@mui/icons-material/Phone";
import pi from "@mui/icons-material/Edit";
import "@mui/material/Drawer";
import hi from "@mui/lab/LoadingButton";
import mi from "@mui/material/Box";
import fi from "@mui/material/DialogActions";
import gi from "@mui/material/DialogContent";
import Ci from "@mui/material/DialogContentText";
import Ei from "@mui/material/SwipeableDrawer";
import { Controller as _t, useForm as pt } from "react-hook-form";
import { matchIsValidTel as xi, MuiTelInput as Si } from "mui-tel-input";
import { z as k } from "zod";
import { zodResolver as kt } from "@hookform/resolvers/zod";
import { parsePhoneNumberFromString as vi } from "libphonenumber-js";
import on from "@mui/material/Stack";
import At from "@mui/icons-material/Person";
import $ from "@mui/material/Grid";
import Ti from "@mui/icons-material/Place";
import { countries as Oi } from "countries-list";
import zt from "@mui/icons-material/Cancel";
import Vt from "@mui/icons-material/CheckCircle";
import Ii from "@mui/material/List";
import Ri from "@mui/material/ListItem";
import ht from "@mui/material/Typography";
import bi from "@mui/lab/LoadingButton/LoadingButton";
import Ni from "@mui/material/TextField";
import yi from "@mui/material/IconButton";
import Ai from "@mui/icons-material/Visibility";
import wi from "@mui/icons-material/VisibilityOff";
import Pi from "@mui/icons-material/VpnKey";
import Bt from "@mui/icons-material/InfoOutlined";
import mt from "@mui/icons-material/Check";
const On = () => (X(), /* @__PURE__ */ n(
  Tr,
  {
    sx: {
      height: "24px",
      width: "24px",
      fill: "currentColor"
    },
    children: /* @__PURE__ */ m("svg", { width: "24", height: "24", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", children: [
      /* @__PURE__ */ n("rect", { x: "8.5", y: "3", width: "7", height: "6", rx: "1.5" }),
      /* @__PURE__ */ n("rect", { x: "2.5", y: "15", width: "7", height: "6", rx: "1.5" }),
      /* @__PURE__ */ n("rect", { x: "14.5", y: "15", width: "7", height: "6", rx: "1.5" }),
      /* @__PURE__ */ n("path", { d: "M8 13C7.44772 13 7 13.4477 7 14V15H5V14C5 12.3431 6.34315 11 8 11H16C17.6569 11 19 12.3431 19 14V15H17V14C17 13.4477 16.5523 13 16 13H8Z" }),
      /* @__PURE__ */ n("rect", { x: "11", y: "9", width: "2", height: "2" })
    ] })
  }
));
class Li {
  constructor() {
    Q(this, "events", {});
  }
  on(t, r) {
    const i = this.events;
    return (i[t] || (i[t] = [])).push({
      fn: r
    }), this;
  }
  once(t, r) {
    const i = () => {
      this.off(t, i), r();
    }, o = this.events;
    return (o[t] || (o[t] = [])).push({
      fn: i,
      fnOnce: r
    }), this;
  }
  emit(t) {
    var r = (this.events[t] || []).slice(), i = 0, o = r.length;
    for (i; i < o; i++)
      r[i].fn();
    return this;
  }
  off(t, r) {
    var c;
    const i = this.events;
    var o = i[t], a = [];
    if (o && r)
      for (var s = 0, l = o.length; s < l; s++)
        o[s].fn !== r && ((c = o[s]) == null ? void 0 : c.fnOnce) !== r && a.push(o[s]);
    return a.length ? i[t] = a : delete i[t], this;
  }
}
class Mi {
  constructor(t) {
    Q(this, "emitter");
    this.emitter = t;
  }
  on(t, r) {
    this.emitter.on(t, r);
  }
  off(t, r) {
    this.emitter.off(t, r);
  }
  once(t, r) {
    this.emitter.once(t, r);
  }
}
const Gt = () => `${_.Services.FrontDoor}/proxy`, In = "HOME", Rn = {
  local: "https://id-dev.ncrcloud.com",
  dev: "https://id-dev.ncrcloud.com",
  stg: "https://id-stg.ncrcloud.com",
  prd: "https://identity.ncrvoyix.com",
  apac: "https://identity-apac.ncrvoyix.com",
  napac: "https://identity-napac.ncrvoyix.com",
  emea: "https://identity-emea.ncrvoyix.com"
}, bn = {
  local: {
    FrontDoor: "https://localhost:4003"
  },
  dev: {
    FrontDoor: "https://home-ccapi-dev.ncrcloud.com"
  },
  stg: {
    FrontDoor: "https://home-ccapi-stg.ncrcloud.com"
  },
  prd: {
    FrontDoor: "https://home-ccapi.ncrvoyix.com"
  },
  napac: {
    FrontDoor: "https://home-ccapi-napac.ncrvoyix.com"
  },
  apac: {
    FrontDoor: "https://home-ccapi-apac.ncrvoyix.com"
  },
  emea: {
    FrontDoor: "https://home-ccapi-emea.ncrvoyix.com"
  }
}, Wt = new Li(), _ = {
  Services: bn.local,
  AccessToken: "",
  NepOrganization: "",
  IdmUrl: Rn.local,
  Environment: "local"
}, Ui = () => {
  let t = new zr(window.navigator.userAgent).getResult();
  return {
    browserName: t.browser.name || "",
    browserVersion: t.browser.version || "",
    osName: t.os.name || "",
    osVersion: t.os.version || "",
    deviceVendor: t.device.vendor || "",
    deviceModel: t.device.model || ""
  };
}, Ht = () => typeof window > "u", Di = () => _.Services.FrontDoor, Fi = Cn.create(), _i = () => {
  const { browserName: e, browserVersion: t, osName: r, osVersion: i, deviceModel: o, deviceVendor: a } = Ui();
  return {
    key: "base",
    browser: `${e} ${t}`,
    os: `${r} ${i}`,
    mobile: a !== "" ? `${a} ${o}` : null,
    location: window.location.host,
    package: "1.1.0"
  };
}, ki = (e) => {
  Fi.post(`${Di()}/logging`, e, {
    headers: {
      Authorization: `AccessToken ${_.AccessToken}`
    }
  }).catch(() => {
  });
}, an = () => {
  switch (_.Environment) {
    case "local":
    case "dev":
    case "stg":
    case "prd":
    case "apac":
    case "emea":
    case "napac":
    default:
      return "warn";
  }
}, zi = (e) => {
  const t = e.bindings.find((r) => r.key === "base");
  return {
    browser: t == null ? void 0 : t.browser,
    os: t == null ? void 0 : t.os,
    mobile: t == null ? void 0 : t.mobile,
    location: t == null ? void 0 : t.location,
    package: t == null ? void 0 : t.package,
    severity: e.level.label,
    messages: e.messages
  };
}, rt = () => _r({
  level: an(),
  browser: {
    asObject: !0,
    transmit: {
      level: an(),
      send: function(e, t) {
        _.Environment !== "local" && ki(zi(t));
      }
    }
  }
}).child(_i()), Nn = ({ children: e }) => /* @__PURE__ */ n(Vi, { children: e });
class Vi extends vr.Component {
  constructor(t) {
    super(t), this.state = {
      hasError: !1,
      logger: void 0
    };
  }
  static getDerivedStateFromError() {
    return { hasError: !0 };
  }
  componentDidMount() {
    this.setState({
      ...this.state,
      logger: rt()
    });
  }
  componentDidCatch(t, r) {
    this.state.logger && this.state.logger.error(t, r.componentStack);
  }
  render() {
    return this.state.hasError && this.props.fallback ? this.props.fallback : this.props.children;
  }
}
const Bi = {
  xs: 0,
  sm: 600,
  md: 900
};
class Je {
  constructor(t, r) {
    Q(this, "_value");
    Q(this, "_mobileValue");
    this._value = t, this._mobileValue = r ?? t;
  }
  get value() {
    return this._value;
  }
  get mobileValue() {
    return this._mobileValue;
  }
}
const w = {
  BorderRadius: new Je("8px"),
  UserSettingsPadding: new Je("32px", "16px"),
  DialogBorderRadius: new Je("16px"),
  MobileDialogWidth: new Je("85vw"),
  Elevations: {
    Drawer: "2000"
  },
  Breakpoints: Bi
}, re = {
  otherSurfaceBorder: {
    dark: "#3D3D3D",
    light: "#E8E8E8"
  },
  cancelButtonColor: {
    dark: "#E0E0E0",
    light: "#424242"
  },
  cancelButtonBorderColor: {
    dark: "#757575",
    light: "#BDBDBD"
  },
  saveButtonColor: {
    dark: "#FFFFFF",
    light: "#FFFFFF"
  },
  saveButtonBackgroundColor: {
    dark: "#5F249F",
    light: "#5F249F"
  },
  saveButtonHoverBackgroundColor: {
    dark: "#6A1B9A",
    light: "#6A1B9A"
  },
  logoutButtonHoverBorderColor: {
    dark: "#616161",
    light: "#9E9E9E"
  }
}, yn = te(void 0), An = () => {
  const e = ne(yn);
  if (!e)
    throw new Error("To use SwitcherContext, it must be wrapped in <SwitcherProvider/>");
  return e;
}, P = {
  OrgMenuMax: 5,
  AppMenuMax: 10,
  EffectiveOrgsLimit: 30,
  NcrEmailFormat: "@ncr.com",
  NcrVoyixEmailFormat: "@ncrvoyix.com",
  i18NS: "rcc",
  OrgHeader: "nep-organization",
  GlobalConfigSetName: "v1_home_global_settings",
  ApplicationsListCacheKey: "rcc-applications-list-cache",
  RccCacheKey: "rcc-app-cache",
  ApiVersionHeader: "X-Api-Version",
  ApiVersion: "1.0",
  EffectiveOrgsPageSize: 30
}, { ApiVersion: Tc } = P, Gi = { NO_APPLICATIONS: "Your user is not granted any applications for the tenant {{org}}. Please check with your administrator for application granting.", NO_DEFAULT_APPLICATION: "A default application was not detected for this user and tenant. This normally occurs if you did not provide the ApplicationContextProvider the 'defaultApp' prop or if the 'baseUrl' (given on application creation) does not match the domain of the application." }, Wi = { INPUT_LABEL: "Search", CLEAR: "Clear" }, Hi = { LOADING: "Loading...", LOADING_MORE: "Loading more", PROPS: { EMAIL: "Email", NA: "N/A" }, BUTTONS: { LOGOUT: "Log out", SAVE: "Save", CANCEL: "Cancel", EDIT: "Edit", SUBMIT: "Submit", CONFIRM: "Confirm", CHANGE: "Change" }, CONFIRM: { TITLE: "Are you sure you wish to proceed?", CONTENT: "This action cannot be undone." }, ADDRESS: { APT_SUITE: "Apt, Suite, etc.", LABEL: "Address", STREET: "Street", STREET_ADDRESS: "Street Address", CITY: "City", STATE: "State", POSTAL: "Postal Code", COUNTRY: "Country", COORDINATES: "Coordinates", LATITUDE: "Latitude", LONGITUDE: "Longitude", TIMEZONE: "Timezone", CURRENCY: "Currency", COUNTY: "County" }, FORM: { ERRORS: { REQUIRED: "Required.", REQUIRED_FIRST_NAME: "First Name is required.", REQUIRED_FIRST_NAME_FOR_SAVE: "First Name is required. Please update before saving.", REQUIRED_LAST_NAME: "Last Name is required.", REQUIRED_LAST_NAME_FOR_SAVE: "Last Name is required. Please update before saving.", EMAIL_INVALID: "Please enter a valid email address.", INTERNAL_EMAIL_INVALID: "Please use your quicklook ID and @ncr.com", REQUIRED_EMAIL: "Email is required.", NCR_EMAIL_PROHIBITED: "Can not use @ncr.com or @ncrvoyix.com to update email. Please contact system administrator." }, REQUIRED_FIELDS: "Required fields are marked with an asterisk (*)." }, ALERTS: { UPDATE_SUCCESS: "Updated successfully.", UPDATE_FAILED: "An error occurred while updating this information.." }, MODALS: { LEAVE_UNSAVED: { TITLE: "Unsaved Changes", CONTENT_TEXT: "Some information has been changed and is currently unsaved. Are you sure you want to leave without saving?", CONFIRM_ACTION: "Leave" } } }, $i = { ACCOUNT: "Account", UPDATE_DISPLAY_NAME_ERROR: "Primary user profile could not be loaded." }, Zi = { TITLE: "Account", CLOSE_BUTTON_TITLE: "Close user settings", PROFILE: { TITLE: "Profile", DESCRIPTION: "Update and manage your personal details in one place.", PERSONAL_INFO: "Personal info", BASIC_INFO: "Basic info", FIRST_NAME: "First name", LAST_NAME: "Last name", EMAIL: "Email", CONTACT_INFO: "Contact info", PHONE_NUMBER: "Phone number", CHANGE_EMAIL: "Change email", CHANGE: "Change", LOGOUT: "Would you like to log out?", EMAIL_UPDATE: { UPDATE: "Change email", VERIFY: "Verify email", RESEND: "Resend code", WARNING: "Please verify your email address.", VERIFY_ALERT: "Important: <0>Verify your email</0> to gain full-access to features of your account.", ADD_EMAIL: { SUCCESS: "Email with verification code sent successfully.", ERROR: "Email is already in use. Please log in to existing account." }, VERIFY_CODE: { PROMPT: "Check your email for a verification code", SUCCESS: "Email was verified successfully", ERROR: { EXPIRED: "This verification code has expired. Please resend email to receive a new code.", WRONG_CODE: "Verification code is invalid. Please resend email to get a new code." } } } }, PREFERENCES: { TITLE: "Preferences", DESCRIPTION: "Update and manage your preferences in one place.", DEFAULTS: { TITLE: "Defaults", ORGANIZATION: { TITLE: "Organization", DESCRIPTION: "Select the organization that will load after log in.", EMPTY: "Set default organization" } }, DATE_TIME: { TITLE: "Date & Time", REGION: { TITLE: "Region", DESCRIPTION: "Controls the date, time, and formatting.", INFO: "Setting Region will impact timezone views in some supported views." } }, DISPLAY: { TITLE: "Display", DISPLAY_NAME: { TITLE: "Display name", DESCRIPTION: "Appears in emails and applications for personalization.", PROMPT: "Change display name", FEDERATION_MESSAGE: "Please contact an Application Admin to update your display name.", VALIDATION: "Display name must be between 1 and 2048 characters" }, THEME: { TITLE: "Theme", DESCRIPTION: "Select your interface color scheme." }, LANGUAGE: { TITLE: "Language", DESCRIPTION: "Select your preferred language.", INFO: "If application does not support selected language please note we will default to English.", OPTIONS: { ENGLISH: "English (US)", SPANISH: "Spanish", FRENCH: "French" } } } }, SECURITY: { TITLE: "Security", DESCRIPTION: "Manage security settings and keep your account secure.", CREDENTIALS: "Login credentials", PASSWORD: "Password", CHANGE_PASSWORD: "Change password", CHANGE_PASSWORD_SUBTITLE: "Set a secure password to log in to your account", PASSWORD_RESET: { POLICY: "View password policy", CURRENT_PASSWORD: "Current Password", NEW_PASSWORD: "New Password", CONFIRM_PASSWORD: "Confirm Password", HEADING: "Change Password", CONFIRM: "Confirm password", SUBMIT: "Submit", SUCCESS: "Password updated successfully.", REQUIREMENTS: { HEADER: "Password requirements", MIN_CHARS: "{{number}} characters", MIN_UPPER: "{{number}} upper case letter", MIN_LOWER: "{{number}} lower case letter", MIN_NUMBER: "{{number}} number", MIN_SPECIAL: "{{number}} special character", MATCH: "Passwords match", CONTAINS_NAME: "Must not contain First Name or Last Name" }, ERROR: { FAILED: "Failed to update password.", RECENT_PASSWORD: "Your password cannot be any of your last three passwords.", CURR_PASSWORD: "Current password is not correct.", SAME_CURR_AND_NEW_PASSWORD: "New password cannot be your current password." }, PREVIOUS: "Go back to user information" } } }, Yi = { SWITCHER: { EMPTY: "No applications", SELECT: "Select application", DEFAULT_ICON_ALT: "Default application icon", ICON_ALT: "{{appName}} application icon" }, MENU: { TITLE: "Applications", MANAGE_ALL_APPS: "Show all applications" }, ACCESSIBILITY: { SWITCHER: "Select application", CLOSE: "Close application dialog" }, DIALOG: { NO_RESULTS: "No applications found" } }, qi = { SWITCHER: { EMPTY: "No organizations", SELECT: "Select organization" }, TABS: { RECENT: "Recent", ALL: "All" }, DIALOG: { NO_RESULTS: "No organizations found", FEDERATED_CTA: "Set Organization", NO_MATCH: "Not a valid organization", ID: "Organization ID" }, ERROR: { UNAUTHORIZED: "You do not have access to the organization '{{invalidOrg}}'." }, MENU: { TITLE: "Organizations", MANAGE_ALL_ORGS: "View all organizations" }, ACCESSIBILITY: { SWITCHER: "Select organization", EXPAND_ORG: "Expand to see children organizations", COLLAPSE_ORG: "Collapse to hide children organizations", CLOSE: "Close organization dialog" } }, ji = {
  WARNINGS: Gi,
  SEARCH: Wi,
  COMMON: Hi,
  USER_PROFILE: $i,
  USER_SETTINGS: Zi,
  APPLICATION_CONTEXT: Yi,
  ORG_CONTEXT: qi
}, wn = jr.use(Yr).createInstance(
  {
    resources: {
      en: {
        [P.i18NS]: ji
      }
    },
    ns: P.i18NS,
    defaultNS: P.i18NS,
    fallbackLng: "en",
    lng: "en",
    interpolation: {
      escapeValue: !1
    }
  },
  (e) => {
    e && console.log(e);
  }
);
wn.init();
const R = (e) => Sn(P.i18NS, { ...e, i18n: wn }), ft = ({
  isLoading: e,
  startIcon: t,
  sx: r = {}
}) => {
  const i = X(), o = e ? /* @__PURE__ */ n(
    Mt,
    {
      sx: {
        color: i.palette.action.active
      },
      size: "16px"
    }
  ) : t;
  return /* @__PURE__ */ n(b, { justifyContent: "center", alignItems: "center", sx: r, children: o });
}, $t = Ce(
  ({
    label: e,
    isLoading: t,
    isReadOnly: r,
    isEmpty: i,
    disabled: o,
    onClick: a,
    buttonSx: s = {},
    labelSx: l = {},
    startIcon: c,
    endIcon: d = /* @__PURE__ */ n(
      Vr,
      {
        fontSize: "small",
        sx: {
          color: (f) => f.palette.action.active,
          height: "24px",
          width: "24px"
        }
      }
    ),
    showEndIcon: p = !0,
    ...h
  }, u) => {
    const { t: f } = R(), g = X(), { showStartIconOnly: C, isDisabled: x } = An();
    return /* @__PURE__ */ n(
      le,
      {
        "aria-disabled": t || o || r || i || x,
        disableRipple: !0,
        ref: u,
        onClick: () => {
          t || a();
        },
        variant: "text",
        endIcon: !r && !C && p ? d : null,
        "data-readonly": r,
        sx: {
          height: "40px",
          borderRadius: w.BorderRadius.value,
          textTransform: "none",
          color: g.palette.text.primary,
          padding: "0px 4px",
          "&:focus-visible": {
            outline: `2px solid ${g.palette.text.primary}`
          },
          "&:hover": {
            backgroundColor: g.palette.action.hover
          },
          "&:active": {
            backgroundColor: g.palette.action.selected
          },
          ".MuiButton-startIcon, .MuiButton-endIcon": {
            margin: 0
          },
          "&:not(.Mui-disabled) .MuiButton-startIcon": {
            color: g.palette.action.active
          },
          "&.Mui-disabled[data-readonly=false]": {
            "& > #switcher-label": {
              fontWeight: 500,
              color: g.palette.action.active
            },
            ".MuiButton-startIcon, .MuiButton-endIcon": {
              svg: {
                color: "inherit"
              }
            }
          },
          "&.Mui-disabled[data-readonly=true]": {
            "& > #switcher-label": {
              color: g.palette.text.primary
            },
            ".MuiButton-startIcon, .MuiButton-endIcon": {
              svg: {
                color: g.palette.action.active
              }
            }
          },
          minWidth: "40px",
          maxWidth: "224px",
          ...s
        },
        disabled: o || r || i || x,
        startIcon: !i && (c || /* @__PURE__ */ n(ft, { isLoading: t })),
        ...h,
        children: !C && /* @__PURE__ */ n(
          N,
          {
            id: "switcher-label",
            sx: {
              ...g.typography.subtitle1,
              textOverflow: "ellipsis",
              textAlign: "left",
              whiteSpace: "nowrap",
              width: "100%",
              overflow: "hidden",
              color: "inherit",
              fontWeight: 600,
              paddingLeft: "8px",
              paddingRight: "4px",
              ...l
            },
            "aria-live": "assertive",
            "aria-atomic": "true",
            children: t ? f("COMMON.LOADING") : e
          }
        )
      }
    );
  }
), sn = (e) => e != null && typeof e == "object", Zt = (e, t) => {
  const r = Object.keys(e), i = Object.keys(t);
  if (r.length !== i.length) return !1;
  for (var o of r) {
    const a = e[o], s = t[o], l = sn(a) && sn(s);
    if (l && !Zt(a, s) || !l && a !== s)
      return !1;
  }
  return !0;
}, Xi = (e, t) => {
  const [r, i] = E([]);
  S(() => {
    if (!Zt(r, t))
      return i([...t]), e();
  }, t);
}, Pe = () => ({
  menuTransformOrigin: {
    vertical: "top",
    horizontal: "center"
  },
  menuAnchorOrigin: {
    vertical: "bottom",
    horizontal: "center"
  }
}), gt = ({
  config: e,
  children: t
}) => {
  const [r, i] = E(
    Pe()
  );
  return Xi(() => {
    i(e);
  }, [e]), /* @__PURE__ */ n(yn.Provider, { value: r, children: t });
}, oe = (e) => `[rcc]: ${e}`, Pn = te(void 0), B = () => {
  const e = ne(Pn);
  if (!e)
    throw new Error(
      oe(
        "<RccContextProvider/> is most likely not wrapped around the component / provider you are trying to use. To use OrganizationContext, it must be wrapped in <OrganizationContextProvider/>"
      )
    );
  return e;
}, Ln = te(void 0), V = () => {
  const e = ne(Ln);
  if (!e)
    throw new Error(oe("To use RccContext, it must be wrapped in <RccContextProvider/>"));
  return e;
}, ln = (e) => e == null, Ki = {
  status: 500,
  message: "Unknown Error"
}, G = (e) => {
  var t, r, i, o, a;
  if (e instanceof kr) {
    const s = (r = (t = e == null ? void 0 : e.response) == null ? void 0 : t.data) == null ? void 0 : r.message, l = (o = (i = e == null ? void 0 : e.response) == null ? void 0 : i.data) == null ? void 0 : o.details;
    throw {
      status: (a = e == null ? void 0 : e.response) == null ? void 0 : a.status,
      message: s || l || (e == null ? void 0 : e.message)
    };
  } else
    throw {
      ...Ki
    };
}, Le = Cn.create();
Le.interceptors.request.use(
  (e) => {
    e.headers[P.ApiVersionHeader] = P.ApiVersion, _.AccessToken && (e.headers.Authorization = `AccessToken ${_.AccessToken}`), _.NepOrganization && e.headers[P.OrgHeader] === void 0 && (e.headers[P.OrgHeader] = _.NepOrganization), e.withCredentials = !0;
    let { Authorization: t, ...r } = e.headers;
    return rt().info({
      request: {
        url: e.url,
        method: e.method,
        headers: { Authorization: "AccessToken REDACTED", ...r },
        data: e.data
      }
    }), e;
  },
  null,
  { synchronous: !0 }
);
Le.interceptors.response.use(
  (e) => (rt().info({
    response: {
      url: e.config.url,
      method: e.config.method,
      status: e.status
    }
  }), e),
  (e) => {
    var t, r, i, o, a;
    return rt().error({
      response: {
        url: (t = e == null ? void 0 : e.config) == null ? void 0 : t.url,
        method: (r = e == null ? void 0 : e.config) == null ? void 0 : r.method,
        message: e.message,
        status: (i = e.response) == null ? void 0 : i.status,
        data: (o = e.response) == null ? void 0 : o.data,
        headers: (a = e.response) == null ? void 0 : a.headers
      }
    }), Promise.reject(e);
  }
);
const ce = (e, t = {}) => Le.get(e, t).then((r) => r.data), Ct = (e, t, r = {}) => Le.put(e, t, r).then((i) => i.data), Qi = (e, t = {}) => Le.delete(e, t).then((r) => r.data), Mn = (e, t, r = {}) => Le.post(e, t, r).then((i) => i.data), Un = (e, t) => ["EFFECTIVE_ORGANIZATIONS", e, t], Ji = (e) => ["ORGANIZATION", e], eo = () => "RECENT_ORGANIZATIONS", to = (e) => ["APPLICATIONS", e], no = () => "USER_PREFERENCES", ro = () => "OKTA_USER_INFO", Dn = (e) => ["USER_PROFILE", e], io = (e) => ["COMMON_PROFILE_VISIBILITY", e], oo = (e) => ["INTROSPECT", e], Fn = "/provisioning/user-profiles", ao = () => `${_.Services.FrontDoor}/users`, so = (e) => Mn(
  `${Gt()}/users/change-my-password`,
  e,
  {
    headers: {
      [P.OrgHeader]: null
    }
  }
).catch(G), lo = async (e, t) => Ct(`${Gt()}${Fn}`, e, {
  withCredentials: !0,
  headers: {
    [P.OrgHeader]: t
  }
}).catch(G), co = async (e) => {
  const t = { displayName: e };
  return Ct(`${ao()}/display-name`, t).catch(G);
}, _n = async (e) => ce(`${Gt()}${Fn}`, {
  withCredentials: !0,
  headers: {
    [P.OrgHeader]: e
  }
}).catch(G), uo = (e) => {
  const { isLoading: t, data: r, error: i, mutate: o } = ve(
    ln(e) ? null : Dn(e),
    () => _n(e)
  ), [a, s] = E(!1), l = z(async (c) => {
    if (ln(e))
      throw oe("Organization name is required to update user profile");
    try {
      s(!0);
      const d = await lo(c, e);
      await o(d, { revalidate: !1 });
    } finally {
      s(!1);
    }
  }, [e, o]);
  return {
    isLoading: t,
    data: r,
    error: i,
    isUserProfileMutating: a,
    updateUserProfile: l
  };
}, po = () => {
  const { isAuthenticated: e } = V(), { isLoading: t, data: r, error: i, mutate: o } = ve(
    e ? Dn("") : null,
    () => _n("")
  ), [a, s] = E(void 0), [l, c] = E(!1), d = D(), { t: p } = R();
  S(function() {
    r && (d.current = r);
  }, [r]);
  const h = z(async (u) => {
    if (!d.current) {
      console.error(p("USER_PROFILE.UPDATE_DISPLAY_NAME_ERROR"));
      return;
    }
    try {
      s(void 0), c(!0), await co(u), await o({
        ...d.current,
        displayName: u
      }, { revalidate: !1 });
    } catch (f) {
      s(f);
    } finally {
      c(!1);
    }
  }, [s, c]);
  return {
    isGetPrimaryUserProfileLoading: t,
    primaryUserProfile: r,
    getPrimaryUserProfileError: i,
    updateDisplayNameError: a,
    isDisplayNameUpdating: l,
    updateDisplayName: h
  };
};
var Ve = /* @__PURE__ */ ((e) => (e.SYSTEM = "system", e.LIGHT = "light", e.DARK = "dark", e))(Ve || {}), Be = /* @__PURE__ */ ((e) => (e.US = "UnitedStates", e.MEXICO = "Mexico", e.CANADA = "Canada", e))(Be || {}), Yt = /* @__PURE__ */ ((e) => (e.SIGNOUT = "SIGNOUT", e))(Yt || {}), Ge = /* @__PURE__ */ ((e) => (e.organization = "organizationId", e))(Ge || {}), ho = /* @__PURE__ */ ((e) => (e.FULL = "FULL", e.PARTIAL = "PARTIAL", e.NONE = "NONE", e))(ho || {}), mo = /* @__PURE__ */ ((e) => (e.ACTIVE = "ACTIVE", e.INACTIVE = "INACTIVE", e.TERMINATED = "TERMINATED", e.SUSPENDED = "SUSPENDED", e))(mo || {});
function fo(e) {
  return e == null ? !1 : e.federationType === "FULL" || e.federationType === "PARTIAL";
}
function go(e) {
  return e.email ? !!(e.managedUserTypes && e.managedUserTypes.includes("PROFILE")) : !1;
}
function Co(e) {
  const t = [e.street, e.addressLine2].filter((o) => o).join(" "), r = `${e.city ?? ""}${e.city && (e.state || e.postalCode) ? ", " : ""}${e.state ?? ""}${e.state && e.postalCode ? " " : ""}${e.postalCode ?? ""}`, i = e.country;
  return [t, r, i].filter((o) => o).join(`
`);
}
const Eo = (e) => ({
  displayName: e.displayName,
  address: e.address,
  telephoneNumber: e.telephoneNumber,
  familyName: e.familyName,
  fullName: e.fullName,
  givenName: e.givenName,
  deviceLogin: e.deviceLogin
}), kn = te(void 0), ae = () => {
  const e = ne(kn);
  if (!e)
    throw new Error(
      oe(
        "<RccContextProvider/> is most likely not wrapped around the component / provider you are trying to use. To use UserProfileContext, it must be wrapped in <UserProfileContextProvider/>"
      )
    );
  return e;
}, xo = () => {
  const { userProfile: e, userProfileLoading: t } = ae();
  return { userProfile: e, userProfileLoading: t };
}, So = ({ children: e }) => {
  const { organization: t } = B(), {
    data: r,
    isLoading: i,
    error: o,
    isUserProfileMutating: a,
    updateUserProfile: s
  } = uo(t == null ? void 0 : t.organizationName), {
    isGetPrimaryUserProfileLoading: l,
    primaryUserProfile: c,
    getPrimaryUserProfileError: d,
    updateDisplayNameError: p,
    isDisplayNameUpdating: h,
    updateDisplayName: u
  } = po(), f = z(
    async (x) => {
      const O = { ...x };
      return c != null && c.displayName && (O.displayName = c.displayName), await s(Eo(O));
    },
    [s, c == null ? void 0 : c.displayName]
  ), g = z(() => r ? go(r) : !1, [r]), C = j(
    () => ({
      userProfile: r,
      userProfileLoading: i,
      isUpdateUserProfileLoading: a,
      getUserProfileError: o,
      updateUserProfile: f,
      isUserManagedProfile: g,
      isUserFederated: fo(c),
      primaryUserProfile: c,
      isGetPrimaryUserProfileLoading: l,
      getPrimaryUserProfileError: d,
      updateDisplayNameError: p,
      isDisplayNameUpdating: h,
      updateDisplayName: u
    }),
    [
      r,
      i,
      a,
      o,
      f,
      g,
      c,
      l,
      d,
      p,
      h,
      u
    ]
  );
  return /* @__PURE__ */ n(kn.Provider, { value: C, children: e });
}, zn = te(
  void 0
), ye = () => {
  const e = ne(zn);
  if (!e)
    throw new Error(
      oe(
        "To use ApplicationContext, it must be wrapped in <ApplicationContextProvider/>"
      )
    );
  return e;
}, Vn = () => {
  const { isLoading: e, isAppDialogOpen: t, setIsAppDialogOpen: r, error: i, application: o, userApplications: a } = ye();
  return {
    isLoading: e,
    isAppDialogOpen: t,
    setIsAppDialogOpen: r,
    error: i,
    application: o,
    userApplications: a
  };
}, Bn = te(
  void 0
), Me = () => {
  const e = ne(Bn);
  if (!e)
    throw new Error(
      oe(
        "<RccContextProvider/> is most likely not wrapped around the component / provider you are trying to use. To use OrganizationsCacheContext, it must be wrapped in <OrganizationsCacheProvider/>"
      )
    );
  return e;
}, Oc = () => {
  const {
    recentOrganizations: e,
    recentOrganizationsMutationError: t,
    isRecentOrganizationsLoading: r,
    getRecentOrganizationsError: i,
    isRecentOrganizationsMutating: o
  } = Me();
  return {
    recentOrganizations: e,
    recentOrganizationsMutationError: t,
    isRecentOrganizationsLoading: r,
    getRecentOrganizationsError: i,
    isRecentOrganizationsMutating: o
  };
}, Gn = te(void 0), Ue = () => {
  const e = ne(Gn);
  if (!e)
    throw new Error(
      oe(
        "<RccContextProvider/> is most likely not wrapped around the component / provider you are trying to use. To use UserPreferencesContext, it must be wrapped in <UserPreferencesProvider/>"
      )
    );
  return e;
}, vo = () => {
  const {
    userPreferences: e,
    isUserPreferencesLoading: t,
    isUserPreferencesMutating: r,
    userPreferencesMutationError: i,
    getUserPreferencesError: o
  } = Ue();
  return {
    userPreferences: e,
    isUserPreferencesLoading: t,
    isUserPreferencesMutating: r,
    userPreferencesMutationError: i,
    getUserPreferencesError: o
  };
}, Wn = te(void 0), Ic = () => {
  const e = ne(Wn);
  if (!e)
    throw new Error(
      oe(
        "<RccContextProvider/> is most likely not wrapped around the component / provider you are trying to use. To use UsersContext, it must be wrapped in <UsersContextProvider/>"
      )
    );
  return e;
}, Z = () => {
  const e = Te();
  return vn(e.breakpoints.down(w.Breakpoints.sm));
}, To = () => {
  let e = document.createElement("div");
  e.style.cssText = "overflow:scroll; visibility:hidden; position:absolute;", document.body.appendChild(e);
  let t = e.offsetWidth - e.clientWidth;
  return e.remove(), t;
}, Hn = Ce(
  ({ children: e, sx: t = {} }, r) => {
    const i = Z(), o = j(() => Ht() ? 0 : To(), []), a = i ? {
      padding: "0px 16px 8px 16px"
    } : {
      padding: `0px ${Math.max(24 - o, 0)}px 24px 24px`
    };
    return /* @__PURE__ */ n(
      at,
      {
        ref: r,
        sx: { ...a, scrollbarGutter: "stable", ...t },
        children: e
      }
    );
  }
), Oo = Ce(function(t, r) {
  return /* @__PURE__ */ n(dt, { direction: "up", ref: r, ...t });
}), Io = Ce(function(t, r) {
  return /* @__PURE__ */ n(Dt, { ref: r, ...t });
}), $n = ({
  isOpen: e,
  dialogTitle: t,
  dialogCloseTitle: r,
  dialogTitleSlot: i,
  dialogContent: o,
  onClose: a,
  children: s
}) => {
  const l = Z(), c = l ? {
    height: "100%",
    width: "100%",
    margin: 0,
    maxHeight: "unset",
    borderRadius: 0
  } : {}, d = l ? {
    padding: "20px 16px"
  } : {
    padding: "24px"
  };
  return /* @__PURE__ */ m(
    Tn,
    {
      sx: {
        "& .MuiPaper-root": {
          borderRadius: "12px",
          width: "452px",
          maxHeight: "min(700px, calc(100% - 64px))",
          ...c
        }
      },
      open: e,
      onClose: a,
      TransitionComponent: l ? Oo : Io,
      children: [
        /* @__PURE__ */ m(b, { children: [
          /* @__PURE__ */ m(
            b,
            {
              position: "relative",
              justifyContent: "space-between",
              alignItems: "center",
              direction: "row",
              sx: d,
              children: [
                /* @__PURE__ */ n(
                  He,
                  {
                    sx: { padding: 0, fontSize: "18px", fontWeight: 700 },
                    variant: "h6",
                    children: t
                  }
                ),
                /* @__PURE__ */ n(ie, { sx: { padding: "6px" }, title: r, onClick: a, children: /* @__PURE__ */ n(ct, { sx: { height: "20px", width: "20px" } }) })
              ]
            }
          ),
          !!i && i
        ] }),
        o || /* @__PURE__ */ n(Hn, { children: s })
      ]
    }
  );
}, Ro = (e) => {
  const t = e.split("/");
  return t.length == 1 ? e : t.slice(-2)[0];
}, qt = () => _.Services.FrontDoor, bo = (e) => Qi(`${qt()}${e}`, {
  headers: {
    [P.OrgHeader]: null
  }
}).catch(G), No = (e) => ce(`${qt()}/organizations/organization/${e}`, {
  headers: {
    //Overwrite stored header
    [P.OrgHeader]: e
  }
}).then((t) => (t.organizationName = Ro(t.organizationName), t)).catch(G), Zn = (e, t) => ce(`${qt()}/organizations/effective`, {
  params: {
    pageNumber: e,
    pageSize: t
  }
}).catch(
  G
), yo = () => {
  const { trigger: e } = ei(
    "/organizations/effective",
    bo,
    {
      revalidate: !1
    }
  );
  return e;
}, je = (e, t = {}) => {
  const {
    data: r,
    isLoading: i,
    error: o
  } = ve(
    e ? Ji(e) : null,
    () => No(e),
    {
      /**
       * https://swr.vercel.app/docs/advanced/performance#deduplication
       * Allows deduping of requests with the same key in this time span of miliseconds
       * We set it to 10 seconds since we don't expect changes in the response too often
       */
      dedupingInterval: 1e4,
      ...t
    }
  );
  return {
    organizationData: r,
    isLoadingOrg: i,
    errorOrg: o
  };
}, Ao = (e, t, r, i = {}) => {
  const o = Un(t, r), {
    data: a,
    isLoading: s,
    error: l
  } = Ft(
    e ? o : null,
    () => Zn(t, r),
    i
  );
  return {
    effectiveOrganizationsResponse: a,
    isLoadingEffectiveOrgs: s,
    errorOrgs: l
  };
}, wo = (e, t, r, i) => !e || i && i.lastPage ? null : Un(r, t), Po = (e) => {
  const { isAuthenticated: t } = V(), {
    data: r,
    isLoading: i,
    isValidating: o,
    setSize: a,
    size: s,
    error: l
  } = Jr(
    (c, d) => wo(t, e, c, d),
    (c) => Zn(c[1], e),
    {
      initialSize: 1,
      revalidateFirstPage: !1
    }
  );
  return {
    data: r,
    isLoading: i,
    isValidating: o,
    setSize: a,
    size: s,
    error: l
  };
}, Yn = (e) => {
  const t = D(null);
  return S(() => {
    e && (typeof e == "function" ? e(t.current ?? null) : e.current = t.current);
  }), t;
}, qn = Ce(
  ({
    activeTerm: e,
    setActiveTerm: t,
    onCtaClick: r,
    searchTerm: i,
    setSearchTerm: o,
    isDisabled: a = !1,
    listSxProps: s = {}
  }, l) => {
    const [c, d] = E(!1), [p, h] = E(!0), u = Yn(l), { t: f } = R(), { organizationData: g, isLoadingOrg: C, errorOrg: x } = je(i), O = j(
      () => Or(async (y) => {
        const M = y.target.value;
        o(M);
      }, 750),
      [o]
    ), v = Te(), T = () => {
      !p && !C && (t(i), r(g));
    };
    return S(() => {
      d(i !== e);
    }, [d, i, e]), S(() => {
      h(
        !g || !c || a || !!x || C
      );
    }, [g, c, a, x, C]), S(() => {
      var y;
      x && ((y = u.current) == null || y.focus());
    }, [x]), /* @__PURE__ */ m(
      b,
      {
        sx: {
          rowGap: "8px",
          ...s
        },
        children: [
          /* @__PURE__ */ m(b, { rowGap: "8px", children: [
            /* @__PURE__ */ n(
              $e,
              {
                "data-element-id": "default-org-input",
                inputRef: u,
                disabled: a,
                fullWidth: !0,
                autoComplete: "off",
                onChange: (y) => {
                  h(!0), O(y);
                },
                error: !!x,
                InputProps: {
                  sx: { borderRadius: w.BorderRadius.value }
                }
              }
            ),
            x && /* @__PURE__ */ n(A, { fontSize: "14px", color: "error", children: f("ORG_CONTEXT.DIALOG.NO_MATCH") })
          ] }),
          /* @__PURE__ */ n(
            le,
            {
              "data-element-id": "set-default-organization-button",
              disabled: p || a,
              onClick: T,
              sx: {
                textTransform: "unset",
                backgroundColor: v.palette.primary.main,
                borderRadius: w.BorderRadius.value
              },
              fullWidth: !0,
              variant: "contained",
              size: "large",
              children: f("ORG_CONTEXT.DIALOG.FEDERATED_CTA")
            }
          )
        ]
      }
    );
  }
), jn = te(
  void 0
), Xn = () => {
  const e = ne(jn);
  if (!e)
    throw new Error(
      "To use OrganizationDialogContext, it must be wrapped in <OrganizationDialogProvider/>"
    );
  return e;
}, Lo = ({
  updateOrganization: e,
  setIsOrgDialogOpen: t,
  children: r
}) => {
  const i = z(
    (a) => {
      t(!1), e(a);
    },
    [t, e]
  ), o = j(
    () => ({
      handleOrganizationClick: i
    }),
    [i]
  );
  return /* @__PURE__ */ n(jn.Provider, { value: o, children: r });
}, jt = () => ({
  "&.Mui-selected": {
    backgroundColor: "action.selected"
  },
  "&.Mui-focusVisible": {
    backgroundColor: "action.hover"
  },
  "&.Mui-selected.Mui-focusVisible, &.Mui-selected:hover": {
    backgroundColor: "action.focus"
  }
}), Mo = {
  px: 0,
  py: 0
}, Kn = ({
  children: e,
  sx: t = {},
  buttonProps: r = {},
  buttonSx: i = {},
  selected: o,
  onListItemButtonClick: a,
  ...s
}) => /* @__PURE__ */ n(
  st,
  {
    sx: {
      ...Mo,
      ...t
    },
    ...s,
    children: /* @__PURE__ */ n(
      lt,
      {
        selected: o,
        sx: {
          margin: "4px 0",
          padding: "8px",
          ...jt(),
          borderRadius: w.BorderRadius.value,
          ...i
        },
        ...r,
        onClick: a,
        children: e
      }
    )
  }
), Uo = () => {
  const { t: e } = R();
  return /* @__PURE__ */ n(
    Ir,
    {
      icon: /* @__PURE__ */ n(Mt, { size: "16px", color: "secondary" }),
      label: e("COMMON.LOADING_MORE")
    }
  );
}, Do = 50, Fo = ({
  onLoad: e,
  loading: t,
  threshold: r = 0.5,
  disabled: i = !1,
  loadDebounce: o = Do
}) => {
  const a = D(null), s = D(e), l = j(
    () => ti(() => {
      s.current();
    }, o),
    [o]
  );
  return S(
    function() {
      s.current = e;
    },
    [e]
  ), S(
    function() {
      if (i || !a.current) return;
      const d = a.current, p = () => {
        if (!d || t) return;
        const h = d.scrollTop, u = d.scrollHeight, f = d.clientHeight, g = h + f, C = u * r;
        g >= C && l();
      };
      return d.addEventListener("scroll", p), () => {
        d.removeEventListener("scroll", p);
      };
    },
    [r, i, t]
  ), a;
}, _o = () => {
  const { organization: e } = B(), { handleOrganizationClick: t } = Xn(), { data: r, isLoading: i, isValidating: o, size: a, setSize: s, error: l } = Po(P.EffectiveOrgsPageSize), c = r == null ? void 0 : r[r.length - 1], d = c && c.lastPage || l, p = Fo({
    onLoad: () => s(a + 1),
    loading: i || o,
    disabled: d
  }), h = (r == null ? void 0 : r.flatMap((f) => f.organizations)) ?? [], u = ut.uniqBy(h, "organizationName");
  return /* @__PURE__ */ n(Hn, { ref: p, children: /* @__PURE__ */ m(Ze, { disablePadding: !0, children: [
    u.map((f) => {
      const g = f.organizationName;
      return /* @__PURE__ */ n(
        Kn,
        {
          selected: g === (e == null ? void 0 : e.organizationName),
          buttonSx: {
            padding: "12px 8px 12px 12px"
          },
          onListItemButtonClick: () => t(g),
          children: /* @__PURE__ */ n(A, { variant: "body1", children: g })
        },
        g
      );
    }),
    !d && /* @__PURE__ */ n(st, { sx: { display: "flex", justifyContent: "center" }, children: /* @__PURE__ */ n(Uo, {}) })
  ] }) });
}, ko = ({
  onCtaClick: e
}) => {
  const [t, r] = E(), [i, o] = E(), a = D(!0), s = D(null), { organization: l, isLoading: c } = B();
  return S(() => {
    if (a.current && l && s.current) {
      const d = l.organizationName;
      r(d), o(d), s.current.value = d, a.current = !1;
    }
  }, [l]), /* @__PURE__ */ n(
    qn,
    {
      ref: s,
      onCtaClick: e,
      searchTerm: t,
      setSearchTerm: r,
      activeTerm: i,
      setActiveTerm: o,
      isDisabled: c
    }
  );
}, zo = () => {
  const { t: e } = R(), t = Z(), { handleOrganizationClick: r } = Xn(), { totalOrganizations: i, isOrgDialogOpen: o, setIsOrgDialogOpen: a } = B(), s = (i || 0) > P.EffectiveOrgsLimit, l = t ? {
    padding: "0px 16px 16px 16px"
  } : {
    padding: "0px 24px 16px 24px"
  }, c = () => {
    a(!1);
  }, d = (p) => {
    r(p == null ? void 0 : p.organizationName);
  };
  return /* @__PURE__ */ n(
    $n,
    {
      isOpen: o,
      dialogTitle: e("ORG_CONTEXT.MENU.TITLE"),
      dialogCloseTitle: e("ORG_CONTEXT.ACCESSIBILITY.CLOSE"),
      onClose: c,
      dialogTitleSlot: /* @__PURE__ */ n(Lt, { children: s && /* @__PURE__ */ n(b, { sx: l, children: /* @__PURE__ */ n(
        ko,
        {
          onCtaClick: d
        }
      ) }) }),
      dialogContent: /* @__PURE__ */ n(_o, {})
    }
  );
}, Vo = () => {
  const { setIsOrgDialogOpen: e, updateOrganization: t } = B();
  return /* @__PURE__ */ n(
    Lo,
    {
      setIsOrgDialogOpen: e,
      updateOrganization: t,
      children: /* @__PURE__ */ n(zo, {})
    }
  );
}, Bo = { padding: "16px" }, Qn = ({
  sx: e = {},
  children: t
}) => /* @__PURE__ */ n(
  N,
  {
    height: "auto",
    width: "100%",
    sx: {
      ...Bo,
      ...e
    },
    children: t
  }
), Jn = ({ children: e }) => /* @__PURE__ */ m(N, { height: "auto", paddingTop: "6px", width: "100%", children: [
  /* @__PURE__ */ n(
    N,
    {
      sx: (t) => ({
        margin: "0px auto",
        width: "48px",
        height: "5px",
        backgroundColor: re.otherSurfaceBorder[t.palette.mode],
        borderRadius: "33px"
      })
    }
  ),
  e
] }), er = ({
  menuOpen: e,
  menuTitle: t,
  menuCloseTitle: r,
  ctaTitle: i,
  onMenuOpen: o,
  onMenuClose: a,
  onCtaClick: s,
  children: l
}) => /* @__PURE__ */ m(
  fn,
  {
    disableDiscovery: !0,
    disableSwipeToOpen: !0,
    anchor: "bottom",
    open: e,
    onClose: a,
    onOpen: o,
    sx: {
      ".MuiPaper-root.MuiDrawer-paper": {
        borderTopRightRadius: w.BorderRadius.value,
        borderTopLeftRadius: w.BorderRadius.value
      }
    },
    children: [
      /* @__PURE__ */ n(Jn, { children: /* @__PURE__ */ m(
        N,
        {
          padding: "8px 16px",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          children: [
            /* @__PURE__ */ n(
              A,
              {
                sx: {
                  fontWeight: 700,
                  fontSize: "1.125rem"
                },
                variant: "h6",
                children: t
              }
            ),
            /* @__PURE__ */ n(ie, { title: r, onClick: a, children: /* @__PURE__ */ n(En, {}) })
          ]
        }
      ) }),
      /* @__PURE__ */ n(Ze, { sx: { maxHeight: "70vh", overflowY: "auto", padding: "0px 16px 8px 16px" }, children: l }),
      /* @__PURE__ */ n(ge, {}),
      /* @__PURE__ */ n(Qn, { children: /* @__PURE__ */ n(
        le,
        {
          size: "large",
          onClick: s,
          sx: {
            borderRadius: w.BorderRadius.value,
            textTransform: "none",
            width: "100%",
            color: "text.primary",
            borderColor: "text.primary",
            "&:hover": {
              backgroundColor: "action.hover",
              borderColor: "text.primary"
            }
          },
          variant: "outlined",
          children: i
        }
      ) })
    ]
  }
), tr = (e) => {
  const t = X(), { children: r, sx: i, ...o } = e;
  return /* @__PURE__ */ n(
    st,
    {
      sx: {
        padding: "4px 0px"
      },
      children: /* @__PURE__ */ n(
        lt,
        {
          sx: {
            borderRadius: w.BorderRadius.value,
            padding: "8px 16px 8px 8px",
            ...t.typography.subtitle1,
            ...jt(),
            ...i
          },
          ...o,
          children: r
        }
      )
    }
  );
}, Go = ({
  menuOpen: e,
  onMenuOpen: t,
  onMenuClose: r,
  onOrgClick: i
}) => {
  const { t: o } = R(), { userOrganizations: a, setIsOrgDialogOpen: s, organization: l } = B(), { recentOrganizations: c } = Me(), p = !!c && (c == null ? void 0 : c.length) > 0 ? c : a, h = () => {
    r(), s(!0);
  }, u = p.slice(0, P.OrgMenuMax).map((f) => {
    const g = f.organizationName;
    return /* @__PURE__ */ n(
      tr,
      {
        selected: g === (l == null ? void 0 : l.organizationName),
        onClick: () => i(g),
        sx: {
          padding: "12px 8px 12px 12px"
        },
        children: g
      },
      g
    );
  });
  return /* @__PURE__ */ n(
    er,
    {
      menuOpen: e,
      menuTitle: o("ORG_CONTEXT.MENU.TITLE"),
      menuCloseTitle: o("ORG_CONTEXT.ACCESSIBILITY.CLOSE"),
      ctaTitle: o("ORG_CONTEXT.MENU.MANAGE_ALL_ORGS"),
      onMenuClose: r,
      onMenuOpen: t,
      onCtaClick: h,
      children: u
    }
  );
}, Wo = Pe(), Ho = (e, t) => !e && !t ? {
  padding: "8px 0px"
} : {
  padding: "4px 0px 0px"
}, Et = ({
  menuTitle: e,
  ctaTitle: t,
  onCtaClick: r,
  anchorRef: i,
  menuOpen: o,
  children: a,
  onMenuClose: s,
  menuPaperSx: l = {}
}) => {
  const { menuAnchorOrigin: c, menuTransformOrigin: d } = Wo, p = X(), { menuAnchorOrigin: h, menuTransformOrigin: u } = An(), f = !!t && !!r;
  return Ht() ? /* @__PURE__ */ n(we, {}) : /* @__PURE__ */ m(
    Rr,
    {
      anchorEl: () => i.current,
      anchorOrigin: h || c,
      transformOrigin: u || d,
      keepMounted: !0,
      sx: {
        ".MuiMenu-paper": {
          width: "286px",
          maxHeight: "350px",
          borderRadius: w.BorderRadius.value,
          ...l
        }
      },
      MenuListProps: {
        sx: {
          ...Ho(f, !!e)
        }
      },
      open: o,
      onClose: s,
      children: [
        e && /* @__PURE__ */ n(
          Ne,
          {
            "aria-hidden": !0,
            disabled: !0,
            sx: {
              padding: "0px 16px 0px 20px",
              fontWeight: 500,
              height: "48px",
              fontSize: p.typography.body2.fontSize,
              color: p.palette.text.secondary,
              "&.Mui-disabled": {
                opacity: 1
              }
            },
            children: e
          }
        ),
        a,
        f && [
          /* @__PURE__ */ n(
            ge,
            {
              role: "separator",
              sx: {
                "&.MuiDivider-root.MuiDivider-fullWidth": {
                  margin: "8px 0px 0px"
                }
              }
            },
            "cta_divider"
          ),
          /* @__PURE__ */ m(
            Ne,
            {
              sx: {
                padding: "20px",
                fontWeight: 500,
                fontSize: p.typography.body2.fontSize,
                color: p.palette.text.primary
              },
              onClick: r,
              children: [
                t,
                /* @__PURE__ */ n(ni, { sx: { fontSize: "20px", marginLeft: "8px" } })
              ]
            },
            "cta_button"
          )
        ]
      ]
    }
  );
}, De = (e) => {
  const { children: t, sx: r, ...i } = e;
  return /* @__PURE__ */ n(
    Ne,
    {
      sx: {
        margin: "4px 12px",
        padding: "8px",
        borderRadius: "8px",
        ...jt(),
        ...r
      },
      ...i,
      children: t
    }
  );
}, nr = {
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
  overflow: "hidden"
}, $o = ({
  anchorRef: e,
  menuOpen: t,
  onMenuClose: r,
  onOrgClick: i
}) => {
  const { t: o } = R(), { userOrganizations: a, setIsOrgDialogOpen: s, organization: l } = B(), { recentOrganizations: c } = Me(), d = c && (c == null ? void 0 : c.length) > 0, p = () => {
    r(), s(!0);
  }, u = (d ? c : a).slice(0, P.OrgMenuMax).map((f) => {
    const g = f.organizationName;
    return /* @__PURE__ */ n(
      De,
      {
        sx: {
          padding: "12px 8px 12px 12px"
        },
        selected: g === (l == null ? void 0 : l.organizationName),
        title: g,
        onClick: () => i(g),
        children: /* @__PURE__ */ n(A, { sx: nr, variant: "body1", children: g })
      },
      g
    );
  });
  return /* @__PURE__ */ n(
    Et,
    {
      anchorRef: e,
      ctaTitle: o("ORG_CONTEXT.MENU.MANAGE_ALL_ORGS"),
      menuTitle: o("ORG_CONTEXT.MENU.TITLE"),
      menuOpen: t,
      onCtaClick: p,
      onMenuClose: r,
      menuPaperSx: {
        maxHeight: "400px"
      },
      children: u
    }
  );
}, Rc = ({
  config: e = Pe()
}) => {
  const { t } = R(), [r, i] = E(!1), {
    isLoading: o,
    isLoadingOrg: a,
    organization: s,
    userOrganizations: l,
    updateOrganization: c
  } = B(), d = D(null), { isRecentOrganizationsLoading: p, isRecentOrganizationsMutating: h } = Me(), u = Z(), f = !o && l.length === 0, C = (h || p || a) && !f, x = () => {
    i(!0);
  }, O = () => {
    i(!1);
  }, v = (y) => {
    O(), c(y);
  };
  let T;
  return f ? T = t("ORG_CONTEXT.SWITCHER.EMPTY") : s ? T = s == null ? void 0 : s.organizationName : T = t("ORG_CONTEXT.SWITCHER.SELECT"), /* @__PURE__ */ n(Nn, { children: /* @__PURE__ */ m(gt, { config: e || {}, children: [
    /* @__PURE__ */ n(
      $t,
      {
        label: T,
        disabled: o,
        isReadOnly: !C && l.length == 1,
        isLoading: C,
        isEmpty: f,
        onClick: x,
        startIcon: /* @__PURE__ */ n(ft, { startIcon: /* @__PURE__ */ n(On, {}), isLoading: C }),
        labelSx: {
          display: u ? "none" : void 0
        },
        showEndIcon: !u,
        ref: d,
        "data-element-id": "org-switcher-nav-button",
        "aria-label": `Organization switcher, selected organization: ${s == null ? void 0 : s.organizationName}`
      }
    ),
    u ? /* @__PURE__ */ n(
      Go,
      {
        menuOpen: r,
        onMenuOpen: x,
        onMenuClose: O,
        onOrgClick: v
      }
    ) : /* @__PURE__ */ n(
      $o,
      {
        anchorRef: d,
        menuOpen: r,
        onMenuClose: O,
        onOrgClick: v
      }
    ),
    /* @__PURE__ */ n(Vo, {})
  ] }) });
}, Zo = 6e4 * 60, rr = () => `${_.Services.FrontDoor}/applications`, Yo = (e) => e.findIndex((t) => t.name === In), ir = (e) => e.sort((t, r) => {
  const i = (t.displayName || t.name).toLowerCase(), o = (r.displayName || r.name).toLowerCase();
  return i < o ? -1 : i > o ? 1 : 0;
}), or = (e) => {
  const t = Yo(e);
  if (t !== -1) {
    const r = e.splice(t, 1)[0];
    e.unshift(r);
  }
  return e;
}, qo = () => ce(`${rr()}/grants`).then(ir).then(or).catch(G), jo = () => ce(`${rr()}/all-applications`).then(ir).then(or).catch(G), Xo = () => {
  const { isAuthenticated: e } = V(), [t, r] = E(), [i, o] = E(!1), [a, s] = E(), l = z(async () => {
    try {
      o(!0);
      const c = await jo();
      r(c), localStorage.setItem(P.ApplicationsListCacheKey, JSON.stringify({ applications: c, lastUpdated: (/* @__PURE__ */ new Date()).getTime() }));
    } catch (c) {
      s(c);
    } finally {
      o(!1);
    }
  }, [o, r]);
  return S(function() {
    if (e === void 0 || e)
      return;
    const d = localStorage.getItem(P.ApplicationsListCacheKey);
    if (!d) {
      l();
      return;
    }
    const p = JSON.parse(d);
    if (!p.applications || isNaN(p.lastUpdated)) {
      l();
      return;
    }
    (/* @__PURE__ */ new Date()).getTime() - p.lastUpdated > Zo ? l() : r(p.applications);
  }, [e, l, r]), {
    data: t,
    isLoading: i,
    error: a
  };
}, Ko = (e, t = {}) => {
  var r = e == null ? void 0 : e.organizationName;
  const {
    data: i,
    isLoading: o,
    error: a
  } = Ft(
    r ? to(r) : null,
    qo,
    t
  );
  return {
    data: i,
    isLoading: o,
    error: a
  };
}, Qo = (e) => ({
  name: e.name,
  displayName: e.displayName,
  baseUrl: e.baseUrl,
  redirectUrl: e.redirectUrl,
  imageUrl: e.imageUrl
}), Jo = (e) => e.find((t) => t.name === In), ea = (e, t, r) => {
  let i;
  if (r && (i = e.find((o) => o.name === r)), !i) {
    const o = window.location.hostname;
    i = e.find((a) => {
      var s;
      return (s = a.baseUrl) == null ? void 0 : s.includes(o);
    });
  }
  return i || console.warn(t("WARNINGS.NO_DEFAULT_APPLICATION")), i;
}, bt = (e) => e || [], ta = (e) => e.filter((t) => !!t.baseUrl), bc = ({
  defaultApp: e,
  children: t
}) => {
  const { t: r } = R(), { isAuthenticated: i } = V(), { organization: o } = B(), [a, s] = E(!1), [l, c] = E(!1), [d, p] = E(), [h, u] = E(), {
    data: f,
    isLoading: g,
    error: C
  } = Ko(o), {
    data: x,
    isLoading: O,
    error: v
  } = Xo(), T = z(() => ta(bt(i ? f : x)), [i, x, f]), y = z(
    (I) => {
      const L = ea(I, r, e), W = Jo(I), U = L ?? W ?? I[0];
      return Qo(U);
    },
    [r, e]
  );
  S(
    function() {
      f ? u(y(f)) : x && u(y(x));
    },
    [y, f, x, u]
  ), S(
    function() {
      if (d) {
        c(!1);
        return;
      }
      c(g || O);
    },
    [O, g, d, c]
  ), S(
    function() {
      p(C || v);
    },
    [p, C, v]
  ), S(
    function() {
      !l && f && (f == null ? void 0 : f.length) === 0 && (o != null && o.organizationName) && console.warn(r("WARNINGS.NO_APPLICATIONS", { org: o.organizationName }));
    },
    [f, o, l, r]
  );
  const M = j(
    () => ({
      isAppDialogOpen: a,
      setIsAppDialogOpen: s,
      getSwitcherList: T,
      application: h,
      userApplications: bt(f),
      allApplications: bt(x),
      isLoading: l,
      error: d
    }),
    [
      h,
      f,
      l,
      d,
      a,
      s,
      T
    ]
  );
  return /* @__PURE__ */ n(zn.Provider, { value: M, children: t });
}, Xt = (e, t) => {
  if (!t) return "";
  let r = new URL(t);
  return e && r.searchParams.set(Ge.organization, e), r.href;
}, na = (e) => {
  const { t } = R();
  return /* @__PURE__ */ m(
    "svg",
    {
      ...e,
      width: "22",
      height: "22",
      role: "img",
      viewBox: "0 0 22 22",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ n("title", { children: t("APPLICATION_CONTEXT.SWITCHER.DEFAULT_ICON_ALT") }),
        /* @__PURE__ */ n("g", { id: "Design", children: /* @__PURE__ */ m("g", { id: "Group", children: [
          /* @__PURE__ */ n(
            "path",
            {
              id: "Vector",
              d: "M10.9999 12.3285C11.7336 12.3285 12.3284 11.7337 12.3284 11.0001C12.3284 10.2664 11.7336 9.67163 10.9999 9.67163C10.2663 9.67163 9.67151 10.2664 9.67151 11.0001C9.67151 11.7337 10.2663 12.3285 10.9999 12.3285Z",
              fill: "#5F249F"
            }
          ),
          /* @__PURE__ */ n(
            "path",
            {
              id: "Vector_2",
              d: "M14.2408 12.3285C14.9745 12.3285 15.5692 11.7337 15.5692 11.0001C15.5692 10.2664 14.9745 9.67163 14.2408 9.67163C13.5071 9.67163 12.9124 10.2664 12.9124 11.0001C12.9124 11.7337 13.5071 12.3285 14.2408 12.3285Z",
              fill: "#5F249F"
            }
          ),
          /* @__PURE__ */ n(
            "path",
            {
              id: "Vector_3",
              d: "M17.4803 12.3285C18.214 12.3285 18.8087 11.7337 18.8087 11.0001C18.8087 10.2664 18.214 9.67163 17.4803 9.67163C16.7466 9.67163 16.1519 10.2664 16.1519 11.0001C16.1519 11.7337 16.7466 12.3285 17.4803 12.3285Z",
              fill: "#5F249F"
            }
          ),
          /* @__PURE__ */ n(
            "path",
            {
              id: "Vector_4",
              d: "M20.3963 12.0037C20.9506 12.0037 21.3999 11.5543 21.3999 11C21.3999 10.4457 20.9506 9.99634 20.3963 9.99634C19.8419 9.99634 19.3926 10.4457 19.3926 11C19.3926 11.5543 19.8419 12.0037 20.3963 12.0037Z",
              fill: "#5F249F"
            }
          ),
          /* @__PURE__ */ n(
            "path",
            {
              id: "Vector_5",
              d: "M20.3963 8.50394C20.8068 8.50394 21.1397 8.17109 21.1397 7.76051C21.1397 7.34993 20.8068 7.01709 20.3963 7.01709C19.9857 7.01709 19.6528 7.34993 19.6528 7.76051C19.6528 8.17109 19.9857 8.50394 20.3963 8.50394Z",
              fill: "#5F249F"
            }
          ),
          /* @__PURE__ */ n(
            "path",
            {
              id: "Vector_6",
              d: "M20.3963 14.9842C20.8068 14.9842 21.1397 14.6513 21.1397 14.2407C21.1397 13.8302 20.8068 13.4973 20.3963 13.4973C19.9857 13.4973 19.6528 13.8302 19.6528 14.2407C19.6528 14.6513 19.9857 14.9842 20.3963 14.9842Z",
              fill: "#5F249F"
            }
          ),
          /* @__PURE__ */ n(
            "path",
            {
              id: "Vector_7",
              d: "M11 2.60745C11.5543 2.60745 12.0037 2.15809 12.0037 1.60378C12.0037 1.04946 11.5543 0.600098 11 0.600098C10.4457 0.600098 9.99634 1.04946 9.99634 1.60378C9.99634 2.15809 10.4457 2.60745 11 2.60745Z",
              fill: "#5F249F"
            }
          ),
          /* @__PURE__ */ n(
            "path",
            {
              id: "Vector_8",
              d: "M4.51967 5.52347C5.07398 5.52347 5.52335 5.07411 5.52335 4.51979C5.52335 3.96547 5.07398 3.51611 4.51967 3.51611C3.96535 3.51611 3.51599 3.96547 3.51599 4.51979C3.51599 5.07411 3.96535 5.52347 4.51967 5.52347Z",
              fill: "#5F249F"
            }
          ),
          /* @__PURE__ */ n(
            "path",
            {
              id: "Vector_9",
              d: "M4.51967 18.4842C5.07398 18.4842 5.52335 18.0348 5.52335 17.4805C5.52335 16.9262 5.07398 16.4768 4.51967 16.4768C3.96535 16.4768 3.51599 16.9262 3.51599 17.4805C3.51599 18.0348 3.96535 18.4842 4.51967 18.4842Z",
              fill: "#5F249F"
            }
          ),
          /* @__PURE__ */ n(
            "path",
            {
              id: "Vector_10",
              d: "M17.4804 5.52347C18.0347 5.52347 18.484 5.07411 18.484 4.51979C18.484 3.96547 18.0347 3.51611 17.4804 3.51611C16.926 3.51611 16.4767 3.96547 16.4767 4.51979C16.4767 5.07411 16.926 5.52347 17.4804 5.52347Z",
              fill: "#5F249F"
            }
          ),
          /* @__PURE__ */ n(
            "path",
            {
              id: "Vector_11",
              d: "M17.4804 18.4842C18.0347 18.4842 18.484 18.0348 18.484 17.4805C18.484 16.9262 18.0347 16.4768 17.4804 16.4768C16.926 16.4768 16.4767 16.9262 16.4767 17.4805C16.4767 18.0348 16.926 18.4842 17.4804 18.4842Z",
              fill: "#5F249F"
            }
          ),
          /* @__PURE__ */ n(
            "path",
            {
              id: "Vector_12",
              d: "M7.76039 2.3472C8.17097 2.3472 8.50381 2.01436 8.50381 1.60377C8.50381 1.19319 8.17097 0.860352 7.76039 0.860352C7.34981 0.860352 7.01697 1.19319 7.01697 1.60377C7.01697 2.01436 7.34981 2.3472 7.76039 2.3472Z",
              fill: "#5F249F"
            }
          ),
          /* @__PURE__ */ n(
            "path",
            {
              id: "Vector_13",
              d: "M14.2407 2.3472C14.6513 2.3472 14.9842 2.01436 14.9842 1.60377C14.9842 1.19319 14.6513 0.860352 14.2407 0.860352C13.8302 0.860352 13.4973 1.19319 13.4973 1.60377C13.4973 2.01436 13.8302 2.3472 14.2407 2.3472Z",
              fill: "#5F249F"
            }
          ),
          /* @__PURE__ */ n(
            "path",
            {
              id: "Vector_14",
              d: "M1.60365 12.0037C2.15797 12.0037 2.60733 11.5543 2.60733 11C2.60733 10.4457 2.15797 9.99634 1.60365 9.99634C1.04934 9.99634 0.599976 10.4457 0.599976 11C0.599976 11.5543 1.04934 12.0037 1.60365 12.0037Z",
              fill: "#5F249F"
            }
          ),
          /* @__PURE__ */ n(
            "path",
            {
              id: "Vector_15",
              d: "M1.60365 14.9842C2.01423 14.9842 2.34708 14.6513 2.34708 14.2407C2.34708 13.8302 2.01423 13.4973 1.60365 13.4973C1.19307 13.4973 0.860229 13.8302 0.860229 14.2407C0.860229 14.6513 1.19307 14.9842 1.60365 14.9842Z",
              fill: "#5F249F"
            }
          ),
          /* @__PURE__ */ n(
            "path",
            {
              id: "Vector_16",
              d: "M1.60365 8.50394C2.01423 8.50394 2.34708 8.17109 2.34708 7.76051C2.34708 7.34993 2.01423 7.01709 1.60365 7.01709C1.19307 7.01709 0.860229 7.34993 0.860229 7.76051C0.860229 8.17109 1.19307 8.50394 1.60365 8.50394Z",
              fill: "#5F249F"
            }
          ),
          /* @__PURE__ */ n(
            "path",
            {
              id: "Vector_17",
              d: "M11 21.4002C11.5543 21.4002 12.0037 20.9508 12.0037 20.3965C12.0037 19.8422 11.5543 19.3928 11 19.3928C10.4457 19.3928 9.99634 19.8422 9.99634 20.3965C9.99634 20.9508 10.4457 21.4002 11 21.4002Z",
              fill: "#5F249F"
            }
          ),
          /* @__PURE__ */ n(
            "path",
            {
              id: "Vector_18",
              d: "M14.2407 21.1399C14.6513 21.1399 14.9842 20.8071 14.9842 20.3965C14.9842 19.9859 14.6513 19.6531 14.2407 19.6531C13.8302 19.6531 13.4973 19.9859 13.4973 20.3965C13.4973 20.8071 13.8302 21.1399 14.2407 21.1399Z",
              fill: "#5F249F"
            }
          ),
          /* @__PURE__ */ n(
            "path",
            {
              id: "Vector_19",
              d: "M7.76039 21.1399C8.17097 21.1399 8.50381 20.8071 8.50381 20.3965C8.50381 19.9859 8.17097 19.6531 7.76039 19.6531C7.34981 19.6531 7.01697 19.9859 7.01697 20.3965C7.01697 20.8071 7.34981 21.1399 7.76039 21.1399Z",
              fill: "#5F249F"
            }
          ),
          /* @__PURE__ */ n(
            "path",
            {
              id: "Vector_20",
              d: "M7.76044 12.3285C8.49411 12.3285 9.08887 11.7337 9.08887 11.0001C9.08887 10.2664 8.49411 9.67163 7.76044 9.67163C7.02676 9.67163 6.43201 10.2664 6.43201 11.0001C6.43201 11.7337 7.02676 12.3285 7.76044 12.3285Z",
              fill: "#5F249F"
            }
          ),
          /* @__PURE__ */ n(
            "path",
            {
              id: "Vector_21",
              d: "M4.51959 12.3285C5.25326 12.3285 5.84802 11.7337 5.84802 11.0001C5.84802 10.2664 5.25326 9.67163 4.51959 9.67163C3.78592 9.67163 3.19116 10.2664 3.19116 11.0001C3.19116 11.7337 3.78592 12.3285 4.51959 12.3285Z",
              fill: "#5F249F"
            }
          ),
          /* @__PURE__ */ n(
            "path",
            {
              id: "Vector_22",
              d: "M10.9999 9.08899C11.7336 9.08899 12.3284 8.49423 12.3284 7.76056C12.3284 7.02689 11.7336 6.43213 10.9999 6.43213C10.2663 6.43213 9.67151 7.02689 9.67151 7.76056C9.67151 8.49423 10.2663 9.08899 10.9999 9.08899Z",
              fill: "#5F249F"
            }
          ),
          /* @__PURE__ */ n(
            "path",
            {
              id: "Vector_23",
              d: "M10.9999 15.5692C11.7336 15.5692 12.3284 14.9745 12.3284 14.2408C12.3284 13.5071 11.7336 12.9124 10.9999 12.9124C10.2663 12.9124 9.67151 13.5071 9.67151 14.2408C9.67151 14.9745 10.2663 15.5692 10.9999 15.5692Z",
              fill: "#5F249F"
            }
          ),
          /* @__PURE__ */ n(
            "path",
            {
              id: "Vector_24",
              d: "M14.2408 9.08899C14.9745 9.08899 15.5692 8.49423 15.5692 7.76056C15.5692 7.02689 14.9745 6.43213 14.2408 6.43213C13.5071 6.43213 12.9124 7.02689 12.9124 7.76056C12.9124 8.49423 13.5071 9.08899 14.2408 9.08899Z",
              fill: "#5F249F"
            }
          ),
          /* @__PURE__ */ n(
            "path",
            {
              id: "Vector_25",
              d: "M14.2408 15.5692C14.9745 15.5692 15.5692 14.9745 15.5692 14.2408C15.5692 13.5071 14.9745 12.9124 14.2408 12.9124C13.5071 12.9124 12.9124 13.5071 12.9124 14.2408C12.9124 14.9745 13.5071 15.5692 14.2408 15.5692Z",
              fill: "#5F249F"
            }
          ),
          /* @__PURE__ */ n(
            "path",
            {
              id: "Vector_26",
              d: "M17.4803 9.08899C18.214 9.08899 18.8087 8.49423 18.8087 7.76056C18.8087 7.02689 18.214 6.43213 17.4803 6.43213C16.7466 6.43213 16.1519 7.02689 16.1519 7.76056C16.1519 8.49423 16.7466 9.08899 17.4803 9.08899Z",
              fill: "#5F249F"
            }
          ),
          /* @__PURE__ */ n(
            "path",
            {
              id: "Vector_27",
              d: "M17.4803 15.5692C18.214 15.5692 18.8087 14.9745 18.8087 14.2408C18.8087 13.5071 18.214 12.9124 17.4803 12.9124C16.7466 12.9124 16.1519 13.5071 16.1519 14.2408C16.1519 14.9745 16.7466 15.5692 17.4803 15.5692Z",
              fill: "#5F249F"
            }
          ),
          /* @__PURE__ */ n(
            "path",
            {
              id: "Vector_28",
              d: "M7.76044 9.08899C8.49411 9.08899 9.08887 8.49423 9.08887 7.76056C9.08887 7.02689 8.49411 6.43213 7.76044 6.43213C7.02676 6.43213 6.43201 7.02689 6.43201 7.76056C6.43201 8.49423 7.02676 9.08899 7.76044 9.08899Z",
              fill: "#5F249F"
            }
          ),
          /* @__PURE__ */ n(
            "path",
            {
              id: "Vector_29",
              d: "M7.76044 15.5692C8.49411 15.5692 9.08887 14.9745 9.08887 14.2408C9.08887 13.5071 8.49411 12.9124 7.76044 12.9124C7.02676 12.9124 6.43201 13.5071 6.43201 14.2408C6.43201 14.9745 7.02676 15.5692 7.76044 15.5692Z",
              fill: "#5F249F"
            }
          ),
          /* @__PURE__ */ n(
            "path",
            {
              id: "Vector_30",
              d: "M4.51959 9.08899C5.25326 9.08899 5.84802 8.49423 5.84802 7.76056C5.84802 7.02689 5.25326 6.43213 4.51959 6.43213C3.78592 6.43213 3.19116 7.02689 3.19116 7.76056C3.19116 8.49423 3.78592 9.08899 4.51959 9.08899Z",
              fill: "#5F249F"
            }
          ),
          /* @__PURE__ */ n(
            "path",
            {
              id: "Vector_31",
              d: "M4.51959 15.5692C5.25326 15.5692 5.84802 14.9745 5.84802 14.2408C5.84802 13.5071 5.25326 12.9124 4.51959 12.9124C3.78592 12.9124 3.19116 13.5071 3.19116 14.2408C3.19116 14.9745 3.78592 15.5692 4.51959 15.5692Z",
              fill: "#5F249F"
            }
          ),
          /* @__PURE__ */ n(
            "path",
            {
              id: "Vector_32",
              d: "M10.9999 5.84827C11.7336 5.84827 12.3284 5.25351 12.3284 4.51984C12.3284 3.78616 11.7336 3.19141 10.9999 3.19141C10.2663 3.19141 9.67151 3.78616 9.67151 4.51984C9.67151 5.25351 10.2663 5.84827 10.9999 5.84827Z",
              fill: "#5F249F"
            }
          ),
          /* @__PURE__ */ n(
            "path",
            {
              id: "Vector_33",
              d: "M10.9999 18.809C11.7336 18.809 12.3284 18.2142 12.3284 17.4805C12.3284 16.7469 11.7336 16.1521 10.9999 16.1521C10.2663 16.1521 9.67151 16.7469 9.67151 17.4805C9.67151 18.2142 10.2663 18.809 10.9999 18.809Z",
              fill: "#5F249F"
            }
          ),
          /* @__PURE__ */ n(
            "path",
            {
              id: "Vector_34",
              d: "M7.76044 5.84827C8.49411 5.84827 9.08887 5.25351 9.08887 4.51984C9.08887 3.78616 8.49411 3.19141 7.76044 3.19141C7.02676 3.19141 6.43201 3.78616 6.43201 4.51984C6.43201 5.25351 7.02676 5.84827 7.76044 5.84827Z",
              fill: "#5F249F"
            }
          ),
          /* @__PURE__ */ n(
            "path",
            {
              id: "Vector_35",
              d: "M14.2408 5.84827C14.9745 5.84827 15.5692 5.25351 15.5692 4.51984C15.5692 3.78616 14.9745 3.19141 14.2408 3.19141C13.5071 3.19141 12.9124 3.78616 12.9124 4.51984C12.9124 5.25351 13.5071 5.84827 14.2408 5.84827Z",
              fill: "#5F249F"
            }
          ),
          /* @__PURE__ */ n(
            "path",
            {
              id: "Vector_36",
              d: "M7.76044 18.809C8.49411 18.809 9.08887 18.2142 9.08887 17.4805C9.08887 16.7469 8.49411 16.1521 7.76044 16.1521C7.02676 16.1521 6.43201 16.7469 6.43201 17.4805C6.43201 18.2142 7.02676 18.809 7.76044 18.809Z",
              fill: "#5F249F"
            }
          ),
          /* @__PURE__ */ n(
            "path",
            {
              id: "Vector_37",
              d: "M14.2408 18.809C14.9745 18.809 15.5692 18.2142 15.5692 17.4805C15.5692 16.7469 14.9745 16.1521 14.2408 16.1521C13.5071 16.1521 12.9124 16.7469 12.9124 17.4805C12.9124 18.2142 13.5071 18.809 14.2408 18.809Z",
              fill: "#5F249F"
            }
          )
        ] }) })
      ]
    }
  );
}, ar = ({
  imageUrl: e,
  appName: t
}) => {
  const { t: r } = R(), i = t ? r("APPLICATION_CONTEXT.SWITCHER.ICON_ALT", { appName: t }) : "";
  return /* @__PURE__ */ n(N, { flexShrink: 0, borderRadius: "6px", overflow: "hidden", height: "32px", width: "32px", "aria-hidden": "true", children: e ? /* @__PURE__ */ n(
    "img",
    {
      alt: i,
      src: e,
      style: {
        width: "100%",
        height: "100%",
        objectFit: "cover"
      }
    }
  ) : /* @__PURE__ */ n(
    na,
    {
      style: {
        width: "100%",
        height: "100%",
        padding: "2px"
      }
    }
  ) });
}, Kt = ({
  app: e,
  sx: t = {}
}) => {
  const r = e.displayName || e.name;
  return /* @__PURE__ */ m(b, { alignItems: "center", sx: t, width: "100%", columnGap: "8px", direction: "row", children: [
    /* @__PURE__ */ n(ar, { imageUrl: e == null ? void 0 : e.imageUrl, appName: r }),
    /* @__PURE__ */ n(A, { variant: "body1", sx: nr, children: r })
  ] });
}, ra = ({
  onAppClick: e
}) => {
  const { t } = R(), { getSwitcherList: r, application: i } = ye(), { organization: o } = B(), a = r();
  return a.length === 0 ? /* @__PURE__ */ n(N, { sx: { px: "24px" }, children: /* @__PURE__ */ n(A, { variant: "body1", children: t("APPLICATION_CONTEXT.DIALOG.NO_RESULTS") }) }) : /* @__PURE__ */ n(Ze, { disablePadding: !0, children: a.map((s) => {
    const l = s.name;
    return /* @__PURE__ */ n(
      Kn,
      {
        buttonProps: {
          href: Xt(
            o == null ? void 0 : o.organizationName,
            s.baseUrl || s.redirectUrl
          ),
          target: "_blank",
          component: Ye
        },
        selected: l === (i == null ? void 0 : i.name),
        onListItemButtonClick: () => e(s.name),
        children: /* @__PURE__ */ n(Kt, { app: s })
      },
      l
    );
  }) });
}, ia = () => _.Services.FrontDoor, oa = (e, t, r) => Mn(
  `${ia()}${e}`,
  {
    applicationName: t
  },
  {
    headers: {
      [P.OrgHeader]: r.organizationName
    }
  }
).catch(G), Qt = () => {
  const e = "/applications/recent", [t, r] = E(), [i, o] = E(!1);
  return {
    pushRecentApplication: z(
      async (s, l) => {
        try {
          if (!l)
            throw new Error();
          o(!0), await oa(e, s, l).catch(
            G
          ), o(!1);
        } catch (c) {
          r(c);
        }
      },
      [o, r]
    ),
    recentApplicationsMutationError: t,
    isRecentApplicationsMutating: i
  };
}, aa = () => {
  const { t: e } = R(), { isAppDialogOpen: t, setIsAppDialogOpen: r } = ye(), { organization: i } = B(), { pushRecentApplication: o } = Qt(), a = (l) => {
    o(l, i), r(!1);
  }, s = () => {
    r(!1);
  };
  return /* @__PURE__ */ n(
    $n,
    {
      isOpen: t,
      dialogTitle: e("APPLICATION_CONTEXT.MENU.TITLE"),
      dialogCloseTitle: e("APPLICATION_CONTEXT.ACCESSIBILITY.CLOSE"),
      onClose: s,
      children: /* @__PURE__ */ n(ra, { onAppClick: a })
    }
  );
}, sa = ({
  applications: e,
  menuOpen: t,
  onMenuOpen: r,
  onMenuClose: i
}) => {
  const { t: o } = R(), { setIsAppDialogOpen: a, application: s } = Vn(), { organization: l } = B(), { pushRecentApplication: c } = Qt(), d = (u) => {
    c(u, l), i();
  }, p = () => {
    i(), a(!0);
  }, h = e.slice(0, P.AppMenuMax).map((u) => /* @__PURE__ */ n(
    tr,
    {
      component: Ye,
      href: Xt(
        l == null ? void 0 : l.organizationName,
        u.baseUrl || u.redirectUrl
      ),
      target: "_blank",
      selected: u.name === (s == null ? void 0 : s.name),
      onClick: () => d(u.name),
      children: /* @__PURE__ */ n(Kt, { app: u })
    },
    u.name
  ));
  return /* @__PURE__ */ n(
    er,
    {
      menuOpen: t,
      menuTitle: o("APPLICATION_CONTEXT.MENU.TITLE"),
      menuCloseTitle: o("APPLICATION_CONTEXT.ACCESSIBILITY.CLOSE"),
      ctaTitle: o("APPLICATION_CONTEXT.MENU.MANAGE_ALL_APPS"),
      onMenuClose: i,
      onMenuOpen: r,
      onCtaClick: p,
      children: h
    }
  );
}, la = ({
  applications: e,
  anchorRef: t,
  menuOpen: r,
  onMenuClose: i
}) => {
  const { t: o } = R(), { application: a, setIsAppDialogOpen: s } = Vn(), { organization: l } = B(), { pushRecentApplication: c } = Qt(), d = (u) => {
    c(u, l), i();
  }, p = () => {
    i(), s(!0);
  }, h = e.slice(0, P.AppMenuMax).map((u) => {
    const f = u.displayName || u.name;
    return /* @__PURE__ */ n(
      De,
      {
        selected: u.name === (a == null ? void 0 : a.name),
        component: Ye,
        href: Xt(
          l == null ? void 0 : l.organizationName,
          u.baseUrl || u.redirectUrl
        ),
        title: f,
        target: "_blank",
        onClick: () => d(u.name),
        "aria-label": `link ${f}`,
        children: /* @__PURE__ */ n(Kt, { app: u })
      },
      u.name
    );
  });
  return /* @__PURE__ */ n(
    Et,
    {
      anchorRef: t,
      ctaTitle: o("APPLICATION_CONTEXT.MENU.MANAGE_ALL_APPS"),
      menuTitle: o("APPLICATION_CONTEXT.MENU.TITLE"),
      menuOpen: r,
      onCtaClick: p,
      onMenuClose: i,
      children: h
    }
  );
}, ca = ({
  isLoading: e,
  isEmpty: t,
  startIcon: r,
  sx: i = {}
}) => {
  const o = X(), s = e || t ? {
    borderRadius: "8px",
    border: "1px solid",
    borderColor: t ? "currentColor" : re.otherSurfaceBorder[o.palette.mode]
  } : void 0;
  let l;
  return e ? l = /* @__PURE__ */ n(
    Mt,
    {
      sx: {
        color: o.palette.action.active
      },
      size: "16px"
    }
  ) : t ? l = /* @__PURE__ */ n(
    Gr,
    {
      sx: {
        height: "20px",
        width: "20px"
      }
    }
  ) : l = r, /* @__PURE__ */ m(b, { direction: "row", alignItems: "center", sx: i, children: [
    /* @__PURE__ */ n(b, { justifyContent: "center", alignItems: "center", px: "8px", children: /* @__PURE__ */ n(Br, { sx: { height: "20px", width: "20px" } }) }),
    /* @__PURE__ */ n(N, { sx: s, height: "32px", width: "32px", children: l })
  ] });
}, Nc = ({
  isDisplayMode: e = !1,
  config: t = Pe(),
  onClick: r,
  onClose: i
}) => {
  const { t: o } = R(), [a, s] = E(!1), { isAuthenticated: l } = V(), { isLoadingOrg: c, error: d } = B(), {
    isLoading: p,
    application: h,
    error: u,
    getSwitcherList: f
  } = ye(), g = D(null), C = Z(), x = f(), O = () => {
    r && r(), e || s(!0);
  }, v = () => {
    i && i(), s(!1);
  }, T = (h == null ? void 0 : h.displayName) || (h == null ? void 0 : h.name), y = !u && !d, L = l ? y && (p || c) : y && p, W = x.length === 0 && !L;
  let U;
  W ? U = o("APPLICATION_CONTEXT.SWITCHER.EMPTY") : h ? U = T : U = o("APPLICATION_CONTEXT.SWITCHER.SELECT");
  const F = j(
    () => /* @__PURE__ */ n(ar, { imageUrl: h == null ? void 0 : h.imageUrl, appName: T }),
    [h == null ? void 0 : h.imageUrl, T]
  );
  return /* @__PURE__ */ n(Nn, { children: /* @__PURE__ */ m(gt, { config: t || {}, children: [
    /* @__PURE__ */ n(
      $t,
      {
        isReadOnly: !L && x.length == 1 && !e,
        isLoading: L,
        isEmpty: W && !e,
        onClick: O,
        "aria-label": `Application switcher, selected application: ${h == null ? void 0 : h.name}`,
        ref: g,
        "data-element-id": "app-switcher-nav-button",
        startIcon: e ? /* @__PURE__ */ n(
          ca,
          {
            isLoading: L,
            isEmpty: W,
            startIcon: F
          }
        ) : /* @__PURE__ */ n(ft, { isLoading: L, startIcon: F }),
        label: U,
        labelSx: {
          display: e ? "none" : void 0
        },
        showEndIcon: !e
      }
    ),
    C ? /* @__PURE__ */ n(
      sa,
      {
        applications: x,
        menuOpen: a,
        onMenuOpen: O,
        onMenuClose: v
      }
    ) : /* @__PURE__ */ n(
      la,
      {
        applications: x,
        anchorRef: g,
        menuOpen: a,
        onMenuClose: v
      }
    ),
    /* @__PURE__ */ n(aa, {})
  ] }) });
};
function da(e) {
  return /* @__PURE__ */ n(dt, { ...e, direction: "left" });
}
const Nt = {
  message: "",
  anchorOrigin: { horizontal: "right", vertical: "top" },
  color: "info",
  autoHideDuration: 5e3,
  open: !1
}, sr = te(void 0), Ee = () => {
  const e = ne(sr);
  if (!e)
    throw new Error(
      "<RccContextProvider/> is most likely not wrapped around the component / provider you are trying to use. To use SnackbarContext, it must be wrapped in <SnackbarContextProvider/>"
    );
  return e;
}, ua = ({
  snackOptions: e,
  handleSnackClose: t
}) => /* @__PURE__ */ n(
  br,
  {
    open: e.open,
    anchorOrigin: e.anchorOrigin,
    color: e.color,
    onClose: t,
    autoHideDuration: e.autoHideDuration,
    ClickAwayListenerProps: {
      onClickAway: () => {
      }
    },
    TransitionComponent: da,
    children: /* @__PURE__ */ n(
      nt,
      {
        action: /* @__PURE__ */ n(
          ie,
          {
            "aria-label": "close",
            color: "inherit",
            size: "small",
            onClick: t,
            children: /* @__PURE__ */ n(ct, { fontSize: "inherit" })
          }
        ),
        severity: e.color,
        children: e.message
      }
    )
  }
), pa = ({ children: e }) => {
  const [t, r] = E({ ...Nt }), i = D({ ...Nt }), o = Z(), a = z(
    (c) => {
      r({
        ...i.current,
        ...c
      });
    },
    [r]
  ), s = () => {
    a({ open: !1 });
  }, l = j(
    () => ({
      snackOptions: t,
      setSnackOptions: a
    }),
    [t, a]
  );
  return S(() => {
    const c = { horizontal: "right", vertical: "top" }, d = { horizontal: "center", vertical: "bottom" };
    i.current = {
      ...Nt,
      anchorOrigin: o ? d : c
    };
  }, [o]), /* @__PURE__ */ m(sr.Provider, { value: l, children: [
    /* @__PURE__ */ n(ua, { snackOptions: t, handleSnackClose: s }),
    e
  ] });
};
let Ae = {
  navigate: void 0
};
function ha(e) {
  Ae = { ...Ae, ...e };
}
const ma = (e, t) => {
  if ("URLSearchParams" in window) {
    const r = new URL(window.location.toString());
    t === void 0 ? r.searchParams.delete(e) : r.searchParams.set(e, t), Ae.navigate ? Ae.navigate(r.pathname + r.search) : window.history.pushState(null, "", r);
  }
}, lr = (e) => "URLSearchParams" in window ? new URLSearchParams(window.location.search).get(e) : null, Jt = () => {
  const [e, t] = E();
  return S(() => {
    const r = () => {
      t(window.location);
    };
    return r(), window.addEventListener("popstate", r), () => {
      window.removeEventListener("popstate", r);
    };
  }, []), e;
};
function cr(e, t) {
  if (Ae.navigate) {
    Ae.navigate(e, t);
    return;
  }
  const i = fa(e) && !e.startsWith(window.location.origin) ? new URL(e) : new URL(e, window.location.origin);
  t != null && t.target ? window.open(i.toString(), t.target) : window.location.replace(i);
}
function fa(e) {
  let t;
  try {
    t = new URL(e);
  } catch {
    return !1;
  }
  return t.protocol === "http:" || t.protocol === "https:";
}
const ga = (e, t, r, i, o, a) => {
  const [s, l] = E(), { isAuthenticated: c } = V(), d = c && t == e && !a && s !== void 0, { organizationData: p, errorOrg: h } = je(d ? s : void 0);
  return S(
    function() {
      if (c) {
        const f = lr(Ge.organization) ?? "";
        l(f);
      }
    },
    [c]
  ), S(() => {
    if (d) {
      if (!s || h) {
        r((u) => ++u);
        return;
      }
      p && (i(p), o(!0));
    }
  }, [
    h,
    d,
    s,
    p,
    i,
    o,
    r
  ]), p == null ? void 0 : p.organizationName;
}, Ca = (e, t, r, i, o, a) => {
  const { isAuthenticated: s } = V(), { userPreferences: l, isUserPreferencesLoading: c } = vo(), d = s && t == e && !c && !a, { organizationData: p, errorOrg: h } = je(
    d ? l == null ? void 0 : l.defaultOrganizationId : void 0
  );
  return S(() => {
    if (d) {
      if (l && !l.defaultOrganizationId || h) {
        r((u) => ++u);
        return;
      }
      p && (i(p), o(!0));
    }
  }, [
    d,
    h,
    l,
    p,
    i,
    o,
    r
  ]), p == null ? void 0 : p.organizationName;
}, Ea = (e, t, r, i, o, a, s, l) => {
  const { isAuthenticated: c } = V(), d = c && t == e && !s && !a, p = (l == null ? void 0 : l.length) > 0 ? l[0] : null, { organizationData: h, errorOrg: u } = je(
    d ? p == null ? void 0 : p.organizationName : void 0
  );
  return S(() => {
    if (d) {
      if (u || (l == null ? void 0 : l.length) == 0) {
        r((f) => ++f), o(!0);
        return;
      }
      h && (i(h), o(!0));
    }
  }, [
    d,
    u,
    h,
    l,
    o,
    i,
    r
  ]), h == null ? void 0 : h.organizationName;
}, xa = ({ children: e }) => {
  const [t, r] = E(!1), [i, o] = E(!1), [a, s] = E(), [l, c] = E(), [d, p] = E(), [h, u] = E(), { isAuthenticated: f } = V(), [g, C] = E(), [x, O] = E(), [v, T] = E(!1), { setSnackOptions: y } = Ee(), {
    updateUserRecentOrganizations: M,
    removeRecentOrganization: I,
    isRecentOrganizationsLoading: L
  } = Me(), { isLoadingEffectiveOrgs: W, errorOrgs: U, effectiveOrganizationsResponse: F } = Ao(f, 0, P.EffectiveOrgsPageSize), J = Jt(), [ue, ee] = E(1), [q, pe] = E(!1), { t: Oe } = R(), K = z(
    (H) => {
      _.NepOrganization = H == null ? void 0 : H.organizationName, O(H);
    },
    [O]
  ), Ie = ga(
    1,
    ue,
    ee,
    K,
    pe,
    q
  ), he = Ca(
    2,
    ue,
    ee,
    K,
    pe,
    q
  ), Fe = Ea(
    3,
    ue,
    ee,
    K,
    pe,
    q,
    W,
    F == null ? void 0 : F.organizations
  ), {
    organizationData: me,
    isLoadingOrg: Qe,
    errorOrg: xe
  } = je(g, {
    keepPreviousData: !1
  });
  S(
    function() {
      o(Qe || !q);
    },
    [Qe, q, o]
  ), S(
    function() {
      if (!F) return;
      const { organizations: _e, totalResults: fe } = F;
      s(_e), c(fe);
    },
    [F, s, c]
  ), S(
    function() {
      (xe == null ? void 0 : xe.status) === 403 && g && !L && (async () => {
        await I(g), y({
          open: !0,
          color: "error",
          message: Oe("ORG_CONTEXT.ERROR.UNAUTHORIZED", {
            invalidOrg: g
          }),
          autoHideDuration: null
        });
        const fe = Ie || he || Fe;
        fe && fe !== g && C(fe);
      })();
    },
    [
      Ie,
      he,
      Fe,
      g,
      xe,
      y,
      I
    ]
  ), S(
    function() {
      me && K(me);
    },
    [me, K]
  ), S(
    function() {
      !me || L || M(me);
    },
    [me, L, M]
  ), S(
    function() {
      x && lr(Ge.organization) !== x.organizationName && (ma(Ge.organization, x.organizationName), p(d));
    },
    [x, J]
  ), S(
    function() {
      if (!f || h) {
        r(!1);
        return;
      }
      r(i || W);
    },
    [r, f, i, W, h]
  ), S(
    function() {
      xe && K(void 0), u(xe || U);
    },
    [xe, U, u]
  );
  const nn = z(
    (H) => {
      if (H) {
        var _e = H.toLowerCase();
        C(
          (fe) => _e == fe ? fe : _e
        );
      }
    },
    [C]
  );
  S(
    function() {
      f === !1 && (ee(1), pe(!1), u(void 0), s(void 0), C(void 0), O(void 0), c(void 0), _.NepOrganization = "");
    },
    [
      f,
      ee,
      pe,
      u,
      s,
      C,
      O,
      c
    ]
  );
  const Er = j(
    () => ({
      organization: x,
      isOrgDialogOpen: v,
      setIsOrgDialogOpen: T,
      userOrganizations: a ?? [],
      updateOrganization: nn,
      isLoading: t,
      isLoadingOrg: i,
      totalOrganizations: l,
      hasPreloaded: q,
      error: h
    }),
    [
      x,
      v,
      T,
      a,
      nn,
      t,
      i,
      l,
      q,
      h
    ]
  );
  return /* @__PURE__ */ n(Pn.Provider, { value: Er, children: e });
}, Sa = () => {
  const { authState: e, oktaAuth: t } = qe(), { data: r, mutate: i } = ve(
    e != null && e.isAuthenticated ? ro() : null,
    async () => await t.getUser(),
    {
      revalidateOnFocus: !1
    }
  ), o = z(async () => {
    await i();
  }, [i]);
  return { userInfo: r, refreshUserInfo: o };
}, va = (e, t, r, i) => {
  const o = {
    department: null,
    mobilePhone: null,
    userType: null,
    managerId: null,
    manager: null,
    preferredLanguage: null,
    honorificPrefix: null,
    honorificSuffix: null,
    costCenter: null,
    middleName: null,
    profileUrl: null,
    locale: null,
    title: null,
    secondEmail: null,
    division: null,
    displayName: null,
    organization: null,
    timezone: null,
    nickName: null,
    employeeNumber: null
  };
  return new Promise((a, s) => {
    ii(e, {
      payload: {
        profile: {
          firstName: t,
          lastName: r,
          login: i,
          email: i,
          ...o
        }
      }
    }).then(() => a()).catch((l) => s(l));
  });
}, Ta = (e, t) => ri(e, {
  payload: {
    profile: {
      email: t
    },
    sendEmail: !1,
    role: "PRIMARY"
  }
}), Oa = (e, t) => t({
  verificationCode: e
}), Ia = (e, t, r, i) => oi(e, {
  emailId: t,
  challengeId: r,
  payload: {
    verificationCode: i
  }
}), Ra = (e, t) => ai(e, { id: t }), ke = {
  updateUserEmail: Ta,
  verifyUserEmail: Oa,
  sendUserEmailChallenge: Ra,
  verifyUserEmailChallenge: Ia,
  updateOktaProfile: va
}, wt = P.RccCacheKey;
function ba() {
  if (Ht())
    return /* @__PURE__ */ new Map();
  const e = new Map(JSON.parse(localStorage.getItem(wt) || "[]"));
  return window.addEventListener("beforeunload", () => {
    const t = Array.from(e.entries()), r = [];
    t.forEach((i) => {
      i.length && i.length > 1 && i[1].data && r.push(i);
    }), localStorage.setItem(wt, JSON.stringify(r));
  }), e;
}
function Na() {
  localStorage.removeItem(wt);
}
const ya = (e) => {
  var t;
  if (e)
    return (t = e == null ? void 0 : e.email) == null ? void 0 : t.endsWith(P.NcrEmailFormat);
}, Re = (e) => e.email_verified ? e.email : e.preferred_username, dr = () => _.Services.FrontDoor, ur = "/organizations/recents", Aa = () => ce(`${dr()}${ur}`, {
  headers: {
    [P.OrgHeader]: null
  }
}).catch(G), wa = (e) => Ct(`${dr()}${ur}`, {
  recentOrganizations: e
}, {
  headers: {
    [P.OrgHeader]: null
  }
}).catch(G), Pa = () => {
  const e = D(), { isAuthenticated: t } = V(), [r, i] = E(), [o, a] = E(!1), {
    data: s,
    isLoading: l,
    error: c,
    mutate: d
  } = ve(t ? eo() : null, Aa);
  S(() => {
    s && (e.current = [...s]);
  }, [s]);
  const p = z(async (f) => {
    try {
      a(!0), await wa(f).catch(G), await d(f, { revalidate: !1 }), a(!1);
    } catch (g) {
      i(g);
    }
  }, [
    a,
    i,
    d
  ]), h = z(
    async (f) => {
      const g = e.current;
      if (g === void 0) return;
      const { organizationName: C, displayName: x } = f, O = {
        organizationName: C,
        displayName: x
      }, v = [...g], T = v.findIndex(
        (M) => M.organizationName === C
      );
      T > -1 && v.splice(T, 1), v.unshift(O);
      const y = v.slice(0, 5);
      await p(y);
    },
    [p]
  ), u = z(
    async (f) => {
      const g = e.current;
      if (g === void 0) return;
      const C = [...g], x = C.findIndex(
        (O) => O.organizationName === f
      );
      x != -1 && (C.splice(x, 1), await p(C));
    },
    [p]
  );
  return {
    recentOrganizations: s,
    recentOrganizationsMutationError: r,
    isRecentOrganizationsLoading: l,
    getRecentOrganizationsError: c,
    isRecentOrganizationsMutating: o,
    removeRecentOrganization: u,
    updateRecentsWithNewOrganization: h
  };
}, La = ({ children: e }) => {
  const {
    recentOrganizations: t,
    recentOrganizationsMutationError: r,
    isRecentOrganizationsLoading: i,
    getRecentOrganizationsError: o,
    isRecentOrganizationsMutating: a,
    updateRecentsWithNewOrganization: s,
    removeRecentOrganization: l
  } = Pa(), c = yo(), d = j(
    () => ({
      recentOrganizations: t,
      recentOrganizationsMutationError: r,
      isRecentOrganizationsLoading: i,
      getRecentOrganizationsError: o,
      isRecentOrganizationsMutating: a,
      updateUserRecentOrganizations: s,
      removeRecentOrganization: l,
      deleteEffectiveOrgsCache: c
    }),
    [
      t,
      r,
      i,
      o,
      a,
      s,
      l,
      c
    ]
  );
  return /* @__PURE__ */ n(Bn.Provider, { value: d, children: e });
}, cn = {
  username: "",
  theme: Ve.SYSTEM,
  defaultOrganizationId: void 0,
  language: "en",
  region: Be.US
}, pr = () => `${_.Services.FrontDoor}/user-preferences/self`, Ma = () => ce(pr(), {
  headers: {
    [P.OrgHeader]: null
  }
}).catch(G), Ua = (e) => Ct(`${pr()}`, e, {
  headers: {
    [P.OrgHeader]: null
  }
}), Da = (e, t) => Zt(e, t), Fa = () => {
  const { isAuthenticated: e } = V(), [t, r] = E(!1), [i, o] = E(), a = D({ ...cn }), { data: s, isValidating: l, isLoading: c, error: d, mutate: p } = ve(
    e ? no() : null,
    Ma,
    {
      fallbackData: cn
    }
  );
  S(() => {
    s && (a.current = s);
  }, [s]);
  const h = z(
    async (u) => {
      const f = { ...a.current }, g = Object.assign(f, u);
      if (Da(a.current, g))
        return;
      const { username: C, ...x } = g, O = x;
      try {
        o(void 0), r(!0), await Ua(O).catch(G), await p(g, { revalidate: !1 });
      } catch (v) {
        o(v);
      } finally {
        r(!1);
      }
    },
    [r, p]
  );
  return {
    userPreferences: s,
    isUserPreferencesLoading: c,
    isUserPreferencesValidating: l,
    getUserPreferencesError: d,
    isUserPreferencesMutating: t,
    userPreferencesMutationError: i,
    updateUserPreferences: h
  };
}, _a = ({ children: e }) => {
  const {
    userPreferences: t,
    isUserPreferencesLoading: r,
    isUserPreferencesValidating: i,
    getUserPreferencesError: o,
    isUserPreferencesMutating: a,
    userPreferencesMutationError: s,
    updateUserPreferences: l
  } = Fa(), c = j(
    () => ({
      userPreferences: t,
      isUserPreferencesLoading: r,
      isUserPreferencesMutating: a,
      isUserPreferencesValidating: i,
      userPreferencesMutationError: s,
      getUserPreferencesError: o,
      updateUserPreferences: l
    }),
    [
      t,
      r,
      a,
      i,
      s,
      o,
      l
    ]
  );
  return /* @__PURE__ */ n(Gn.Provider, { value: c, children: e });
}, ka = () => `${_.Services.FrontDoor}/users`, za = () => ce(`${ka()}/introspect`).catch(G), Va = () => {
  const { organization: e } = B(), t = e == null ? void 0 : e.organizationName, {
    data: r,
    isLoading: i,
    error: o
  } = Ft(
    t ? oo(t) : null,
    za,
    {
      keepPreviousData: !1
    }
  );
  return {
    introspection: r,
    isIntrospectLoading: i,
    introspectError: o
  };
}, Ba = ({ children: e }) => {
  const { introspection: t, isIntrospectLoading: r, introspectError: i } = Va(), o = {
    introspection: t,
    isIntrospectLoading: r,
    introspectError: i
  };
  return /* @__PURE__ */ n(Wn.Provider, { value: o, children: e });
}, Ga = ({ enableAutoLogout: e }) => {
  const { cache: t } = Xr(), { oktaAuth: r, authState: i } = qe(), o = D(!1);
  return S(
    function() {
      if ((i == null ? void 0 : i.isAuthenticated) === !1) {
        Na();
        for (let s of t.keys())
          t.delete(s);
      }
    },
    [i == null ? void 0 : i.isAuthenticated]
  ), S(
    function() {
      const s = e ?? !0, l = async () => {
        o.current || (o.current = !0, Wt.emit(Yt.SIGNOUT), localStorage.removeItem(P.ApplicationsListCacheKey), s && await r.signOut());
      };
      return r.tokenManager.on("expired", l), () => {
        r.tokenManager.off("expired", l);
      };
    },
    [r.tokenManager, e]
  ), null;
}, Wa = ({ language: e }) => {
  const { i18n: t } = R();
  return S(() => {
    (async () => {
      try {
        await t.changeLanguage(e);
      } catch {
        throw oe("Please use a value of type RccLanguage");
      }
    })();
  }, [e]), null;
}, Ha = new Mi(Wt), yc = ({
  config: e,
  children: t
}) => {
  const { authState: r } = qe(), [i, o] = E(), { userInfo: a, refreshUserInfo: s } = Sa();
  _.Services = bn[e.environment], _.IdmUrl = Rn[e.environment], _.Environment = e.environment, S(() => {
    ha(e.routerOverrides);
  }, [e.routerOverrides]), S(() => {
    var p;
    const c = (p = r == null ? void 0 : r.accessToken) == null ? void 0 : p.accessToken, d = (r == null ? void 0 : r.isAuthenticated) && !!c;
    _.AccessToken = d ? c : "", o(d);
  }, [r, o]);
  const l = j(
    () => {
      var c;
      return {
        isAuthenticated: i,
        apiVersion: P.ApiVersion,
        events: Ha,
        isInternalUser: ya(a),
        userInfo: a,
        _TEMPORARY_globalProfileOktaSdkEnabled: e == null ? void 0 : e._TEMPORARY_globalProfileOktaSdkEnabled,
        refreshUserInfo: s,
        navigate: (c = e == null ? void 0 : e.routerOverrides) == null ? void 0 : c.navigate
      };
    },
    [
      i,
      a,
      s,
      e == null ? void 0 : e._TEMPORARY_globalProfileOktaSdkEnabled,
      e == null ? void 0 : e.routerOverrides
    ]
  );
  return /* @__PURE__ */ n(Ln.Provider, { value: l, children: /* @__PURE__ */ m(
    Kr,
    {
      value: {
        provider: ba,
        keepPreviousData: !0,
        revalidateOnFocus: !1,
        errorRetryCount: 0
      },
      children: [
        /* @__PURE__ */ n(Wa, { language: e.language }),
        /* @__PURE__ */ n(pa, { children: /* @__PURE__ */ m(La, { children: [
          /* @__PURE__ */ n(Ga, { enableAutoLogout: (e == null ? void 0 : e.enableAutoLogout) ?? !1 }),
          /* @__PURE__ */ n(_a, { children: /* @__PURE__ */ n(xa, { children: /* @__PURE__ */ n(Ba, { children: /* @__PURE__ */ n(So, { children: t }) }) }) })
        ] }) })
      ]
    }
  ) });
}, et = {
  size: "32px",
  fontSize: "12px",
  fontSizeOneInitial: "14px"
}, en = () => {
  const [e, t] = E(""), r = X(), { primaryUserProfile: i, isGetPrimaryUserProfileLoading: o } = ae();
  S(() => {
    const s = i != null && i.displayName ? i == null ? void 0 : i.displayName.split(" ") : [];
    if (s.length === 0) {
      t("");
      return;
    }
    s[0] && t(`${s[0][0].toUpperCase()}`), s[0] && s[1] && t(`${s[0][0].toUpperCase()}${s[1][0].toUpperCase()}`);
  }, [i == null ? void 0 : i.displayName]);
  const a = {
    height: et.size,
    width: et.size,
    fontSize: e.length > 1 ? et.fontSize : et.fontSizeOneInitial,
    backgroundColor: r.palette.grey[600],
    color: r.palette.common.white,
    lineHeight: 1,
    paddingTop: ".09em"
  };
  return o ? /* @__PURE__ */ n(be, { variant: "circular", sx: a }) : /* @__PURE__ */ n(Lt, { children: e.length > 0 ? /* @__PURE__ */ n(rn, { sx: a, children: e }) : /* @__PURE__ */ n(rn, { sx: a, children: /* @__PURE__ */ n(xn, { fontSize: "medium" }) }) });
};
function tn({
  onClick: e,
  ...t
}) {
  const { oktaAuth: r } = qe(), { t: i } = R(), { deleteEffectiveOrgsCache: o } = Me();
  return /* @__PURE__ */ n(ze, { ...t, type: "button", onClick: async () => {
    e && e(), localStorage.removeItem(P.ApplicationsListCacheKey), o().catch(() => {
    }), Wt.emit(Yt.SIGNOUT), await r.signOut();
  }, children: i("COMMON.BUTTONS.LOGOUT") });
}
const $a = ({
  option: e,
  selected: t,
  onClick: r
}) => {
  const { onClick: i, icon: o, url: a, label: s } = e;
  return /* @__PURE__ */ n(
    st,
    {
      disablePadding: !0,
      sx: {
        a: {
          textDecoration: "none",
          width: "100%",
          color: "inherit"
        }
      },
      children: /* @__PURE__ */ m(
        lt,
        {
          onClick: () => {
            i && i(), a && cr(a, e.linkProps), r();
          },
          sx: {
            padding: "12px 16px"
          },
          selected: t,
          children: [
            o && /* @__PURE__ */ n(
              N,
              {
                display: "flex",
                lineHeight: 1,
                color: (c) => c.palette.action.active,
                paddingRight: "8px",
                children: o
              }
            ),
            /* @__PURE__ */ n(A, { variant: "body1", textAlign: "center", children: s })
          ]
        }
      )
    },
    a
  );
}, Za = ({
  menuOpen: e,
  onMenuOpen: t,
  onMenuClose: r,
  options: i
}) => {
  const { primaryUserProfile: o } = ae(), a = X(), s = Jt(), [l, c] = E(!1);
  return S(() => {
    c(
      !!(o && o.givenName && o.familyName)
    );
  }, [o]), /* @__PURE__ */ m(
    fn,
    {
      disableDiscovery: !0,
      disableSwipeToOpen: !0,
      anchor: "bottom",
      open: e,
      onClose: r,
      onOpen: t,
      children: [
        /* @__PURE__ */ n(Jn, { children: l && /* @__PURE__ */ m(Lt, { children: [
          /* @__PURE__ */ m(
            N,
            {
              sx: {
                padding: "12px 8px"
              },
              display: "flex",
              alignItems: "center",
              children: [
                /* @__PURE__ */ n(N, { paddingRight: "16px", children: /* @__PURE__ */ n(en, {}) }),
                /* @__PURE__ */ n(A, { variant: "body1", children: (o == null ? void 0 : o.displayName) ?? (o == null ? void 0 : o.fullName) })
              ]
            }
          ),
          /* @__PURE__ */ n(ge, {})
        ] }) }),
        /* @__PURE__ */ n(Ze, { "data-element-id": "user-menu-list", children: i.map((d) => /* @__PURE__ */ n(
          $a,
          {
            option: d,
            selected: (d == null ? void 0 : d.url) === (s == null ? void 0 : s.pathname),
            onClick: r
          },
          d.label
        )) }),
        /* @__PURE__ */ m(
          Qn,
          {
            sx: {
              padding: 0
            },
            children: [
              /* @__PURE__ */ n(N, { sx: { px: "8px" }, children: /* @__PURE__ */ n(ge, {}) }),
              /* @__PURE__ */ n(
                tn,
                {
                  "data-element-id": "logout-button-drawer",
                  size: "large",
                  sx: {
                    width: "100%",
                    justifyContent: "flex-start",
                    textTransform: "none",
                    padding: "12px 16px",
                    color: a.palette.text.primary,
                    fontWeight: a.typography.body1.fontWeight,
                    fontSize: a.typography.body1.fontSize
                  }
                }
              )
            ]
          }
        )
      ]
    }
  );
}, Ya = ({
  option: e,
  onClick: t,
  selected: r
}) => {
  const { onClick: i, icon: o, label: a, url: s } = e;
  return /* @__PURE__ */ n(
    Ne,
    {
      "data-element-id": a,
      onClick: () => {
        i && i(), s && cr(s, e.linkProps), t();
      },
      sx: {
        padding: 0,
        a: {
          textDecoration: "none",
          width: "100%",
          color: "inherit"
        }
      },
      selected: r,
      children: /* @__PURE__ */ m(N, { display: "flex", alignItems: "center", padding: "12px 16px", children: [
        o && /* @__PURE__ */ n(
          N,
          {
            display: "flex",
            lineHeight: 1,
            paddingRight: "8px",
            color: (c) => c.palette.action.active,
            children: o
          }
        ),
        /* @__PURE__ */ n(A, { variant: "body1", children: a })
      ] })
    }
  );
}, qa = ({
  anchorRef: e,
  menuOpen: t,
  onMenuClose: r,
  options: i
}) => {
  const { primaryUserProfile: o } = ae(), a = !!(o != null && o.displayName), s = X(), l = Jt(), c = D(null);
  return S(
    function() {
      t && c.current && c.current.focus();
    },
    [t]
  ), /* @__PURE__ */ m(
    Et,
    {
      anchorRef: e,
      menuOpen: t,
      onMenuClose: r,
      menuPaperSx: {
        minWidth: "288px",
        borderRadius: w.BorderRadius.value
      },
      children: [
        a && /* @__PURE__ */ m(N, { children: [
          /* @__PURE__ */ m(
            Ne,
            {
              ref: c,
              "aria-label": `Display name: ${o == null ? void 0 : o.displayName}`,
              tabIndex: 0,
              autoFocus: !0,
              component: "span",
              children: [
                /* @__PURE__ */ n(N, { paddingRight: "12px", children: /* @__PURE__ */ n(en, {}) }),
                /* @__PURE__ */ n(A, { variant: "body1", children: o == null ? void 0 : o.displayName })
              ]
            }
          ),
          /* @__PURE__ */ n(ge, { sx: { display: a ? "block" : "none" } })
        ] }),
        i.map((d) => /* @__PURE__ */ n(
          Ya,
          {
            option: d,
            onClick: r,
            selected: (l == null ? void 0 : l.pathname) === (d == null ? void 0 : d.url)
          },
          d.label
        )),
        /* @__PURE__ */ n(ge, {}),
        /* @__PURE__ */ n(
          tn,
          {
            "data-element-id": "logout-button-menu",
            onClick: r,
            sx: {
              width: "100%",
              justifyContent: "flex-start",
              textTransform: "none",
              padding: "8px",
              color: s.palette.text.primary,
              fontWeight: s.typography.body1.fontWeight,
              fontSize: s.typography.body1.fontSize
            }
          }
        )
      ]
    }
  );
}, dn = 4, ja = 250, Xa = (e) => {
  const t = D(0), [r, i] = E(0), [o, a] = E(null);
  return S(() => {
    const s = (d) => {
      const { screenY: p } = d.targetTouches[0];
      t.current = p;
    }, l = (d) => {
      const p = d.targetTouches[0], { screenY: h } = p;
      let u = h - t.current;
      u > 0 ? a("top") : u < 0 && a("bottom"), i(Math.min(Math.abs(u), ja));
    }, c = () => {
      t.current = 0, i(0), a(null);
    };
    return window.addEventListener("touchstart", s), window.addEventListener("touchmove", l), window.addEventListener("touchend", c), () => {
      window.removeEventListener("touchstart", s), window.removeEventListener("touchmove", l), window.removeEventListener("touchend", c);
    };
  }, []), S(() => {
    e.current && (o === "top" ? e.current.style.marginTop = `${r / dn}px` : o === "bottom" ? e.current.style.marginBottom = `${r / dn}px` : (e.current.style.marginTop = "0", e.current.style.marginBottom = "0"));
  }, [r, o]), null;
}, Ka = ({ children: e }) => {
  const t = D(null);
  return Xa(t), /* @__PURE__ */ n(N, { ref: t, children: e });
}, Qa = {
  width: "100%",
  maxWidth: "820px"
}, Ja = ({
  children: e,
  value: t,
  index: r,
  tabPadding: i,
  a11yTabPrefix: o,
  a11yTabPanelPrefix: a
}) => /* @__PURE__ */ n(
  N,
  {
    role: "tabpanel",
    hidden: t !== r,
    id: `${a}-${r}`,
    "aria-labelledby": `${o}-${r}`,
    children: t === r && /* @__PURE__ */ n(b, { alignItems: "center", padding: i, children: /* @__PURE__ */ n(N, { ...Qa, children: e }) })
  }
), xt = ({ children: e }) => /* @__PURE__ */ n(b, { gap: "16px", children: e }), es = (e) => e ? {
  flexDirection: "column",
  rowGap: "16px"
} : {
  flexDirection: "row",
  justifyContent: "space-between",
  alignItems: "center",
  columnGap: "16px",
  width: "100%"
}, ts = ({
  children: e,
  name: t,
  description: r
}) => {
  const i = Z(), o = es(i);
  return /* @__PURE__ */ m(b, { sx: o, children: [
    /* @__PURE__ */ m(b, { rowGap: "3px", fontSize: "16px", children: [
      /* @__PURE__ */ n(A, { variant: "subtitle2", fontWeight: 600, fontSize: "inherit", children: t }),
      /* @__PURE__ */ n(A, { color: "text.secondary", variant: "body1", fontSize: "inherit", children: r })
    ] }),
    e
  ] });
};
function ns({
  buttonVariant: e = "text",
  ...t
}) {
  const { t: r } = R({ keyPrefix: "COMMON" });
  return e === "icon" ? /* @__PURE__ */ n(ie, { type: "button", size: "small", "data-element-id": "edit-button", ...t, children: /* @__PURE__ */ n(pi, { fontSize: "inherit" }) }) : /* @__PURE__ */ n(
    le,
    {
      type: "button",
      ...t,
      sx: {
        textTransform: "unset",
        textDecoration: "underline"
      },
      children: r("BUTTONS.EDIT")
    }
  );
}
const it = Qr(hi, {
  shouldForwardProp: (e) => e !== "variantType"
})(({ variantType: e }) => {
  const t = Te(), r = t.palette.mode;
  return e === "cancel" ? {
    textTransform: "unset",
    color: re.cancelButtonColor[r],
    borderColor: re.cancelButtonBorderColor[r],
    "&:hover": {
      backgroundColor: t.palette.action.hover,
      borderColor: re.cancelButtonBorderColor[r]
    }
  } : e === "save" ? {
    color: re.saveButtonColor[r],
    textTransform: "unset",
    backgroundColor: re.saveButtonBackgroundColor[r],
    "&:hover": {
      backgroundColor: re.saveButtonHoverBackgroundColor[r]
    }
  } : {
    textTransform: "unset"
  };
}), rs = ({
  saveText: e,
  cancelText: t,
  onSave: r,
  onCancel: i,
  loadingButton: o,
  disabled: a,
  cancelDisabled: s,
  fullWidth: l,
  type: c
}) => {
  const { t: d } = R({ keyPrefix: "COMMON" });
  return /* @__PURE__ */ m(b, { direction: "row", gap: 2, children: [
    /* @__PURE__ */ n(
      it,
      {
        variant: "outlined",
        variantType: "cancel",
        onClick: i,
        disabled: s,
        fullWidth: l,
        children: t || d("BUTTONS.CANCEL")
      }
    ),
    /* @__PURE__ */ n(
      it,
      {
        variant: "contained",
        variantType: "save",
        loading: o,
        onClick: r,
        disabled: a,
        fullWidth: l,
        type: c,
        children: e || d("BUTTONS.SAVE")
      }
    )
  ] });
}, St = ({
  children: e,
  title: t,
  icon: r,
  editMode: i = !1,
  setEditMode: o,
  readonly: a = !1,
  disableEditMode: s = !1,
  ...l
}) => {
  const c = {
    ...l
  };
  return /* @__PURE__ */ m(N, { border: "1px solid", borderColor: "divider", borderRadius: "12px", children: [
    /* @__PURE__ */ m(
      N,
      {
        display: "flex",
        justifyContent: "space-between",
        p: "16px",
        alignItems: "center",
        id: "settings-panel-header",
        children: [
          /* @__PURE__ */ m(N, { display: "flex", justifyContent: "flex-start", gap: "8px", alignItems: "center", children: [
            r && /* @__PURE__ */ n(
              N,
              {
                sx: {
                  backgroundColor: "background.default",
                  border: (d) => `1px solid ${d.palette.divider}`,
                  width: "32px",
                  height: "32px",
                  borderRadius: w.BorderRadius.value,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center"
                },
                children: mn(r, {
                  sx: { width: 16, height: 16 }
                })
              }
            ),
            /* @__PURE__ */ n(A, { variant: "h5", fontWeight: 600, fontSize: "inherit", children: t })
          ] }),
          !i && !!o && !a && /* @__PURE__ */ n(
            ns,
            {
              "data-element-id": "edit-button-" + t,
              "aria-label": `Edit ${t}`,
              buttonVariant: "icon",
              onClick: () => {
                o(!0);
              },
              sx: {
                borderRadius: w.BorderRadius.value,
                padding: "8px"
              },
              autoFocus: !0
            }
          )
        ]
      }
    ),
    /* @__PURE__ */ n(
      ge,
      {
        style: {
          width: "100%"
        }
      }
    ),
    /* @__PURE__ */ m(b, { p: "16px", direction: "column", gap: 2, id: "settings-panel-body", children: [
      e,
      i && /* @__PURE__ */ n(rs, { fullWidth: !0, ...c })
    ] })
  ] });
}, Xe = ({ children: e, title: t, icon: r }) => /* @__PURE__ */ m(N, { border: "1px solid", borderColor: "divider", borderRadius: "12px", children: [
  /* @__PURE__ */ n(
    N,
    {
      display: "flex",
      justifyContent: "space-between",
      p: "16px",
      alignItems: "center",
      id: "settings-panel-header",
      children: /* @__PURE__ */ m(N, { display: "flex", justifyContent: "flex-start", gap: "8px", alignItems: "center", children: [
        r && /* @__PURE__ */ n(
          N,
          {
            sx: {
              backgroundColor: "background.default",
              border: (i) => `1px solid ${i.palette.divider}`,
              width: "32px",
              height: "32px",
              borderRadius: w.BorderRadius.value,
              display: "flex",
              justifyContent: "center",
              alignItems: "center"
            },
            children: mn(r, {
              sx: { width: 16, height: 16 }
            })
          }
        ),
        /* @__PURE__ */ n(A, { variant: "h5", fontWeight: 600, fontSize: "inherit", children: t })
      ] })
    }
  ),
  /* @__PURE__ */ n(
    ge,
    {
      style: {
        width: "100%"
      }
    }
  ),
  /* @__PURE__ */ n(b, { p: "16px", direction: "column", gap: 2, id: "settings-panel-body", children: e })
] });
var Se = /* @__PURE__ */ ((e) => (e.required = "required", e.invalidFormat_email = "invalidFormat_email", e.qlidFormat_email = "qlidFormat_email", e.requiredFirstName = "requiredFirstName", e.requiredFirstNameForSave = "requiredFirstNameForSave", e.requiredLastName = "requiredLastName", e.requiredLastNameForSave = "requiredLastNameForSave", e.requiredEmail = "requiredEmail", e.notNcrEmailFormat = "notNcrEmailFormat", e))(Se || {});
const un = {
  invalidFormat_email: "COMMON.FORM.ERRORS.EMAIL_INVALID",
  notNcrEmailFormat: "COMMON.FORM.ERRORS.NCR_EMAIL_PROHIBITED"
}, Pt = (e, t, r, i) => {
  const o = (a) => a.trim().length > 0;
  i({ ...r, [t]: o(e) ? null : "required" });
}, pn = (e, t, r, i, o = !1, a = !1) => {
  if (!e) return;
  if (!((l) => /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(l))(e)) {
    i({ ...r, [t]: "invalidFormat_email" });
    return;
  }
  if (o) {
    const l = is(e);
    i({ ...r, [t]: l ? null : "qlidFormat_email" });
  }
  if (a) {
    const l = hr(e);
    i({ ...r, [t]: l ? "notNcrEmailFormat" : null });
  }
}, hr = (e) => e.endsWith(P.NcrEmailFormat) || e.endsWith(P.NcrVoyixEmailFormat), is = (e) => {
  if (!e) return !0;
  const t = (r) => /^[A-Za-z]{2}\d{6}@ncr\.com/i.test(r);
  return !hr(e) || t(e);
}, vt = (e) => {
  if (!e.current) return;
  const t = e.current.querySelectorAll("input, select, textarea");
  for (const r of t)
    if (!r.disabled && !r.ariaReadOnly) {
      r.focus();
      break;
    }
}, os = Ce(function(t, r) {
  return /* @__PURE__ */ n(dt, { direction: "up", ref: r, ...t });
}), as = Ce(function(t, r) {
  return /* @__PURE__ */ n(Dt, { ref: r, ...t });
}), Tt = ({
  children: e,
  onClose: t,
  ...r
}) => {
  const i = Z(), o = (a, s) => {
    s && s === "backdropClick" || t();
  };
  return /* @__PURE__ */ m(
    Tn,
    {
      maxWidth: i ? void 0 : !1,
      ...r,
      TransitionComponent: i ? os : as,
      PaperProps: { sx: { borderRadius: w.DialogBorderRadius.value } },
      onClose: o,
      sx: {
        ".MuiDialogTitle-root": {
          paddingRight: "100px"
        }
      },
      children: [
        /* @__PURE__ */ n(
          ie,
          {
            "data-element-id": "close-dialog-button",
            onClick: t,
            sx: {
              position: "absolute",
              top: "12px",
              right: "16px"
            },
            children: /* @__PURE__ */ n(ct, {})
          }
        ),
        e
      ]
    }
  );
}, ss = ({
  open: e,
  setOpen: t,
  onConfirm: r,
  onClose: i,
  title: o,
  contentText: a,
  cancelActionText: s,
  confirmActionText: l
}) => {
  const { t: c } = R(), d = Z(), p = window !== void 0 ? () => window.document.body : void 0;
  o = o || c("COMMON.CONFIRM.TITLE"), a = a || c("COMMON.CONFIRM.CONTENT"), s = s || c("COMMON.BUTTONS.CANCEL"), l = l || c("COMMON.BUTTONS.CONFIRM");
  const h = () => {
    t(!0);
  }, u = () => {
    i();
  }, f = () => {
    r();
  };
  return /* @__PURE__ */ n(mi, { children: d ? /* @__PURE__ */ n(
    Ei,
    {
      container: p,
      anchor: "bottom",
      open: e,
      onClose: u,
      onOpen: h,
      disableDiscovery: !0,
      disableSwipeToOpen: !0,
      sx: {
        zIndex: w.Elevations.Drawer,
        ".MuiPaper-root.MuiDrawer-paper": {
          borderTopRightRadius: w.BorderRadius.value,
          borderTopLeftRadius: w.BorderRadius.value
        }
      },
      children: /* @__PURE__ */ m(b, { sx: { p: 2 }, gap: 2, children: [
        /* @__PURE__ */ m(b, { direction: "row", alignItems: "center", children: [
          /* @__PURE__ */ n(A, { variant: "h5", fontWeight: "bold", sx: { flexGrow: 1 }, children: o }),
          /* @__PURE__ */ n(ie, { size: "small", onClick: u, children: /* @__PURE__ */ n(ct, {}) })
        ] }),
        /* @__PURE__ */ n(A, { children: a }),
        /* @__PURE__ */ m(b, { direction: "column", gap: 1, children: [
          /* @__PURE__ */ n(
            ze,
            {
              variant: "outlined",
              onClick: u,
              sx: {
                textTransform: "unset"
              },
              children: s
            }
          ),
          /* @__PURE__ */ n(
            ze,
            {
              variant: "contained",
              sx: {
                boxShadow: "none",
                ":hover, :active": {
                  boxShadow: "none"
                },
                textTransform: "unset"
              },
              onClick: f,
              children: l
            }
          )
        ] })
      ] })
    }
  ) : /* @__PURE__ */ m(Tt, { open: e, onClose: u, children: [
    /* @__PURE__ */ n(He, { children: o }),
    /* @__PURE__ */ n(gi, { children: /* @__PURE__ */ n(Ci, { children: a }) }),
    /* @__PURE__ */ m(fi, { sx: { px: 3, py: 2 }, children: [
      /* @__PURE__ */ n(ze, { onClick: u, children: s }),
      /* @__PURE__ */ n(
        ze,
        {
          variant: "contained",
          sx: {
            boxShadow: "none",
            ":hover, :active": {
              boxShadow: "none"
            }
          },
          onClick: f,
          children: l
        }
      )
    ] })
  ] }) });
}, ls = (e) => {
  let { currEmail: t, handleUpdateEmail: r } = e;
  const [i, o] = E(!1), { t: a } = R(), [s, l] = E(""), [c, d] = E({
    email: null
  }), [p, h] = E(!1);
  S(() => {
    let C = !!(s.toString().trim() && s.toString().trim() !== t);
    h(C && c.email === null);
  }, [s, t, c]);
  const u = () => {
    d({
      email: null
    }), r(s);
  }, f = () => {
    o(!0);
  };
  function g(C) {
    C.key === "Enter" && p && u();
  }
  return /* @__PURE__ */ m(b, { gap: 2, mt: 2, children: [
    /* @__PURE__ */ n(
      ss,
      {
        open: i,
        setOpen: o,
        onClose: () => o(!1),
        onConfirm: () => {
          u();
        }
      }
    ),
    /* @__PURE__ */ n(
      $e,
      {
        required: !0,
        fullWidth: !0,
        label: a("COMMON.PROPS.EMAIL"),
        variant: "outlined",
        defaultValue: e.currEmail,
        onChange: (C) => {
          l(C.target.value), Pt(C.target.value, "email", c, d), pn(C.target.value, "email", c, d, !1, !0);
        },
        error: c.email === Se.invalidFormat_email || c.email === Se.notNcrEmailFormat,
        helperText: c.email === Se.invalidFormat_email && a(un.invalidFormat_email) || c.email === Se.notNcrEmailFormat && a(un.notNcrEmailFormat),
        onBlur: (C) => {
          pn(
            C.target.value.trim(),
            "email",
            c,
            d,
            !1,
            !0
          ), l(C.target.value.trim());
        },
        onKeyDown: g
      }
    ),
    /* @__PURE__ */ n(
      le,
      {
        variant: "contained",
        onClick: f,
        disabled: !p,
        fullWidth: !0,
        sx: {
          textTransform: "unset"
        },
        children: a("COMMON.BUTTONS.SUBMIT")
      }
    )
  ] });
}, cs = (e) => {
  let { length: t, error: r, disabled: i, value: o, setValue: a } = e;
  const s = D(null);
  return /* @__PURE__ */ m(we, { children: [
    /* @__PURE__ */ n(
      N,
      {
        sx: {
          py: 1,
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-evenly",
          lineHeight: "1em",
          maxHeight: "2em"
        },
        children: ut.range(t).map((l) => /* @__PURE__ */ n(
          $e,
          {
            variant: "outlined",
            focused: o.length === l,
            value: o[l] ?? "",
            sx: {
              fontSize: "15px",
              mx: "8px"
            },
            inputProps: {
              style: {
                textAlign: "center",
                paddingLeft: "5px",
                paddingRight: "5px",
                textTransform: "uppercase",
                cursor: "pointer"
              }
            },
            error: r,
            disabled: i,
            onClick: () => {
              s.current && (a((c) => c.substring(0, l)), s.current.focus());
            },
            onKeyDown: () => {
              s.current && (a((c) => c.substring(0, l)), s.current.focus());
            }
          },
          l
        ))
      }
    ),
    /* @__PURE__ */ n(
      "input",
      {
        ref: s,
        value: o,
        onChange: (l) => a(l.target.value),
        maxLength: t,
        style: { opacity: "0", cursor: "default" }
      }
    )
  ] });
}, ds = (e) => {
  let { verifyCode: t, handleSendVerificationEmail: r, codeExpired: i, invalidCode: o, setInvalidCode: a } = e;
  const { t: s } = R(), l = D(null), [c, d] = E(""), p = () => {
    t(c);
  };
  return S(() => {
    var h;
    (h = l.current) == null || h.focus();
  }, []), S(() => {
    i && d("");
  }, [i]), S(() => {
    c.length !== 6 && a(!1);
  }, [c]), /* @__PURE__ */ m(b, { children: [
    o && /* @__PURE__ */ n(
      nt,
      {
        severity: "error",
        sx: {
          alignItems: "center",
          justifyContent: "center"
        },
        children: s("USER_SETTINGS.PROFILE.EMAIL_UPDATE.VERIFY_CODE.ERROR.WRONG_CODE")
      }
    ),
    i && /* @__PURE__ */ n(
      nt,
      {
        severity: "error",
        sx: {
          alignItems: "center",
          justifyContent: "center"
        },
        children: s("USER_SETTINGS.PROFILE.EMAIL_UPDATE.VERIFY_CODE.ERROR.EXPIRED")
      }
    ),
    /* @__PURE__ */ n(A, { children: s("USER_SETTINGS.PROFILE.EMAIL_UPDATE.VERIFY_CODE.PROMPT") }),
    /* @__PURE__ */ n(
      cs,
      {
        length: 6,
        error: o,
        disabled: i,
        value: c,
        setValue: d
      }
    ),
    /* @__PURE__ */ m(
      b,
      {
        direction: "column",
        justifyContent: "center",
        alignItems: "center",
        gap: 1,
        marginTop: 4,
        children: [
          !i && /* @__PURE__ */ n(
            le,
            {
              variant: "contained",
              onClick: p,
              disabled: c.length !== 6,
              sx: { width: "100%", textTransform: "unset" },
              children: s("COMMON.BUTTONS.SUBMIT")
            }
          ),
          /* @__PURE__ */ n(
            le,
            {
              variant: "text",
              onClick: () => r(),
              sx: { width: "100%", textTransform: "unset" },
              children: s("USER_SETTINGS.PROFILE.EMAIL_UPDATE.RESEND")
            }
          )
        ]
      }
    )
  ] });
}, us = ({ open: e, onClose: t }) => {
  const { t: r } = R({ keyPrefix: "USER_SETTINGS.PROFILE.EMAIL_UPDATE" }), { oktaAuth: i } = qe(), [o, a] = E(), [s, l] = E(), [c, d] = E(!1), [p, h] = E(!1), { userInfo: u } = V(), [f, g] = E(
    u != null && u.email_verified ? "email" : "verify"
  ), C = Z(), { setSnackOptions: x } = Ee(), { refreshUserInfo: O } = V();
  S(function() {
    (async () => {
      if (u != null && u.email_verified)
        return;
      let J = i.transactionManager.load();
      if (J) {
        a(J.emailTransactionId), l(J.challengeId);
        return;
      }
      f === "verify" && !(o && s) && (u != null && u.preferred_username) && await T(u.preferred_username);
    })();
  }, []), S(
    function() {
      if (!o || !s) return;
      si(i, {
        emailTransactionId: o,
        challengeId: s
      });
    },
    [o, s]
  );
  const v = () => {
    t();
  }, T = async (U) => {
    ke.updateUserEmail(i, U).then((F) => {
      if (O(), F.id) {
        let J = F.id;
        a(J), L(J);
      }
      g("verify");
    }).catch(() => {
      x({
        color: "error",
        message: r("ADD_EMAIL.ERROR").toString(),
        autoHideDuration: null
      });
    });
  }, y = async (U) => {
    if (o && s)
      await ke.verifyUserEmailChallenge(
        i,
        o,
        s,
        U
      );
    else
      throw oe("Resource not found");
  }, M = async (U) => {
    try {
      await y(U), d(!1), await O(), x({
        color: "success",
        message: r("VERIFY_CODE.SUCCESS").toString(),
        autoHideDuration: null
      }), v();
    } catch (F) {
      F.message.includes("Resource not found") ? (d(!0), x({
        color: "error",
        message: r("VERIFY_CODE.ERROR.EXPIRED").toString(),
        autoHideDuration: null
      })) : (h(!0), x({
        color: "error",
        message: r("VERIFY_CODE.ERROR.WRONG_CODE").toString(),
        autoHideDuration: null
      }));
    }
  }, I = (U) => U ? ke.sendUserEmailChallenge(i, U) : o ? ke.sendUserEmailChallenge(i, o) : ke.sendUserEmailChallenge(i, s), L = (U) => {
    I(U).then((F) => {
      l(F.id), d(!1), x({
        color: "success",
        message: r("ADD_EMAIL.SUCCESS").toString(),
        autoHideDuration: null
      });
    }).catch((F) => {
      x({
        color: "error",
        message: F.message,
        autoHideDuration: null
      });
    });
  }, W = {
    email: /* @__PURE__ */ n(
      ls,
      {
        currEmail: u == null ? void 0 : u.email,
        handleUpdateEmail: T
      },
      "Enter Email"
    ),
    verify: /* @__PURE__ */ n(
      ds,
      {
        verifyCode: M,
        handleSendVerificationEmail: L,
        codeExpired: c,
        invalidCode: p,
        setInvalidCode: h
      },
      "Enter Verification Code"
    )
  };
  return /* @__PURE__ */ m(Tt, { onClose: v, open: e, children: [
    /* @__PURE__ */ n(He, { children: /* @__PURE__ */ n(A, { variant: "h5", fontWeight: "600", children: r(f === "email" ? "UPDATE" : "VERIFY") }) }),
    /* @__PURE__ */ n(
      at,
      {
        sx: {
          width: C ? w.MobileDialogWidth.value : "480px"
        },
        children: /* @__PURE__ */ n(b, { gap: "16px", children: W[f] })
      }
    )
  ] });
}, ps = k.object({
  email: k.string().email().max(512).min(1),
  telephoneNumber: k.string().max(32).regex(/\+?(\d|\()[\d-() ]*\d/).or(k.literal("").transform(() => null)).nullable().optional()
}), hs = k.object({
  city: k.string().max(128).regex(/[a-zA-Z][a-zA-Z\d'-. ,]*/).or(k.literal("").transform(() => null)).nullable().optional(),
  country: k.string().max(128).regex(/[a-zA-Z][a-zA-Z\d'-. ,]*/).or(k.literal("").transform(() => null)).nullable().optional(),
  postalCode: k.string().max(64).min(1).regex(/[a-zA-Z0-9-]*/).or(k.literal("").transform(() => null)).nullable().optional(),
  state: k.string().max(128).regex(/[a-zA-Z][a-zA-Z\d'-. ,]*/).or(k.literal("").transform(() => null)).nullable().optional(),
  street: k.string().max(128).min(1).or(k.literal("").transform(() => null)).nullable().optional(),
  addressLine2: k.string().max(200).min(1).or(k.literal("").transform(() => null)).nullable().optional(),
  county: k.string().max(128).min(1).or(k.literal("").transform(() => null)).nullable().optional()
}), ms = k.object({
  givenName: k.string().max(512).min(1),
  familyName: k.string().max(512).min(1)
}), mr = te(void 0), de = () => {
  const e = ne(mr), t = j(
    () => ({
      commonProfileVisibility: void 0,
      isLoading: !1,
      isContextFound: !1,
      error: void 0
    }),
    []
  );
  return e || t;
}, se = ({
  name: e,
  control: t,
  label: r,
  errors: i,
  rules: o,
  ...a
}) => {
  const { t: s } = Sn(), l = Te();
  let c = i[e];
  return /* @__PURE__ */ n(
    _t,
    {
      rules: o,
      render: ({ field: d }) => /* @__PURE__ */ m(b, { spacing: 1, children: [
        r && /* @__PURE__ */ n(
          A,
          {
            sx: {
              fontWeight: "500",
              fontSize: "small",
              color: l.palette.text.secondary
            },
            children: r
          }
        ),
        /* @__PURE__ */ n(
          $e,
          {
            ...d,
            ...a,
            error: !!c,
            helperText: c != null && c.message && typeof (c == null ? void 0 : c.message) == "string" ? s(c == null ? void 0 : c.message) : "",
            onBlur: () => {
              d.value && d.onChange(d.value.trim());
            },
            sx: {
              "& .MuiOutlinedInput-root": {
                "& fieldset": {
                  borderColor: l.palette.action.active
                },
                "&:hover fieldset": {
                  borderColor: l.palette.action.hover
                },
                "&.Mui-focused fieldset": {
                  borderColor: l.palette.action.selected
                }
              }
            }
          }
        )
      ] }),
      name: e,
      control: t
    }
  );
}, We = ({
  label: e,
  value: t
}) => /* @__PURE__ */ m(b, { spacing: 0.4, children: [
  e && /* @__PURE__ */ n(
    A,
    {
      sx: {
        fontWeight: "700"
      },
      children: e
    }
  ),
  /* @__PURE__ */ n(
    A,
    {
      sx: {
        minHeight: "1.5em",
        wordWrap: "break-word",
        wordBreak: "break-word",
        whiteSpace: "pre-line",
        color: "text.secondary"
      },
      children: t && t !== "" ? t : "-"
    }
  )
] }), fs = (e) => e.length < 4 ? e : e.length < 7 ? `(${e.slice(0, 3)})-${e.slice(3)}` : `(${e.slice(0, 3)})-${e.slice(3, 6)}-${e.slice(6, 10)}`, gs = (e) => {
  if (!e) return "";
  if (xi(e)) return e;
  const t = vi(e);
  if (!t) return e;
  const r = `+${t.countryCallingCode}`, i = t.nationalNumber, o = fs(i);
  return `${r} ${o}`;
}, fr = () => {
  const { userInfo: e, isInternalUser: t } = V(), { t: r } = R({
    keyPrefix: "USER_SETTINGS.PROFILE"
  }), { t: i } = R({}), [o, a] = E(!1), s = D(null), {
    isUserFederated: l,
    isUserManagedProfile: c,
    userProfile: d,
    updateUserProfile: p,
    userProfileLoading: h,
    isUpdateUserProfileLoading: u
  } = ae(), { commonProfileVisibility: f } = de(), g = (f == null ? void 0 : f.profile.telephoneNumber.enabled) ?? !0, [C, x] = E(!1), { setSnackOptions: O } = Ee(), {
    handleSubmit: v,
    control: T,
    reset: y,
    watch: M,
    formState: { errors: I, isDirty: L, isSubmitting: W }
  } = pt({
    defaultValues: {
      telephoneNumber: d == null ? void 0 : d.telephoneNumber,
      email: e ? Re(e) ?? "" : ""
    },
    resolver: kt(ps)
  }), U = Te(), F = D(null), J = e ? Re(e) : "", ue = M("email");
  S(() => {
    y({
      telephoneNumber: d == null ? void 0 : d.telephoneNumber,
      email: e ? Re(e) ?? "" : ""
    });
  }, [d, e]), S(
    function() {
      s.current && s.current.focus();
    },
    [o]
  ), S(
    function() {
      C && vt(F);
    },
    [C]
  );
  function ee() {
    a(!1);
  }
  const q = () => {
    y({
      telephoneNumber: d == null ? void 0 : d.telephoneNumber,
      email: e ? Re(e) ?? "" : ""
    }), x(!1);
  }, pe = (K) => {
    if (!d)
      return;
    if (ue !== J) {
      const he = { ...d, telephoneNumber: K.telephoneNumber };
      return p(he), a(!0);
    }
    const Ie = { ...d, ...K };
    return p(Ie).catch((he) => {
      O({
        open: !0,
        color: "error",
        message: he.message
      });
    }).finally(() => {
      x(!1);
    });
  }, Oe = h || !d || W || u;
  return e ? /* @__PURE__ */ m(
    St,
    {
      title: r("CONTACT_INFO"),
      icon: /* @__PURE__ */ n(ui, {}),
      onSave: C ? v(pe) : void 0,
      onCancel: C ? () => q() : void 0,
      editMode: C,
      setEditMode: x,
      loadingButton: Oe,
      cancelDisabled: Oe,
      disabled: C ? !L : !1,
      readonly: c(),
      children: [
        !e.email_verified && /* @__PURE__ */ n(nt, { severity: "error", children: /* @__PURE__ */ n(
          N,
          {
            display: "flex",
            justifyContent: "space-between",
            gap: "8px",
            alignItems: "center",
            children: /* @__PURE__ */ n(A, { children: /* @__PURE__ */ n(
              qr,
              {
                t: r,
                i18nKey: "EMAIL_UPDATE.VERIFY_ALERT",
                components: [
                  /* @__PURE__ */ n(
                    Ye,
                    {
                      onClick: () => {
                        a(!0);
                      },
                      sx: {
                        cursor: "pointer"
                      },
                      type: "button"
                    }
                  )
                ]
              }
            ) })
          }
        ) }),
        C ? /* @__PURE__ */ n("form", { ref: F, onSubmit: v(pe), children: /* @__PURE__ */ m(
          It,
          {
            container: !0,
            spacing: 2,
            sx: {
              textAlign: "left"
            },
            children: [
              g && /* @__PURE__ */ n(
                It,
                {
                  item: !0,
                  sx: {
                    flexBasis: "100%"
                  },
                  children: /* @__PURE__ */ n(
                    _t,
                    {
                      control: T,
                      name: "telephoneNumber",
                      render: ({ field: { onChange: K, value: Ie, ...he } }) => {
                        var Fe;
                        return /* @__PURE__ */ m(b, { spacing: 1, children: [
                          /* @__PURE__ */ n(
                            A,
                            {
                              sx: {
                                fontWeight: "500",
                                fontSize: "small",
                                color: U.palette.text.secondary
                              },
                              children: r("PHONE_NUMBER")
                            }
                          ),
                          /* @__PURE__ */ n(
                            Si,
                            {
                              fullWidth: !0,
                              disabled: Oe,
                              value: Ie ?? void 0,
                              ...he,
                              onChange: (me) => {
                                const Qe = gs(me);
                                K(Qe);
                              },
                              sx: {
                                "& .MuiOutlinedInput-root": {
                                  "& fieldset": {
                                    borderColor: U.palette.action.active
                                  },
                                  "&:hover fieldset": {
                                    borderColor: U.palette.action.hover
                                  },
                                  "&.Mui-focused fieldset": {
                                    borderColor: U.palette.action.selected
                                  }
                                }
                              }
                            }
                          ),
                          ((Fe = I.telephoneNumber) == null ? void 0 : Fe.message) && /* @__PURE__ */ n(Nr, { error: !0, children: i(
                            I.telephoneNumber.message
                          ) })
                        ] });
                      }
                    }
                  )
                }
              ),
              /* @__PURE__ */ n(It, { item: !0, sx: { flexBasis: "100%" }, children: /* @__PURE__ */ n(
                se,
                {
                  "data-element-id": "email-input",
                  control: T,
                  name: "email",
                  required: !0,
                  errors: I,
                  disabled: Oe || l || c() || !e.email_verified,
                  fullWidth: !0,
                  label: r("EMAIL"),
                  defaultValue: Re(e) ?? ""
                }
              ) })
            ]
          }
        ) }) : /* @__PURE__ */ m(b, { gap: 2, children: [
          g && /* @__PURE__ */ n(b, { gap: 0.4, children: /* @__PURE__ */ n(
            We,
            {
              label: r("PHONE_NUMBER"),
              value: d == null ? void 0 : d.telephoneNumber
            }
          ) }),
          /* @__PURE__ */ n(b, { gap: 0.4, children: /* @__PURE__ */ n(
            We,
            {
              label: r("EMAIL"),
              value: e ? Re(e) : ""
            }
          ) })
        ] }),
        !t && o && /* @__PURE__ */ n(us, { open: o, onClose: ee })
      ]
    }
  ) : /* @__PURE__ */ n(be, { variant: "rounded", height: 160 });
}, Cs = () => {
  const [e, t] = E(!1), { t: r } = R({
    keyPrefix: "USER_SETTINGS.PROFILE"
  }), {
    userProfile: i,
    updateUserProfile: o,
    isUpdateUserProfileLoading: a,
    userProfileLoading: s,
    isUserManagedProfile: l
  } = ae(), c = X(), { setSnackOptions: d } = Ee(), {
    handleSubmit: p,
    control: h,
    reset: u,
    formState: { errors: f, isDirty: g, isSubmitting: C }
  } = pt({
    defaultValues: {
      givenName: i == null ? void 0 : i.givenName,
      familyName: i == null ? void 0 : i.familyName
    },
    resolver: kt(ms)
  }), x = D(null);
  S(
    function() {
      e && vt(x);
    },
    [e]
  );
  const O = () => {
    u({
      givenName: i == null ? void 0 : i.givenName,
      familyName: i == null ? void 0 : i.familyName
    }), t(!1);
  };
  S(() => {
    O();
  }, [i]);
  const v = (y) => {
    if (!i)
      return;
    const M = { ...i, ...y };
    return o(M).catch((I) => {
      d({
        open: !0,
        color: "error",
        message: I.message
      });
    }).finally(() => {
      t(!1);
    });
  }, T = s || !i || C || a;
  return /* @__PURE__ */ n(
    St,
    {
      onSave: p(v),
      onCancel: () => O(),
      editMode: e,
      setEditMode: t,
      title: r("BASIC_INFO"),
      icon: /* @__PURE__ */ n(At, {}),
      loadingButton: T,
      cancelDisabled: T,
      disabled: !g,
      readonly: l() || !e,
      children: i && /* @__PURE__ */ n("form", { ref: x, onSubmit: p(v), children: e ? /* @__PURE__ */ m(
        $,
        {
          container: !0,
          spacing: 2,
          sx: {
            textAlign: "left"
          },
          children: [
            /* @__PURE__ */ n(
              $,
              {
                item: !0,
                sx: {
                  [c.breakpoints.down(w.Breakpoints.sm)]: {
                    flexBasis: "100%"
                  },
                  [c.breakpoints.up(w.Breakpoints.sm)]: {
                    flexBasis: "50%"
                  }
                },
                children: /* @__PURE__ */ n(
                  se,
                  {
                    control: h,
                    name: "givenName",
                    required: !0,
                    errors: f,
                    disabled: !0,
                    fullWidth: !0,
                    label: r("FIRST_NAME")
                  }
                )
              }
            ),
            /* @__PURE__ */ n(
              $,
              {
                item: !0,
                sx: {
                  [c.breakpoints.down(w.Breakpoints.sm)]: {
                    flexBasis: "100%"
                  },
                  [c.breakpoints.up(w.Breakpoints.sm)]: {
                    flexBasis: "50%"
                  }
                },
                children: /* @__PURE__ */ n(
                  se,
                  {
                    control: h,
                    name: "familyName",
                    required: !0,
                    errors: f,
                    disabled: !0,
                    fullWidth: !0,
                    label: r("LAST_NAME")
                  }
                )
              }
            ),
            /* @__PURE__ */ n(
              $,
              {
                item: !0,
                sx: {
                  flexBasis: "100%"
                }
              }
            )
          ]
        }
      ) : /* @__PURE__ */ m(b, { gap: 1, children: [
        /* @__PURE__ */ n(b, { gap: 0.4, children: /* @__PURE__ */ n(
          We,
          {
            value: i.givenName,
            label: r("FIRST_NAME")
          }
        ) }),
        /* @__PURE__ */ n(b, { gap: 0.4, children: /* @__PURE__ */ n(
          We,
          {
            value: i.familyName,
            label: r("LAST_NAME")
          }
        ) })
      ] }) })
    }
  );
}, Es = () => j(() => ut.sortBy(Object.values(Oi), "name"), []), xs = () => {
  const { t: e } = R({ keyPrefix: "COMMON.ADDRESS" }), [t, r] = E(!1), {
    userProfile: i,
    updateUserProfile: o,
    userProfileLoading: a,
    isUpdateUserProfileLoading: s,
    isUserManagedProfile: l
  } = ae(), { setSnackOptions: c } = Ee(), {
    handleSubmit: d,
    control: p,
    reset: h,
    formState: { errors: u, isDirty: f, isSubmitting: g }
  } = pt({
    defaultValues: i == null ? void 0 : i.address,
    resolver: kt(hs)
  });
  S(() => {
    C();
  }, [i]);
  const C = () => {
    h(i == null ? void 0 : i.address), r(!1);
  }, x = (M) => {
    if (!i)
      return;
    const I = { ...i, address: { ...i.address, ...M } };
    return o(I).catch((L) => {
      c({
        open: !0,
        color: "error",
        message: L.message
      });
    }).finally(() => {
      r(!1);
    });
  }, O = Es(), v = (M) => {
    var I, L;
    return {
      ...M,
      street: (I = M == null ? void 0 : M.street) == null ? void 0 : I.replaceAll(/./g, "*"),
      addressLine2: (L = M == null ? void 0 : M.addressLine2) == null ? void 0 : L.replaceAll(/./g, "*")
    };
  }, T = a || !i || g || s, y = D(null);
  return S(
    function() {
      vt(y);
    },
    [t]
  ), /* @__PURE__ */ n(
    St,
    {
      onSave: d(x),
      onCancel: () => C(),
      editMode: t,
      setEditMode: r,
      title: e("LABEL"),
      icon: /* @__PURE__ */ n(Ti, {}),
      loadingButton: T,
      cancelDisabled: T,
      disabled: !f,
      readonly: l(),
      children: i && /* @__PURE__ */ n("form", { ref: y, onSubmit: d(x), children: t ? /* @__PURE__ */ m($, { container: !0, spacing: 2, children: [
        /* @__PURE__ */ n($, { item: !0, xs: 12, sm: 8, children: /* @__PURE__ */ n(
          se,
          {
            "data-element-id": "street-address-input",
            control: p,
            name: "street",
            errors: u,
            disabled: T,
            fullWidth: !0,
            autoComplete: "street-address",
            label: e("STREET_ADDRESS")
          }
        ) }),
        /* @__PURE__ */ n($, { item: !0, xs: 12, sm: 4, children: /* @__PURE__ */ n(
          se,
          {
            "data-element-id": "address-line2-input",
            control: p,
            name: "addressLine2",
            errors: u,
            disabled: T,
            fullWidth: !0,
            autoComplete: "address-line2",
            label: e("APT_SUITE")
          }
        ) }),
        /* @__PURE__ */ n($, { item: !0, xs: 12, children: /* @__PURE__ */ n(
          se,
          {
            "data-element-id": "city-input",
            control: p,
            name: "city",
            errors: u,
            disabled: T,
            fullWidth: !0,
            autoComplete: "city",
            label: e("CITY")
          }
        ) }),
        /* @__PURE__ */ n($, { item: !0, xs: 12, sm: 6, children: /* @__PURE__ */ n(
          se,
          {
            "data-element-id": "state-input",
            control: p,
            name: "state",
            errors: u,
            disabled: T,
            fullWidth: !0,
            autoComplete: "state",
            label: e("STATE")
          }
        ) }),
        /* @__PURE__ */ n($, { item: !0, xs: 12, sm: 6, children: /* @__PURE__ */ n(
          se,
          {
            "data-element-id": "postal-code-input",
            control: p,
            name: "postalCode",
            errors: u,
            disabled: T,
            fullWidth: !0,
            autoComplete: "postal-code",
            label: e("POSTAL")
          }
        ) }),
        /* @__PURE__ */ n($, { item: !0, xs: 12, children: /* @__PURE__ */ n(
          _t,
          {
            render: ({ field: M }) => /* @__PURE__ */ m(yr, { fullWidth: !0, error: !!u.country, children: [
              /* @__PURE__ */ n(gn, { children: e("COUNTRY") }),
              /* @__PURE__ */ n(
                Ar,
                {
                  ...M,
                  error: !!u.country,
                  fullWidth: !0,
                  disabled: T,
                  label: e("COUNTRY"),
                  autoComplete: "country",
                  children: O.map((I) => /* @__PURE__ */ n(
                    Ne,
                    {
                      value: I.name,
                      children: I.name
                    },
                    I.name
                  ))
                }
              )
            ] }),
            name: "country",
            control: p
          }
        ) })
      ] }) : /* @__PURE__ */ n($, { container: !0, spacing: 2, children: /* @__PURE__ */ n($, { item: !0, xs: 12, children: /* @__PURE__ */ n(
        We,
        {
          value: Co(v(i == null ? void 0 : i.address))
        }
      ) }) }) })
    }
  );
}, gr = () => {
  const { t: e } = R({ keyPrefix: "USER_SETTINGS.PROFILE" }), t = X(), r = t.palette.mode === "dark";
  return /* @__PURE__ */ m(
    N,
    {
      border: "1px solid",
      borderColor: t.palette.divider,
      borderRadius: "12px",
      padding: "16px",
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      children: [
        /* @__PURE__ */ n(A, { fontWeight: "600", children: e("LOGOUT") }),
        /* @__PURE__ */ n(
          tn,
          {
            "data-element-id": "logout-button-profile",
            variant: "outlined",
            sx: {
              textTransform: "unset",
              borderRadius: "6px",
              minWidth: "90px",
              padding: "6px 12px",
              borderColor: t.palette.action.active,
              color: t.palette.text.primary,
              "&:hover": {
                backgroundColor: t.palette.action.hover,
                borderColor: r ? re.logoutButtonHoverBorderColor.dark : re.logoutButtonHoverBorderColor.light
              }
            }
          }
        )
      ]
    }
  );
}, Ss = () => {
  const { userProfileLoading: e } = ae(), { commonProfileVisibility: t, isLoading: r } = de(), i = (t == null ? void 0 : t.profile.address.enabled) ?? !0;
  return e || r ? /* @__PURE__ */ m(on, { gap: 2, children: [
    /* @__PURE__ */ n(be, { height: 160, variant: "rounded" }),
    /* @__PURE__ */ n(be, { height: 160, variant: "rounded" }),
    /* @__PURE__ */ n(be, { height: 160, variant: "rounded" })
  ] }) : /* @__PURE__ */ m(on, { gap: "16px", children: [
    /* @__PURE__ */ n(Cs, {}),
    /* @__PURE__ */ n(fr, {}),
    i && /* @__PURE__ */ n(xs, {}),
    /* @__PURE__ */ n(gr, {})
  ] });
}, vs = () => /* @__PURE__ */ n(xt, { children: /* @__PURE__ */ n(Ss, {}) }), tt = Ce(
  ({
    label: e,
    description: t,
    disabled: r,
    error: i,
    editMode: o,
    defaultValue: a,
    fullWidth: s,
    onChange: l,
    required: c
  }, d) => {
    const p = Yn(d);
    return o ? /* @__PURE__ */ m(b, { rowGap: "8px", children: [
      /* @__PURE__ */ n(gn, { required: c, error: !!i, children: e }),
      /* @__PURE__ */ n(
        $e,
        {
          required: c,
          defaultValue: a,
          inputRef: p,
          disabled: r,
          fullWidth: s,
          onChange: l,
          autoComplete: "off",
          error: !!i,
          onBlur: (h) => {
            h.target.value = h.target.value.trim();
          },
          InputProps: {
            sx: { borderRadius: w.BorderRadius.value }
          }
        }
      ),
      t && /* @__PURE__ */ n(A, { color: i ? "error" : void 0, fontSize: "14px", children: t })
    ] }) : /* @__PURE__ */ m(b, { rowGap: "8px", children: [
      /* @__PURE__ */ n(A, { variant: "subtitle2", fontWeight: "500", color: "text.primary", children: e }),
      /* @__PURE__ */ n(A, { variant: "body1", fontWeight: "400", color: "text.secondary", children: a || "" })
    ] });
  }
), Ts = () => {
  const { isInternalUser: e } = V(), { userProfile: t, updateUserProfile: r, isUpdateUserProfileLoading: i, userProfileLoading: o } = ae(), a = i || o, { t: s } = R({
    keyPrefix: "USER_SETTINGS.PROFILE"
  }), { t: l } = R({ keyPrefix: "COMMON" }), [c, d] = E(!1), p = D(null), h = D(null), [u, f] = E({
    firstName: null,
    lastName: null
  }), { setSnackOptions: g } = Ee(), C = (v, T) => {
    g({
      open: !0,
      message: v,
      color: T
    });
  }, x = () => {
    var T, y;
    if (!t || a) return;
    let v = { ...t };
    return v.givenName = (T = p.current) == null ? void 0 : T.value, v.familyName = (y = p.current) == null ? void 0 : y.value, r(v).then(() => {
      C(l("ALERTS.UPDATE_SUCCESS"), "success");
    }).catch(() => {
      C(l("ALERTS.UPDATE_FAILED"), "error");
    }).finally(() => {
      d(!1);
    });
  };
  function O() {
    d(!1);
  }
  return t ? e ? /* @__PURE__ */ n(Xe, { title: s("PERSONAL_INFO"), icon: /* @__PURE__ */ n(At, {}), children: /* @__PURE__ */ m(b, { gap: "8px", children: [
    /* @__PURE__ */ n(
      tt,
      {
        label: s("FIRST_NAME"),
        defaultValue: t.givenName,
        disabled: !0
      }
    ),
    /* @__PURE__ */ n(
      tt,
      {
        label: s("LAST_NAME"),
        defaultValue: t.familyName,
        disabled: !0
      }
    )
  ] }) }) : /* @__PURE__ */ n(
    St,
    {
      title: s("PERSONAL_INFO"),
      icon: /* @__PURE__ */ n(At, {}),
      editMode: c,
      setEditMode: d,
      disabled: !!u.firstName || !!u.lastName || a,
      loadingButton: a,
      cancelDisabled: a,
      onSave: x,
      onCancel: O,
      children: /* @__PURE__ */ m(b, { gap: "8px", children: [
        /* @__PURE__ */ n(
          tt,
          {
            ref: p,
            required: !0,
            label: s("FIRST_NAME"),
            error: u.firstName === Se.required,
            onChange: (v) => {
              Pt(v.target.value, "firstName", u, f);
            },
            editMode: c,
            defaultValue: t.givenName
          }
        ),
        /* @__PURE__ */ n(
          tt,
          {
            ref: h,
            required: !0,
            label: s("LAST_NAME"),
            error: u.lastName === Se.required,
            onChange: (v) => {
              Pt(v.target.value, "lastName", u, f);
            },
            editMode: c,
            defaultValue: t.familyName
          }
        )
      ] })
    }
  ) : /* @__PURE__ */ n(be, { variant: "rounded", height: 160 });
}, Os = () => {
  const { isInternalUser: e, _TEMPORARY_globalProfileOktaSdkEnabled: t } = V();
  return t ? /* @__PURE__ */ m(xt, { children: [
    /* @__PURE__ */ n(Ts, {}),
    /* @__PURE__ */ n(fr, {}),
    /* @__PURE__ */ n(gr, {})
  ] }) : /* @__PURE__ */ n(vs, {});
}, Is = ({ status: e }) => {
  const t = X();
  return /* @__PURE__ */ n(
    "div",
    {
      style: {
        flexBasis: 0,
        flexGrow: 1,
        position: "relative",
        maxWidth: "100%",
        width: "100%",
        height: "8px",
        backgroundColor: e === "complete" ? t.palette.success.main : "#D9D9D9"
      }
    }
  );
}, Rs = ({
  value: e,
  max: t,
  message: r
}) => /* @__PURE__ */ m("div", { children: [
  /* @__PURE__ */ m(
    "div",
    {
      style: {
        display: "flex",
        gap: "8px",
        alignItems: "center"
      },
      children: [
        ut.range(t + 1).map((i) => /* @__PURE__ */ n(Is, { status: i <= e ? "complete" : "incomplete" })),
        e === t ? /* @__PURE__ */ n(Vt, { color: "success" }) : /* @__PURE__ */ n(zt, { color: "error" })
      ]
    }
  ),
  /* @__PURE__ */ n(ht, { children: r })
] });
class ot {
  constructor() {
    Q(this, "length");
    Q(this, "uppercase");
    Q(this, "lowercase");
    Q(this, "numbers");
    Q(this, "special");
    Q(this, "match");
    Q(this, "doesNotContainName");
    Q(this, "totalFields", 7);
  }
  get validFields() {
    return (this.length ? 1 : 0) + (this.uppercase ? 1 : 0) + (this.lowercase ? 1 : 0) + (this.numbers ? 1 : 0) + (this.special ? 1 : 0) + (this.doesNotContainName ? 1 : 0);
  }
  isValid() {
    return !!this.length && !!this.uppercase && !!this.lowercase && !!this.numbers && !!this.special && !!this.doesNotContainName;
  }
  matches() {
    return this.match;
  }
  static validatePassword(t, r, i, o) {
    let a = new ot();
    return a.match = !1, a.length = t.length >= Y.minimumLength, a.uppercase = Y.uppercaseRegEx.test(t), a.lowercase = Y.lowerCaseRegEx.test(t), a.numbers = Y.numberRegexp.test(t), a.special = Y.specialCharRegexp.test(t), a.match = t === r, a.doesNotContainName = !(t.includes(i) || t.includes(o)), a;
  }
}
const Y = {
  minimumLength: 12,
  minimumUppercase: 1,
  minimumLowercase: 1,
  minimumNumbers: 1,
  minimumSpecial: 1,
  specialCharRegexp: /[!@#$%&*+~<>?\[\]{}]+/i,
  numberRegexp: /\d+/i,
  uppercaseRegEx: /[A-Z]+/,
  lowerCaseRegEx: /[a-z]+/
}, bs = ({ passwordValid: e }) => {
  const { t } = R({ keyPrefix: "USER_SETTINGS.SECURITY.PASSWORD_RESET" }), r = Z();
  let i = [
    {
      valid: e.length,
      resetText: t("REQUIREMENTS.MIN_CHARS", {
        number: Y.minimumLength
      })
    },
    {
      valid: e.uppercase,
      resetText: t("REQUIREMENTS.MIN_UPPER", {
        number: Y.minimumUppercase
      })
    },
    {
      valid: e.lowercase,
      resetText: t("REQUIREMENTS.MIN_LOWER", {
        number: Y.minimumLowercase
      })
    },
    {
      valid: e.numbers,
      resetText: t("REQUIREMENTS.MIN_NUMBER", {
        number: Y.minimumNumbers
      })
    },
    {
      valid: e.special,
      resetText: t("REQUIREMENTS.MIN_SPECIAL", {
        number: Y.minimumSpecial
      })
    },
    {
      valid: e.doesNotContainName,
      resetText: t("REQUIREMENTS.CONTAINS_NAME")
    },
    {
      valid: e.match,
      resetText: t("REQUIREMENTS.MATCH")
    }
  ];
  return /* @__PURE__ */ m(
    N,
    {
      pl: "10%",
      sx: {
        marginTop: r ? 1 : 0,
        paddingLeft: r ? 0 : "10%"
      },
      children: [
        /* @__PURE__ */ n(
          ht,
          {
            variant: "caption",
            align: "left",
            sx: {
              float: "left",
              fontSize: 14,
              marginBottom: 3,
              lineHeight: "14px"
            },
            children: t("REQUIREMENTS.HEADER")
          }
        ),
        /* @__PURE__ */ n(
          Ii,
          {
            sx: {
              ml: 0,
              paddingBottom: 0
            },
            children: i.map((o) => /* @__PURE__ */ n(
              Ns,
              {
                valid: !!o.valid,
                description: o.resetText
              },
              o.resetText
            ))
          }
        )
      ]
    }
  );
}, Ns = (e) => /* @__PURE__ */ m(Ri, { sx: { padding: "0", paddingBottom: 0.5 }, children: [
  e.valid ? /* @__PURE__ */ n(Vt, { color: "success" }) : /* @__PURE__ */ n(zt, { color: "error" }),
  /* @__PURE__ */ n(ht, { variant: "caption", sx: { marginLeft: "8px", fontSize: 14 }, children: e.description })
] }), ys = ({ passwordValid: e }) => {
  const { t } = R({ keyPrefix: "USER_SETTINGS.SECURITY.PASSWORD_RESET" });
  let r = [
    {
      valid: e.length,
      resetText: t("REQUIREMENTS.MIN_CHARS", {
        number: Y.minimumLength
      })
    },
    {
      valid: e.uppercase,
      resetText: t("REQUIREMENTS.MIN_UPPER", {
        number: Y.minimumUppercase
      })
    },
    {
      valid: e.lowercase,
      resetText: t("REQUIREMENTS.MIN_LOWER", {
        number: Y.minimumLowercase
      })
    },
    {
      valid: e.numbers,
      resetText: t("REQUIREMENTS.MIN_NUMBER", {
        number: Y.minimumNumbers
      })
    },
    {
      valid: e.special,
      resetText: t("REQUIREMENTS.MIN_SPECIAL", {
        number: Y.minimumSpecial
      })
    },
    {
      valid: e.doesNotContainName,
      resetText: t("REQUIREMENTS.CONTAINS_NAME")
    }
  ];
  return /* @__PURE__ */ n(
    Rs,
    {
      value: e.validFields,
      max: e.totalFields - 1,
      message: e.isValid() ? void 0 : "Your password should contain at least " + r.filter((i) => !i.valid).map((i) => i.resetText).join(", ")
    }
  );
}, As = ({ passwordValid: e }) => /* @__PURE__ */ n("div", { children: /* @__PURE__ */ m(
  "div",
  {
    style: {
      display: "flex",
      gap: "8px",
      alignItems: "center"
    },
    children: [
      /* @__PURE__ */ n(ht, { children: "Password matches" }),
      e.match ? /* @__PURE__ */ n(Vt, { color: "success" }) : /* @__PURE__ */ n(zt, { color: "error" })
    ]
  }
) }), yt = ({
  label: e,
  value: t,
  error: r,
  setValue: i,
  setTouched: o
}) => {
  const [a, s] = E(!0);
  return /* @__PURE__ */ n(
    Ni,
    {
      "data-element-id": e,
      "data-cy": e,
      label: e,
      value: t,
      error: r,
      type: a ? "password" : "text",
      onChange: (d) => {
        i(d.target.value), o(!0);
      },
      fullWidth: !0,
      required: !0,
      InputProps: {
        endAdornment: /* @__PURE__ */ n(wr, { position: "end", sx: { width: "auto" }, children: /* @__PURE__ */ n(
          yi,
          {
            "aria-label": "toggle password visibility",
            onClick: () => {
              s((d) => !d);
            },
            onMouseDown: (d) => d.preventDefault(),
            edge: "end",
            tabIndex: 1,
            children: a ? /* @__PURE__ */ n(Ai, {}) : /* @__PURE__ */ n(wi, {})
          }
        ) })
      }
    }
  );
}, ws = ({
  firstName: e,
  lastName: t,
  onClose: r
}) => {
  const { t: i } = R({ keyPrefix: "USER_SETTINGS.SECURITY.PASSWORD_RESET" }), o = Z(), a = X(), [s, l] = E(!1), [c, d] = E(!1), [p, h] = E(!1), [u, f] = E(!1), [g, C] = E(!1), [x, O] = E(""), [v, T] = E(""), [y, M] = E(""), [I, L] = E(
    ot.validatePassword(v, y, e, t)
  ), { setSnackOptions: W } = Ee(), U = D(null);
  S(() => {
    requestAnimationFrame(() => {
      vt(U);
    });
  }, []), S(() => {
    L(
      ot.validatePassword(v, y, e, t)
    );
  }, [v, x, y, e, t]);
  const F = () => {
    W({
      open: !0,
      color: "success",
      message: i("SUCCESS").toString()
    }), r();
  };
  async function J() {
    C(!0), so({
      oldPassword: x,
      newPassword: v
    }).then(F).catch((ee) => {
      if (ee.message) {
        let q = "";
        ee.message.includes("Password has been used too recently") ? q = i("ERROR.RECENT_PASSWORD").toString() : ee.message.includes("Old Password is not correct") ? q = i("ERROR.CURR_PASSWORD").toString() : ee.message.includes("Password cannot be your current password") && (q = i("ERROR.SAME_CURR_AND_NEW_PASSWORD").toString()), W({
          open: !0,
          color: "error",
          message: q
        });
      } else
        W({
          open: !0,
          color: "error",
          message: i("ERROR.FAILED").toString()
        });
    }).finally(() => {
      C(!1);
    });
  }
  async function ue() {
    r();
  }
  return S(() => {
    f(x.length > 0);
  }, [x]), /* @__PURE__ */ m(
    Tt,
    {
      open: !0,
      onClose: ue,
      PaperProps: { sx: { borderRadius: w.DialogBorderRadius.value } },
      maxWidth: !1,
      children: [
        /* @__PURE__ */ n(He, { children: /* @__PURE__ */ m(
          N,
          {
            display: "flex",
            flexDirection: "row",
            justifyContent: "flex-start",
            alignItems: "center",
            gap: "16px",
            children: [
              /* @__PURE__ */ n(A, { variant: "h5", fontWeight: "600", children: i("HEADING") }),
              !o && /* @__PURE__ */ n(
                Ye,
                {
                  "data-element-id": "password-policy-link",
                  href: `${_.IdmUrl}/knowledge-base/password-policies`,
                  target: "_blank",
                  style: {
                    textDecoration: "none",
                    fontSize: 13
                  },
                  children: i("POLICY")
                }
              )
            ]
          }
        ) }),
        /* @__PURE__ */ n(
          at,
          {
            sx: {
              width: o ? w.MobileDialogWidth.value : "auto"
            },
            children: /* @__PURE__ */ m(b, { gap: "16px", children: [
              /* @__PURE__ */ m($, { container: !0, spacing: 2, direction: "row", children: [
                /* @__PURE__ */ n(
                  $,
                  {
                    item: !0,
                    sx: {
                      [a.breakpoints.up(w.Breakpoints.sm)]: {
                        maxWidth: "66.67%",
                        flexBasis: "66.67%"
                      },
                      [a.breakpoints.up(w.Breakpoints.xs)]: {
                        maxWidth: "100%",
                        flexBasis: "100%"
                      }
                    },
                    children: /* @__PURE__ */ m(b, { gap: "16px", mt: 2, children: [
                      O && /* @__PURE__ */ n("form", { ref: U, children: /* @__PURE__ */ n(
                        yt,
                        {
                          label: i("CURRENT_PASSWORD"),
                          error: !u && s,
                          setValue: O,
                          setTouched: l
                        }
                      ) }),
                      /* @__PURE__ */ n(
                        yt,
                        {
                          value: v,
                          label: i("NEW_PASSWORD"),
                          error: !I.isValid() && c,
                          setValue: T,
                          setTouched: d
                        }
                      ),
                      o && c && /* @__PURE__ */ n(ys, { passwordValid: I }),
                      /* @__PURE__ */ n(
                        yt,
                        {
                          value: y,
                          label: i("CONFIRM"),
                          error: !I.match && p,
                          setValue: M,
                          setTouched: h
                        }
                      ),
                      o && p && /* @__PURE__ */ n(As, { passwordValid: I })
                    ] })
                  }
                ),
                !o && /* @__PURE__ */ n(
                  $,
                  {
                    item: !0,
                    sx: {
                      [a.breakpoints.up(w.Breakpoints.sm)]: {
                        maxWidth: "33.33%",
                        flexBasis: "33.33%"
                      },
                      [a.breakpoints.up(w.Breakpoints.xs)]: {
                        maxWidth: "100%",
                        flexBasis: "100%"
                      }
                    },
                    children: /* @__PURE__ */ n(bs, { passwordValid: I })
                  }
                )
              ] }),
              /* @__PURE__ */ n(
                bi,
                {
                  "data-element-id": "password-submit-button",
                  variant: "contained",
                  fullWidth: !0,
                  onClick: J,
                  disabled: !I.isValid() || !I.matches() || !u,
                  loading: g,
                  sx: {
                    textTransform: "unset"
                  },
                  children: i("SUBMIT")
                }
              )
            ] })
          }
        )
      ]
    }
  );
}, Ps = () => {
  const { t: e } = R({
    keyPrefix: "USER_SETTINGS.SECURITY"
  }), [t, r] = E(!1), { userProfile: i } = xo();
  function o() {
    r(!1);
  }
  return /* @__PURE__ */ n(Xe, { title: e("CREDENTIALS"), icon: /* @__PURE__ */ n(Pi, {}), children: /* @__PURE__ */ m(ts, { name: e("PASSWORD"), description: e("CHANGE_PASSWORD_SUBTITLE"), children: [
    t && /* @__PURE__ */ n(
      ws,
      {
        firstName: (i == null ? void 0 : i.givenName) ?? "",
        lastName: (i == null ? void 0 : i.familyName) ?? "",
        onClose: o
      }
    ),
    /* @__PURE__ */ n(
      le,
      {
        "data-element-id": "change-password-button",
        variant: "outlined",
        disabled: t,
        sx: {
          textTransform: "unset"
        },
        onClick: () => {
          r(!0);
        },
        children: e("CHANGE_PASSWORD")
      }
    )
  ] }) });
}, Ls = () => /* @__PURE__ */ n(xt, { children: /* @__PURE__ */ n(Ps, {}) }), Cr = (e) => {
  const t = X(), r = {
    "& svg path": {
      fill: t.palette.text.primary
    }
  };
  return /* @__PURE__ */ n(N, { ...e, children: /* @__PURE__ */ n(
    N,
    {
      sx: t.palette.mode === "dark" ? r : {},
      width: "100%",
      position: "relative",
      paddingTop: "14.225%",
      children: /* @__PURE__ */ m(
        "svg",
        {
          style: {
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%"
          },
          width: "703",
          height: "100",
          viewBox: "0 0 703 100",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
          children: [
            /* @__PURE__ */ m("g", { clipPath: "url(#clip0_172_14979)", children: [
              /* @__PURE__ */ n(
                "path",
                {
                  d: "M19.82 43.7693V97.0393H0V1.56934H0.38L61.24 56.2393V2.95934H81.19V98.4393H80.81L19.82 43.7693Z",
                  fill: "black"
                }
              ),
              /* @__PURE__ */ n(
                "path",
                {
                  d: "M97.1992 49.9996C97.1992 21.3896 118.289 1.30957 148.019 1.30957C157.419 1.30957 164.919 2.95957 171.269 5.88957V25.0896C165.169 21.7796 157.289 20.0096 148.019 20.0096C128.709 20.0096 117.399 32.0896 117.399 50.0096C117.399 67.9296 128.709 80.0096 148.019 80.0096C157.289 80.0096 165.169 78.2296 171.269 74.9196V93.9896C164.919 97.0396 157.419 98.6896 148.019 98.6896C118.289 98.6896 97.1992 78.4796 97.1992 49.9996Z",
                  fill: "black"
                }
              ),
              /* @__PURE__ */ n(
                "path",
                {
                  d: "M190.131 2.95996H220.751C244.001 2.95996 256.831 15.93 256.831 35.12C256.831 47.33 251.111 57.24 238.661 61.94L259.751 97.03H237.261L209.941 49.99H221.121C230.901 49.99 236.751 44.01 236.751 35.12C236.751 26.23 230.651 20.37 221.001 20.37H209.951V97.03H190.131V2.95996Z",
                  fill: "black"
                }
              ),
              /* @__PURE__ */ n(
                "path",
                {
                  d: "M286.82 2.95996H308.67L332.18 55.34L355.56 2.95996H377.41L332.31 98.56H331.8L286.82 2.95996Z",
                  fill: "black"
                }
              ),
              /* @__PURE__ */ n(
                "path",
                {
                  d: "M512.18 60.05L479.02 2.95996H501.64L522.1 39.7L542.56 2.95996H565.18L532.02 60.04V97.04H512.2V60.04L512.18 60.05Z",
                  fill: "black"
                }
              ),
              /* @__PURE__ */ n("path", { d: "M580.09 2.95996H599.91V97.04H580.09V2.95996Z", fill: "black" }),
              /* @__PURE__ */ n(
                "path",
                {
                  d: "M657.91 64.1197L636.95 97.0497H613.32L645.59 48.9897L614.72 2.96973H638.35L658.04 33.7397L677.73 2.96973H701.36L670.36 48.8697L702.76 97.0497H679.13L657.91 64.1197Z",
                  fill: "black"
                }
              ),
              /* @__PURE__ */ n(
                "path",
                {
                  d: "M445.799 24.4996C452.382 24.4996 457.719 19.1584 457.719 12.5696C457.719 5.98089 452.382 0.639648 445.799 0.639648C439.216 0.639648 433.879 5.98089 433.879 12.5696C433.879 19.1584 439.216 24.4996 445.799 24.4996Z",
                  fill: "#5F249F"
                }
              ),
              /* @__PURE__ */ n(
                "path",
                {
                  d: "M413 99.36C419.583 99.36 424.92 94.0188 424.92 87.43C424.92 80.8412 419.583 75.5 413 75.5C406.417 75.5 401.08 80.8412 401.08 87.43C401.08 94.0188 406.417 99.36 413 99.36Z",
                  fill: "#5F249F"
                }
              ),
              /* @__PURE__ */ n(
                "path",
                {
                  d: "M414.549 23.86C421.132 23.86 426.469 18.5188 426.469 11.93C426.469 5.34124 421.132 0 414.549 0C407.966 0 402.629 5.34124 402.629 11.93C402.629 18.5188 407.966 23.86 414.549 23.86Z",
                  fill: "#5F249F"
                }
              ),
              /* @__PURE__ */ n(
                "path",
                {
                  d: "M444.26 99.9904C450.843 99.9904 456.18 94.6536 456.18 88.0704C456.18 81.4872 450.843 76.1504 444.26 76.1504C437.677 76.1504 432.34 81.4872 432.34 88.0704C432.34 94.6536 437.677 99.9904 444.26 99.9904Z",
                  fill: "#5F249F"
                }
              ),
              /* @__PURE__ */ n(
                "path",
                {
                  d: "M392 45.5299C398.583 45.5299 403.92 40.1887 403.92 33.5999C403.92 27.0112 398.583 21.6699 392 21.6699C385.417 21.6699 380.08 27.0112 380.08 33.5999C380.08 40.1887 385.417 45.5299 392 45.5299Z",
                  fill: "#5F249F"
                }
              ),
              /* @__PURE__ */ n(
                "path",
                {
                  d: "M466.809 78.3405C473.392 78.3405 478.729 72.9992 478.729 66.4105C478.729 59.8217 473.392 54.4805 466.809 54.4805C460.225 54.4805 454.889 59.8217 454.889 66.4105C454.889 72.9992 460.225 78.3405 466.809 78.3405Z",
                  fill: "#5F249F"
                }
              ),
              /* @__PURE__ */ n(
                "path",
                {
                  d: "M391.359 76.8004C397.943 76.8004 403.279 71.4592 403.279 64.8704C403.279 58.2817 397.943 52.9404 391.359 52.9404C384.776 52.9404 379.439 58.2817 379.439 64.8704C379.439 71.4592 384.776 76.8004 391.359 76.8004Z",
                  fill: "#5F249F"
                }
              ),
              /* @__PURE__ */ n(
                "path",
                {
                  d: "M467.449 47.07C474.033 47.07 479.369 41.7287 479.369 35.14C479.369 28.5512 474.033 23.21 467.449 23.21C460.866 23.21 455.529 28.5512 455.529 35.14C455.529 41.7287 460.866 47.07 467.449 47.07Z",
                  fill: "#5F249F"
                }
              )
            ] }),
            /* @__PURE__ */ n("defs", { children: /* @__PURE__ */ n("clipPath", { id: "clip0_172_14979", children: /* @__PURE__ */ n("rect", { width: "702.76", height: "100", fill: "white" }) }) })
          ]
        }
      )
    }
  ) });
}, Ms = 22, Us = "account-tab", Ds = "account-tabpanel", Fs = (e) => ({
  id: `${Us}-${e}`,
  "aria-controls": `${Ds}-${e}`
}), _s = {
  width: "100%",
  maxWidth: "820px"
}, ks = () => {
  const { t: e } = R({
    keyPrefix: "USER_SETTINGS"
  });
  return /* @__PURE__ */ m(b, { fontSize: `${Ms}px`, direction: "row", columnGap: "8px", alignItems: "flex-end", children: [
    /* @__PURE__ */ n(Cr, { width: "122px" }),
    /* @__PURE__ */ n(A, { lineHeight: 0.7, fontWeight: 400, variant: "h4", fontSize: "20px", children: e("TITLE") })
  ] });
}, zs = ({
  tabs: e,
  activeTabIndex: t,
  handleTabChange: r,
  collapsed: i = !1
}) => {
  const o = Z(), { t: a } = R({
    keyPrefix: "USER_SETTINGS"
  });
  return /* @__PURE__ */ m(
    b,
    {
      sx: {
        padding: `8px ${w.UserSettingsPadding[o ? "mobileValue" : "value"]} 0px`,
        borderBottom: "1px solid",
        borderColor: "divider",
        backgroundColor: "background.default"
      },
      children: [
        /* @__PURE__ */ n(Pr, { in: !i, children: /* @__PURE__ */ n(
          "div",
          {
            style: {
              padding: "16px"
            },
            children: /* @__PURE__ */ n(ks, {})
          }
        ) }),
        /* @__PURE__ */ n(b, { alignItems: "flex-start", rowGap: "24px", ..._s, children: /* @__PURE__ */ n(
          Lr,
          {
            sx: (s) => ({
              ".MuiTabs-indicator": {
                backgroundColor: s.palette.text.primary
              }
            }),
            value: t,
            onChange: r,
            children: e.map((s, l) => /* @__PURE__ */ n(
              Mr,
              {
                sx: (c) => ({
                  textTransform: "none",
                  "&.Mui-selected": {
                    color: c.palette.text.primary
                  }
                }),
                label: s.title,
                ...Fs(l)
              },
              s.title
            ))
          }
        ) })
      ]
    }
  );
}, Vs = 22, Bs = "account-tab", Gs = "account-tabpanel", Ws = (e) => ({
  id: `${Bs}-${e}`,
  "aria-controls": `${Gs}-${e}`
}), Hs = () => {
  const { t: e } = R({
    keyPrefix: "USER_SETTINGS"
  });
  return /* @__PURE__ */ m(b, { fontSize: `${Vs}px`, direction: "row", columnGap: "8px", alignItems: "flex-end", children: [
    /* @__PURE__ */ n(Cr, { width: "122px" }),
    /* @__PURE__ */ n(A, { lineHeight: 0.7, fontWeight: 400, variant: "h4", fontSize: "20px", children: e("TITLE") })
  ] });
}, $s = ({
  tabs: e,
  activeTabIndex: t,
  handleTabChange: r
}) => /* @__PURE__ */ m(
  b,
  {
    sx: {
      backgroundColor: "background.default",
      width: "240px",
      height: "inherit",
      padding: "12px",
      borderRight: "1px solid",
      borderColor: "divider"
    },
    children: [
      /* @__PURE__ */ n(
        "div",
        {
          style: {
            padding: "16px"
          },
          children: /* @__PURE__ */ n(Hs, {})
        }
      ),
      /* @__PURE__ */ n(Ze, { children: e.map((i, o) => {
        const a = "16px", s = t === o;
        return /* @__PURE__ */ m(
          lt,
          {
            selected: s,
            ...Ws(o),
            onClick: (l) => r(l, o),
            sx: {
              borderRadius: "8px",
              my: "8px",
              height: "36px",
              "&.Mui-selected": {
                backgroundColor: "action.selected"
              },
              "&:hover": {
                backgroundColor: "action.hover"
              }
            },
            children: [
              /* @__PURE__ */ n(
                Ur,
                {
                  sx: {
                    minWidth: `calc(${a} + 8px)`,
                    ".MuiSvgIcon-root": {
                      fontSize: a,
                      width: a,
                      height: a,
                      color: s ? "text.primary" : "text.secondary"
                    }
                  },
                  children: i.icon
                }
              ),
              /* @__PURE__ */ n(
                Dr,
                {
                  primaryTypographyProps: {
                    fontSize: "14px",
                    fontWeight: "600",
                    color: s ? "text.primary" : "text.secondary"
                  },
                  children: i.title
                }
              )
            ]
          },
          i.title
        );
      }) })
    ]
  }
), Zs = () => {
  const e = Te();
  return vn(e.breakpoints.up(w.Breakpoints.md));
}, Ke = ({
  title: e,
  description: t,
  children: r,
  infoIcon: i,
  sx: o = {}
}) => {
  const a = Z();
  return /* @__PURE__ */ m(
    N,
    {
      display: "flex",
      flexDirection: a ? "column" : "row",
      justifyContent: "space-between",
      alignItems: a ? "flex-start" : "center",
      gap: 2,
      sx: {
        width: "100%",
        ...o
      },
      children: [
        /* @__PURE__ */ m(N, { flex: 1, flexShrink: 1, display: "flex", flexDirection: "column", gap: 0.5, children: [
          /* @__PURE__ */ m(N, { display: "flex", alignItems: "center", gap: 1, children: [
            /* @__PURE__ */ n(A, { fontWeight: 500, variant: "subtitle2", children: e }),
            i
          ] }),
          /* @__PURE__ */ n(A, { variant: "body2", color: (s) => s.palette.text.secondary, children: t })
        ] }),
        /* @__PURE__ */ n(
          N,
          {
            flexShrink: 0,
            sx: {
              textAlign: "right",
              width: a ? "100%" : "290px"
            },
            children: r
          }
        )
      ]
    }
  );
}, Ys = (e) => `${e.clientWidth}px`, Ot = ({
  isMenuOpen: e,
  onMenuClose: t,
  menuContent: r,
  ...i
}) => {
  const o = D(null), [a, s] = E("");
  return S(() => {
    e && o.current && s(Ys(o.current));
  }, [e, o]), /* @__PURE__ */ m(gt, { config: Pe(), children: [
    /* @__PURE__ */ n(
      $t,
      {
        ref: o,
        buttonSx: {
          border: "1px solid",
          borderColor: (l) => l.palette.action.active,
          padding: "10px 12px",
          width: "100%",
          maxWidth: "unset",
          ".MuiLoadingButton-loadingIndicator": {
            left: "12px"
          }
        },
        labelSx: {
          fontWeight: 500
        },
        endIcon: /* @__PURE__ */ n(
          Wr,
          {
            fontSize: "small",
            sx: {
              color: (l) => l.palette.action.active,
              height: "24px",
              width: "24px"
            }
          }
        ),
        ...i
      }
    ),
    /* @__PURE__ */ n(
      Et,
      {
        anchorRef: o,
        menuOpen: e,
        onMenuClose: t,
        menuPaperSx: {
          width: a,
          maxHeight: "235px"
        },
        children: r
      }
    )
  ] });
}, qs = ({
  options: e,
  selectedRegion: t,
  onOptionClick: r
}) => e.map((i) => {
  const o = i.value === t;
  return /* @__PURE__ */ m(
    De,
    {
      selected: o,
      onClick: () => r(i.value),
      sx: { display: "flex", justifyContent: "space-between", alignItems: "center" },
      children: [
        /* @__PURE__ */ n(A, { variant: "subtitle2", children: i.viewValue }),
        o && /* @__PURE__ */ n(mt, {})
      ]
    },
    i.value
  );
}), js = () => {
  const { userPreferences: e, updateUserPreferences: t, isUserPreferencesLoading: r } = Ue(), { commonProfileVisibility: i } = de(), o = i == null ? void 0 : i.preferences.dateTime.region.whitelist, { t: a } = R({
    keyPrefix: "USER_SETTINGS.PREFERENCES.DATE_TIME.REGION"
  });
  let s = [
    { value: Be.US, viewValue: "United States" },
    { value: Be.MEXICO, viewValue: "Mexico" },
    { value: Be.CANADA, viewValue: "Canada" }
  ];
  o && (s = s.filter((x) => o.includes(x.value)));
  const [l, c] = E(!1), d = r || l, [p, h] = E(!1), u = () => h(!0), f = () => h(!1), g = async (x) => {
    c(!0), h(!1), await t({ region: x }), c(!1);
  }, C = s.find((x) => x.value === (e == null ? void 0 : e.region));
  return /* @__PURE__ */ n(
    Ke,
    {
      title: a("TITLE"),
      description: a("DESCRIPTION"),
      infoIcon: /* @__PURE__ */ n(Ut, { title: a("INFO"), children: /* @__PURE__ */ n(
        ie,
        {
          size: "small",
          "aria-label": `information icon: ${a("INFO")}`,
          sx: {
            borderRadius: "8px"
          },
          children: /* @__PURE__ */ n(Bt, { fontSize: "small", color: "action" })
        }
      ) }),
      children: /* @__PURE__ */ n(
        Ot,
        {
          "data-element-id": "region-preferences-switcher",
          isReadOnly: !1,
          isEmpty: !1,
          isLoading: d,
          label: C == null ? void 0 : C.viewValue,
          isMenuOpen: p,
          onMenuClose: f,
          "aria-label": `Selected region: ${C == null ? void 0 : C.viewValue}`,
          onClick: u,
          menuContent: qs({
            options: s,
            selectedRegion: e == null ? void 0 : e.region,
            onOptionClick: g
          })
        }
      )
    }
  );
}, Xs = () => {
  const { commonProfileVisibility: e } = de(), t = (e == null ? void 0 : e.preferences.dateTime.region.enabled) ?? !0, { t: r } = R({
    keyPrefix: "USER_SETTINGS.PREFERENCES.DATE_TIME"
  });
  return t ? /* @__PURE__ */ n(Xe, { title: r("TITLE"), icon: /* @__PURE__ */ n(Hr, {}), children: t && /* @__PURE__ */ n(js, {}) }) : /* @__PURE__ */ n(we, {});
}, Ks = () => {
  const e = D(!0), t = D(null), [r, i] = E(), [o, a] = E(), {
    userPreferences: s,
    isUserPreferencesLoading: l,
    isUserPreferencesValidating: c,
    isUserPreferencesMutating: d,
    updateUserPreferences: p
  } = Ue();
  return S(() => {
    if (e.current && t.current) {
      const u = (s == null ? void 0 : s.defaultOrganizationId) || "";
      i(u), a(u), t.current.value = u, e.current = !1;
    }
  }, [s == null ? void 0 : s.defaultOrganizationId, t]), /* @__PURE__ */ n(N, { width: "100%", children: /* @__PURE__ */ n(
    qn,
    {
      ref: t,
      onCtaClick: async (u) => {
        u && await p({ defaultOrganizationId: u.organizationName });
      },
      searchTerm: r,
      setSearchTerm: i,
      activeTerm: o,
      setActiveTerm: a,
      isDisabled: d || c || l
    }
  ) });
}, Qs = (e, t, r) => e.map((i) => {
  const o = i.organizationName, a = o === t;
  return /* @__PURE__ */ m(
    De,
    {
      selected: a,
      onClick: () => r(o),
      sx: { display: "flex", justifyContent: "space-between", alignItems: "center" },
      children: [
        /* @__PURE__ */ n(A, { variant: "subtitle2", children: o }),
        a && /* @__PURE__ */ n(mt, {})
      ]
    },
    o
  );
}), Js = () => {
  const { t: e } = R(), [t, r] = E(!1), { userOrganizations: i } = B(), [o, a] = E(!1), { userPreferences: s, isUserPreferencesLoading: l, updateUserPreferences: c } = Ue(), d = l || o, p = !d && i.length === 0, h = () => {
    r(!0);
  }, u = () => {
    r(!1);
  }, f = async (C) => {
    a(!0), r(!1), await c({ defaultOrganizationId: C }), a(!1);
  };
  let g;
  return p ? g = e("ORG_CONTEXT.SWITCHER.EMPTY") : d ? g = e("COMMON.LOADING") : g = (s == null ? void 0 : s.defaultOrganizationId) || e("USER_SETTINGS.PREFERENCES.DEFAULTS.ORGANIZATION.EMPTY"), /* @__PURE__ */ n(
    Ot,
    {
      "data-element-id": "org-preferences-switcher",
      disabled: !d && (i == null ? void 0 : i.length) == 0,
      isLoading: d,
      isEmpty: p,
      onClick: h,
      startIcon: /* @__PURE__ */ n(ft, { startIcon: /* @__PURE__ */ n(On, {}), isLoading: d }),
      isMenuOpen: t,
      onMenuClose: u,
      "aria-label": `Selected organization: ${s == null ? void 0 : s.defaultOrganizationId}`,
      menuContent: Qs(
        i,
        s == null ? void 0 : s.defaultOrganizationId,
        f
      ),
      label: g
    }
  );
}, el = () => {
  const { t: e } = R({
    keyPrefix: "USER_SETTINGS.PREFERENCES.DEFAULTS.ORGANIZATION"
  }), { totalOrganizations: t } = B(), r = (t ?? 0) > P.EffectiveOrgsLimit;
  let i;
  return r ? i = /* @__PURE__ */ n(Ks, {}) : i = /* @__PURE__ */ n(Js, {}), /* @__PURE__ */ n(Ke, { title: e("TITLE"), description: e("DESCRIPTION"), children: i });
}, tl = () => {
  const { commonProfileVisibility: e } = de(), t = (e == null ? void 0 : e.preferences.defaults.organization.enabled) ?? !0, { t: r } = R({
    keyPrefix: "USER_SETTINGS.PREFERENCES.DEFAULTS"
  });
  return t ? /* @__PURE__ */ n(Xe, { title: r("TITLE"), icon: /* @__PURE__ */ n($r, {}), children: /* @__PURE__ */ n(el, {}) }) : /* @__PURE__ */ n(we, {});
}, hn = [
  { value: Ve.SYSTEM, viewValue: "System" },
  { value: Ve.DARK, viewValue: "Dark" },
  { value: Ve.LIGHT, viewValue: "Light" }
], nl = ({
  options: e,
  selectedTheme: t,
  onOptionClick: r
}) => e.map((i) => {
  const o = i.value, a = o === t;
  return /* @__PURE__ */ m(
    De,
    {
      selected: a,
      onClick: () => r(o),
      sx: { display: "flex", justifyContent: "space-between", alignItems: "center" },
      children: [
        /* @__PURE__ */ n(A, { variant: "subtitle2", children: i.viewValue }),
        a && /* @__PURE__ */ n(mt, {})
      ]
    },
    o
  );
}), rl = () => {
  const { userPreferences: e, isUserPreferencesLoading: t, updateUserPreferences: r } = Ue(), { t: i } = R({
    keyPrefix: "USER_SETTINGS.PREFERENCES.DISPLAY.THEME"
  }), [o, a] = E(!1), s = () => {
    a(!0);
  }, l = () => {
    a(!1);
  }, [c, d] = E(!1), p = t || c, h = async (f) => {
    a(!1), d(!0), await r({ theme: f }), d(!1);
  }, u = hn.find(
    (f) => f.value === (e == null ? void 0 : e.theme)
  );
  return /* @__PURE__ */ n(Ke, { title: i("TITLE"), description: i("DESCRIPTION"), children: /* @__PURE__ */ n(
    Ot,
    {
      "data-element-id": "theme-preferences-switcher",
      isReadOnly: !1,
      isEmpty: !1,
      isLoading: p,
      onClick: s,
      isMenuOpen: o,
      onMenuClose: l,
      label: u == null ? void 0 : u.viewValue,
      "aria-label": `Selected theme: ${u == null ? void 0 : u.viewValue}`,
      menuContent: nl({
        options: hn,
        selectedTheme: e == null ? void 0 : e.theme,
        onOptionClick: h
      })
    }
  ) });
}, il = ({
  options: e,
  selectedLanguage: t,
  onOptionClick: r
}) => e.map((i) => {
  const o = i.value === t;
  return /* @__PURE__ */ m(
    De,
    {
      selected: o,
      onClick: () => r(i.value),
      sx: { display: "flex", justifyContent: "space-between", alignItems: "center" },
      children: [
        /* @__PURE__ */ n(A, { variant: "subtitle2", children: i.viewValue }),
        o && /* @__PURE__ */ n(mt, {})
      ]
    },
    i.value
  );
}), ol = () => {
  const { userPreferences: e, updateUserPreferences: t, isUserPreferencesLoading: r } = Ue(), { commonProfileVisibility: i } = de(), o = i == null ? void 0 : i.preferences.display.language.whitelist, { t: a } = R({
    keyPrefix: "USER_SETTINGS.PREFERENCES.DISPLAY.LANGUAGE"
  });
  let s = [
    { value: "en", viewValue: "English (US)" },
    { value: "es", viewValue: "Spanish" },
    { value: "fr", viewValue: "French" }
  ];
  o && (s = s.filter((x) => o.includes(x.value)));
  const [l, c] = E(!1), d = () => c(!0), p = () => c(!1), [h, u] = E(!1), f = r || h, g = async (x) => {
    u(!0), c(!1), await t({ language: x }), u(!1);
  }, C = s.find(
    (x) => x.value === (e == null ? void 0 : e.language)
  );
  return /* @__PURE__ */ n(
    Ke,
    {
      title: a("TITLE"),
      description: a("DESCRIPTION"),
      infoIcon: /* @__PURE__ */ n(Ut, { title: a("INFO"), children: /* @__PURE__ */ n(
        ie,
        {
          size: "small",
          "aria-label": `information icon: ${a("INFO")}`,
          sx: {
            borderRadius: "8px"
          },
          children: /* @__PURE__ */ n(Bt, { fontSize: "small", color: "action" })
        }
      ) }),
      children: /* @__PURE__ */ n(
        Ot,
        {
          "data-element-id": "language-preferences-switcher",
          isReadOnly: !1,
          isEmpty: !1,
          isLoading: f,
          label: C == null ? void 0 : C.viewValue,
          isMenuOpen: l,
          onMenuClose: p,
          onClick: d,
          "aria-label": `Selected language: ${C == null ? void 0 : C.viewValue}`,
          menuContent: il({
            options: s,
            selectedLanguage: e == null ? void 0 : e.language,
            onOptionClick: g
          })
        }
      )
    }
  );
}, al = ({
  label: e,
  prompt: t,
  currentValue: r,
  disabled: i = !1,
  isLoading: o = !1,
  rules: a,
  onSave: s
}) => {
  const {
    control: l,
    handleSubmit: c,
    setValue: d,
    getValues: p,
    formState: { errors: h }
  } = pt({
    mode: "onChange"
  }), { t: u } = R(), [f, g] = E(!1), C = Te(), x = async (v) => {
    const T = v.textValue ? v.textValue : void 0;
    await s(T), g(!1);
  }, O = () => {
    r && d("textValue", r), g(!1);
  };
  return S(() => {
    if (!r) return;
    p().textValue === void 0 && d("textValue", r);
  }, [p, d, r]), /* @__PURE__ */ m(we, { children: [
    /* @__PURE__ */ m(
      N,
      {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        sx: {
          border: "1px solid",
          borderRadius: w.BorderRadius.value,
          px: "18px",
          py: "2px",
          height: "40px",
          width: "100%",
          maxWidth: "320px"
        },
        children: [
          /* @__PURE__ */ n(
            A,
            {
              variant: "body1",
              sx: {
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis"
              },
              children: r
            }
          ),
          /* @__PURE__ */ n(
            it,
            {
              "data-element-id": "change-button",
              onClick: () => g(!0),
              variant: "text",
              type: "button",
              disabled: i,
              sx: {
                textTransform: "none",
                fontSize: "body2.fontSize",
                minWidth: "auto",
                ml: "2px",
                p: "0px",
                height: "auto",
                color: C.palette.text.primary
              },
              children: u("COMMON.BUTTONS.CHANGE")
            }
          )
        ]
      }
    ),
    /* @__PURE__ */ n(Tt, { open: f, onClose: O, children: /* @__PURE__ */ m("form", { onSubmit: c(x), children: [
      /* @__PURE__ */ n(
        He,
        {
          sx: {
            fontWeight: "600",
            fontSize: "20px",
            [C.breakpoints.down(w.Breakpoints.sm)]: {
              pl: "16px"
            }
          },
          children: t
        }
      ),
      /* @__PURE__ */ n(
        at,
        {
          sx: {
            [C.breakpoints.up(w.Breakpoints.sm)]: {
              width: "460px"
            },
            [C.breakpoints.down(w.Breakpoints.sm)]: {
              width: "100%",
              padding: "16px"
            }
          },
          children: /* @__PURE__ */ m(b, { gap: 2, padding: "8px 0px", children: [
            /* @__PURE__ */ n(
              se,
              {
                "data-element-id": e + "-input",
                control: l,
                name: "textValue",
                errors: h,
                disabled: o,
                label: e,
                rules: a
              }
            ),
            /* @__PURE__ */ n(
              it,
              {
                "data-element-id": "save-input-button",
                loading: o,
                disabled: o,
                type: "submit",
                variant: "contained",
                variantType: "save",
                children: u("COMMON.BUTTONS.SAVE")
              }
            )
          ] })
        }
      )
    ] }) })
  ] });
}, sl = () => {
  const { t: e } = R({
    keyPrefix: "USER_SETTINGS.PREFERENCES.DISPLAY.DISPLAY_NAME"
  }), { setSnackOptions: t } = Ee(), {
    primaryUserProfile: r,
    isGetPrimaryUserProfileLoading: i,
    getPrimaryUserProfileError: o,
    updateDisplayNameError: a,
    isDisplayNameUpdating: s,
    isUserFederated: l,
    updateDisplayName: c
  } = ae(), d = i || s;
  S(
    function() {
      !o && !a || t({
        open: !0,
        color: "error",
        message: (o == null ? void 0 : o.message) || (a == null ? void 0 : a.message)
      });
    },
    [o, a]
  );
  const p = async (u) => {
    d || await c(u);
  }, h = l ? /* @__PURE__ */ n(Ut, { title: e("FEDERATION_MESSAGE"), children: /* @__PURE__ */ n(
    ie,
    {
      size: "small",
      "aria-label": `information icon: ${e("FEDERATION_MESSAGE")}`,
      sx: {
        borderRadius: "8px"
      },
      children: /* @__PURE__ */ n(Bt, { fontSize: "small", color: "action" })
    }
  ) }) : void 0;
  return /* @__PURE__ */ n(
    Ke,
    {
      infoIcon: h,
      title: e("TITLE"),
      description: e("DESCRIPTION"),
      children: /* @__PURE__ */ n(
        al,
        {
          label: e("TITLE"),
          disabled: l,
          isLoading: d,
          prompt: e("PROMPT"),
          currentValue: r == null ? void 0 : r.displayName,
          rules: {
            maxLength: {
              value: 2048,
              message: e("VALIDATION")
            },
            minLength: {
              value: 1,
              message: e("VALIDATION")
            }
          },
          onSave: p
        }
      )
    }
  );
}, ll = () => {
  const { _TEMPORARY_globalProfileOktaSdkEnabled: e } = V(), { commonProfileVisibility: t } = de(), r = ((t == null ? void 0 : t.preferences.display.displayName.enabled) ?? !0) && !e, i = (t == null ? void 0 : t.preferences.display.theme.enabled) ?? !0, o = (t == null ? void 0 : t.preferences.display.language.enabled) ?? !0, { t: a } = R({
    keyPrefix: "USER_SETTINGS.PREFERENCES.DISPLAY"
  });
  return !r && !i && !o ? /* @__PURE__ */ n(we, {}) : /* @__PURE__ */ m(Xe, { title: a("TITLE"), icon: /* @__PURE__ */ n(Zr, {}), children: [
    r && /* @__PURE__ */ n(sl, {}),
    i && /* @__PURE__ */ n(rl, {}),
    o && /* @__PURE__ */ n(ol, {})
  ] });
}, cl = () => {
  const { isLoading: e, isContextFound: t } = de();
  return t && e ? /* @__PURE__ */ m(b, { gap: 2, children: [
    /* @__PURE__ */ n(Rt, { height: 160, variant: "rounded" }),
    /* @__PURE__ */ n(Rt, { height: 160, variant: "rounded" }),
    /* @__PURE__ */ n(Rt, { height: 160, variant: "rounded" })
  ] }) : /* @__PURE__ */ m(xt, { children: [
    /* @__PURE__ */ n(tl, {}),
    /* @__PURE__ */ n(Xs, {}),
    /* @__PURE__ */ n(ll, {})
  ] });
}, dl = (e) => {
  const t = e.preferences;
  return t.dateTime.region.enabled || t.defaults.organization.enabled || t.display.displayName.enabled || t.display.language.enabled || t.display.theme.enabled;
}, ul = ({
  isOpen: e,
  onClose: t
}) => {
  const { t: r } = R({
    keyPrefix: "USER_SETTINGS"
  }), i = D(null), o = Z(), [a, s] = E(0), [l, c] = E(a), [d, p] = E(!1), h = D(null), { commonProfileVisibility: u, isLoading: f } = de(), g = z(() => a > l ? "left" : "right", [a, l]);
  S(() => {
    c(a);
  }, [a]), S(
    function() {
      e || (s(0), p(!1), i.current && (i.current.scrollTop = 0));
    },
    [e]
  ), S(
    function() {
      e && requestAnimationFrame(() => {
        var L;
        (L = h.current) == null || L.focus();
      });
    },
    [e]
  ), S(() => {
    const I = () => {
      i.current && p(i.current.scrollTop > 0);
    };
    return i.current && i.current.addEventListener("scroll", I), () => {
      i.current && i.current.removeEventListener("scroll", I);
    };
  }, [e]);
  const C = z(() => {
    i.current && (i.current.scrollTop = d ? 10 : 0);
  }, [i, d]), { isInternalUser: x } = V();
  let O = [
    {
      title: r("PROFILE.TITLE"),
      description: r("PROFILE.DESCRIPTION"),
      component: /* @__PURE__ */ n(Os, {}),
      icon: /* @__PURE__ */ n(li, {})
    }
  ];
  !f && (!u || dl(u)) && (O = O.concat({
    title: r("PREFERENCES.TITLE"),
    description: r("PREFERENCES.DESCRIPTION"),
    component: /* @__PURE__ */ n(cl, {}),
    icon: /* @__PURE__ */ n(di, {})
  })), x || (O = O.concat({
    title: r("SECURITY.TITLE"),
    description: r("SECURITY.DESCRIPTION"),
    component: /* @__PURE__ */ n(Ls, {}),
    icon: /* @__PURE__ */ n(ci, {})
  }));
  const v = (I, L) => {
    s(L), C();
  }, T = Zs();
  return /* @__PURE__ */ n(Fr, { onClose: t, open: e, keepMounted: !0, "aria-labelledby": "user-settings-title", children: /* @__PURE__ */ m(
    N,
    {
      sx: {
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        borderRadius: "16px",
        backgroundColor: (I) => I.palette.background.paper,
        overflowY: "hidden",
        ...T ? {
          width: "calc(100vw - 64px)",
          height: "calc(100vh - 64px)"
        } : {
          width: "100%",
          height: "100%",
          borderRadius: 0
        }
      },
      children: [
        /* @__PURE__ */ n(
          "span",
          {
            id: "user-settings-title",
            ref: h,
            tabIndex: 0,
            "aria-label": "Account Settings"
          }
        ),
        /* @__PURE__ */ n(
          ie,
          {
            onClick: t,
            "data-element-id": "close-user-settings",
            "aria-label": "close user settings",
            title: r("CLOSE_BUTTON_TITLE"),
            sx: {
              position: "absolute",
              top: "12px",
              right: "16px"
            },
            children: /* @__PURE__ */ n(En, {})
          }
        ),
        /* @__PURE__ */ m(
          "div",
          {
            style: {
              display: "flex",
              flexDirection: T ? "row" : "column",
              height: "100%"
            },
            children: [
              T ? /* @__PURE__ */ n(
                $s,
                {
                  tabs: O,
                  activeTabIndex: a,
                  handleTabChange: v
                }
              ) : /* @__PURE__ */ n(
                zs,
                {
                  tabs: O,
                  activeTabIndex: a,
                  handleTabChange: v,
                  collapsed: d
                }
              ),
              /* @__PURE__ */ n(
                N,
                {
                  sx: {
                    flex: 1,
                    overflowY: "auto",
                    height: "auto",
                    scrollbarGutter: "stable"
                  },
                  ref: i,
                  children: /* @__PURE__ */ n(Ka, { children: O.map((I, L) => /* @__PURE__ */ n(
                    Ja,
                    {
                      value: a,
                      index: L,
                      tabPadding: w.UserSettingsPadding[o ? "mobileValue" : "value"],
                      a11yTabPrefix: "account-tab",
                      a11yTabPanelPrefix: "account-tabpanel",
                      children: /* @__PURE__ */ n(
                        dt,
                        {
                          in: a === L,
                          direction: g(),
                          appear: l !== L && !T,
                          timeout: 300,
                          children: /* @__PURE__ */ n(
                            Dt,
                            {
                              in: a === L,
                              appear: l !== L && T,
                              timeout: 500,
                              children: /* @__PURE__ */ m(N, { children: [
                                /* @__PURE__ */ m(
                                  b,
                                  {
                                    mb: "32px",
                                    mt: T ? "32px" : "0px",
                                    children: [
                                      /* @__PURE__ */ n(A, { fontSize: "25px", fontWeight: "600", children: I.title }),
                                      /* @__PURE__ */ n(
                                        A,
                                        {
                                          fontSize: "16px",
                                          fontWeight: "400",
                                          color: "text.secondary",
                                          children: I.description
                                        }
                                      )
                                    ]
                                  }
                                ),
                                I.component
                              ] })
                            }
                          )
                        }
                      )
                    },
                    I.title
                  )) })
                }
              )
            ]
          }
        )
      ]
    }
  ) });
}, Ac = ({
  inputOptions: e = []
}) => {
  const [t, r] = E(!1), [i, o] = E(!1), { t: a } = R({
    keyPrefix: "USER_PROFILE"
  }), s = Z(), l = D(null), d = [
    ...[
      {
        icon: /* @__PURE__ */ n(xn, { color: "inherit", fontSize: "medium" }),
        label: a("ACCOUNT"),
        onClick: () => {
          o(!0);
        }
      }
    ],
    ...e
  ].filter((f) => !f.hidden), p = () => {
    r(!0);
  }, h = () => {
    r(!1);
  }, u = () => {
    o(!1);
  };
  return /* @__PURE__ */ m(gt, { config: Pe(), children: [
    /* @__PURE__ */ n(
      le,
      {
        onClick: p,
        ref: l,
        type: "button",
        sx: { borderRadius: "50%", padding: "8px", minWidth: "unset" },
        "data-element-id": "user-menu-nav-button",
        "aria-label": "User Profile",
        children: /* @__PURE__ */ n(en, {})
      }
    ),
    s ? /* @__PURE__ */ n(
      Za,
      {
        menuOpen: t,
        options: d,
        onMenuOpen: p,
        onMenuClose: h
      }
    ) : /* @__PURE__ */ n(
      qa,
      {
        options: d,
        anchorRef: l,
        menuOpen: t,
        onMenuClose: h
      }
    ),
    /* @__PURE__ */ n(
      ul,
      {
        onClose: u,
        isOpen: i
      }
    )
  ] });
}, pl = () => _.Services.FrontDoor, hl = (e) => ce(`${pl()}/common-profile-visibility/${e}`).catch(G), ml = (e) => {
  const { isAuthenticated: t } = V(), { data: r, isLoading: i, error: o } = ve(
    t && e ? io(e) : null,
    (a) => hl(a[1])
  );
  return { data: r, isLoading: i, error: o };
}, wc = ({ children: e }) => {
  const { application: t } = ye(), {
    data: r,
    error: i,
    isLoading: o
  } = ml(t == null ? void 0 : t.name), { isLoadingOrg: a } = B(), { isLoading: s } = ye(), [l, c] = E(!1);
  return S(
    function() {
      i && i.status === 404 && console.warn(i.message);
    },
    [i]
  ), S(
    function() {
      c(o || a || s);
    },
    [o, a, s]
  ), /* @__PURE__ */ n(
    mr.Provider,
    {
      value: {
        commonProfileVisibility: r,
        isLoading: l,
        isContextFound: !0,
        error: i
      },
      children: e
    }
  );
};
export {
  Tc as ApiVersion,
  Nc as ApplicationSwitcher,
  bc as ApplicationsContextProvider,
  wc as CommonProfileVisibilityContextProvider,
  Rc as OrganizationSwitcher,
  Ge as QueryParamKeys,
  yc as RccContextProvider,
  Yt as RccEventKeys,
  Mi as RccEvents,
  ho as UserFederationType,
  Be as UserPreferencesRegion,
  Ve as UserPreferencesTheme,
  Ac as UserProfileSettings,
  mo as UserStatus,
  Qo as convertAppToShared,
  Co as getFormattedAddress,
  fo as isFederated,
  go as isManagedUserProfile,
  Vn as useApplicationsContext,
  B as useOrganizationContext,
  Oc as useOrganizationsCacheContext,
  V as useRccContext,
  vo as useUserPreferencesContext,
  xo as useUserProfileContext,
  Ic as useUsersContext
};
